webpackJsonp([43],{

/***/ 1004:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(463);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a6550e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(1028);
function injectStyle (ssrContext) {
  __webpack_require__(1005)
}
var normalizeComponent = __webpack_require__(951)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a6550e5_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 1005:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1028:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view',{staticStyle:{"flex-grow":"1","height":"100%"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 1067:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1068:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1069:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__auth_role__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__store_js__ = __webpack_require__(613);



var _this = this;






__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
    routes: [{
        path: '/',
        name: 'login',
        component: function component() {
            return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, 1507));
        }
    }, {
        path: '/policy',
        name: 'policy',
        component: function component() {
            return __webpack_require__.e/* import() */(38).then(__webpack_require__.bind(null, 1508));
        }
    }, {
        path: '/mobile/instruction',
        name: 'instruction',
        component: function component() {
            return __webpack_require__.e/* import() */(37).then(__webpack_require__.bind(null, 1509));
        }
    }, {
        path: '/no-nb/mobile/instruction',
        name: 'instruction',
        component: function component() {
            return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, 1510));
        }
    }, {
        path: '/account/delete',
        name: 'deleteAccount',
        component: function component() {
            return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, 1511));
        }
    }, {
        path: '/main',
        name: 'main',
        component: function component() {
            return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, 1512));
        },
        meta: {
            requiresAuth: true,
            authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User]
        },
        children: [{
            path: '/alarms',
            name: 'alarms',
            component: function component() {
                return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, 1513));
            },
            props: true,
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service] }
        }, {
            path: '/visits',
            name: 'visits',
            component: function component() {
                return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, 1514));
            },
            meta: { autorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service] },
            children: [{
                path: '/visits/list',
                name: 'visitsList',
                component: function component() {
                    return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 986));
                },
                default: true
            }, {
                path: '/visits/problems',
                name: 'visitsProblems',
                component: function component() {
                    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 457));
                },
                props: true
            }, {
                path: '/visits/solutions/:visitId',
                name: 'visitsSolutionsForVisit',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            }, {
                path: '/visits/solutions/:problemId',
                name: 'solutionsForProblem',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            }, {
                path: '/visits/solutions/:visitId',
                name: 'visitsSolutionsForVisit',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            }, {
                path: '/visits/solutions',
                name: 'visitsSolutions',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            }]
        }, {
            path: '/systems',
            name: 'systems',
            component: function component() {
                return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1515));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/systems/map',
            name: 'map',
            component: function component() {
                return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, 1516));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/systems/weights',
            name: 'weights',
            component: function component() {
                return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, 1517));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/systems/dashboard',
            name: 'dashboard',
            component: function component() {
                return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, 1518));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/users',
            name: 'users',
            component: function component() {
                return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 1519));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: '/users/contacts',
            name: 'contacts',
            component: function component() {
                return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, 1520));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service] }
        }, {
            path: '/users/invitations',
            name: 'invitations',
            component: function component() {
                return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, 1521));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: '/faq',
            name: 'faq',
            component: function component() {
                return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, 1522));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/devices/:systemName/:systemId',
            name: 'devices',
            props: true,
            component: function component() {
                return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, 1523));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
        }, {
            path: '/contactForm/:farmName/:farmId',
            name: 'contactForm',
            props: true,
            component: function component() {
                return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, 1524));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service] }
        }, {
            path: '/systemState/:systemName/:systemId',
            name: 'systemState',
            props: true,
            component: function component() {
                return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, 1525));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] },
            children: [{
                default: true,
                path: '/systemState/:systemName/:systemId/general',
                name: 'settingsGeneral',
                component: function component() {
                    return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, 1526));
                },
                props: true,
                meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Service, __WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].User] }
            }, {
                path: '/systemState/:systemName/:systemId/devices',
                name: 'settingsDevices',
                component: function component() {
                    return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 1527));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/alarms',
                name: 'settingsAlarms',
                component: function component() {
                    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 1528));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/roughage',
                name: 'settingsRoughage',
                component: function component() {
                    return __webpack_require__.e/* import() */(41).then(__webpack_require__.bind(null, 1505));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/sorting',
                name: 'settingsSorting',
                component: function component() {
                    return __webpack_require__.e/* import() */(40).then(__webpack_require__.bind(null, 1504));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/statistics',
                name: 'settingsStatistics',
                component: function component() {
                    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, 1529));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/visits',
                name: 'systemVisits',
                component: function component() {
                    return __webpack_require__.e/* import() */(2/* duplicate */).then(__webpack_require__.bind(null, 986));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/problems',
                name: 'settingsProblems',
                component: function component() {
                    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 457));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/problems/:visitId',
                name: 'settingsProblemsVisit',
                component: function component() {
                    return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 457));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/solutions/:problemId',
                name: 'settingsProblemSolutionsHistory',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/solutions/:visitId',
                name: 'systemSolutionsForVisit',
                component: function component() {
                    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 190));
                },
                props: true
            },
            // {
            //   path: '/systemState/:systemName/:systemId/tickets',
            //   name: 'settingsTickets',
            //   component: Tickets,
            //   props: true,
            // },
            {
                path: '/systemState/:systemName/:systemId/generalAlarms',
                name: 'systemsGeneralAlarms',
                component: function component() {
                    return __webpack_require__.e/* import() */(39).then(__webpack_require__.bind(null, 1530));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/todo',
                name: 'systemsTasks',
                component: function component() {
                    return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, 1531));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/settings',
                name: 'systemSettings',
                component: function component() {
                    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, 1532));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/tickets',
                name: 'systemTickets',
                component: function component() {
                    return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, 1533));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/animals',
                name: 'systemAnimals',
                component: function component() {
                    return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, 1534));
                },
                props: true
            }, {
                path: '/systemState/:systemName/:systemId/notifications',
                name: 'systemNotifications',
                component: function component() {
                    return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, 1535));
                },
                props: true
            }]
        }, {
            path: 'cloud',
            name: 'cloud',
            component: function component() {
                return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, 1536));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'softwareMain',
            name: 'softwareMain',
            component: function component() {
                return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, 1537));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'software',
            name: 'software',
            component: function component() {
                return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, 1538));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'softwareManagement',
            name: 'softwareManagement',
            component: function component() {
                return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, 1539));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'softwareRequirements',
            name: 'softwareRequirements',
            component: function component() {
                return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, 1540));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'backups',
            name: 'backups',
            component: function component() {
                return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, 1541));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'scheduledReports',
            name: 'scheduledReports',
            component: function component() {
                return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, 1542));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }, {
            path: 'apiUsage',
            name: 'apiUsage',
            component: function component() {
                return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, 1543));
            },
            meta: { authorize: [__WEBPACK_IMPORTED_MODULE_4__auth_role__["a" /* Role */].Admin] }
        }]
    }]
});

router.beforeEach(function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(to, from, next) {
        var authorize;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        authorize = to.meta.authorize;

                        if (!(to.params.systemNameFilter != null)) {
                            _context.next = 6;
                            break;
                        }

                        _context.next = 4;
                        return __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* default */].dispatch('change_filter', to.params.systemNameFilter);

                    case 4:
                        _context.next = 8;
                        break;

                    case 6:
                        _context.next = 8;
                        return __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* default */].dispatch('change_filter', '');

                    case 8:
                        if (!authorize) {
                            _context.next = 13;
                            break;
                        }

                        if (__WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* default */].getters.isLoggedIn) {
                            _context.next = 11;
                            break;
                        }

                        return _context.abrupt('return', next({ path: '/' }));

                    case 11:
                        if (!(authorize.length && !authorize.some(function (r) {
                            return __WEBPACK_IMPORTED_MODULE_5__store_js__["a" /* default */].getters.user.roles.indexOf(r) >= 0;
                        }))) {
                            _context.next = 13;
                            break;
                        }

                        return _context.abrupt('return', next({ path: '/' }));

                    case 13:

                        next();

                    case 14:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, _this);
    }));

    return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
    };
}());

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),

/***/ 1485:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 815,
	"./af.js": 815,
	"./ar": 816,
	"./ar-dz": 817,
	"./ar-dz.js": 817,
	"./ar-kw": 818,
	"./ar-kw.js": 818,
	"./ar-ly": 819,
	"./ar-ly.js": 819,
	"./ar-ma": 820,
	"./ar-ma.js": 820,
	"./ar-sa": 821,
	"./ar-sa.js": 821,
	"./ar-tn": 822,
	"./ar-tn.js": 822,
	"./ar.js": 816,
	"./az": 823,
	"./az.js": 823,
	"./be": 824,
	"./be.js": 824,
	"./bg": 825,
	"./bg.js": 825,
	"./bm": 826,
	"./bm.js": 826,
	"./bn": 827,
	"./bn-bd": 828,
	"./bn-bd.js": 828,
	"./bn.js": 827,
	"./bo": 829,
	"./bo.js": 829,
	"./br": 830,
	"./br.js": 830,
	"./bs": 831,
	"./bs.js": 831,
	"./ca": 832,
	"./ca.js": 832,
	"./cs": 833,
	"./cs.js": 833,
	"./cv": 834,
	"./cv.js": 834,
	"./cy": 835,
	"./cy.js": 835,
	"./da": 836,
	"./da.js": 836,
	"./de": 837,
	"./de-at": 838,
	"./de-at.js": 838,
	"./de-ch": 839,
	"./de-ch.js": 839,
	"./de.js": 837,
	"./dv": 840,
	"./dv.js": 840,
	"./el": 841,
	"./el.js": 841,
	"./en-au": 842,
	"./en-au.js": 842,
	"./en-ca": 843,
	"./en-ca.js": 843,
	"./en-gb": 844,
	"./en-gb.js": 844,
	"./en-ie": 845,
	"./en-ie.js": 845,
	"./en-il": 846,
	"./en-il.js": 846,
	"./en-in": 847,
	"./en-in.js": 847,
	"./en-nz": 848,
	"./en-nz.js": 848,
	"./en-sg": 849,
	"./en-sg.js": 849,
	"./eo": 850,
	"./eo.js": 850,
	"./es": 851,
	"./es-do": 852,
	"./es-do.js": 852,
	"./es-mx": 853,
	"./es-mx.js": 853,
	"./es-us": 854,
	"./es-us.js": 854,
	"./es.js": 851,
	"./et": 855,
	"./et.js": 855,
	"./eu": 856,
	"./eu.js": 856,
	"./fa": 857,
	"./fa.js": 857,
	"./fi": 858,
	"./fi.js": 858,
	"./fil": 859,
	"./fil.js": 859,
	"./fo": 860,
	"./fo.js": 860,
	"./fr": 861,
	"./fr-ca": 862,
	"./fr-ca.js": 862,
	"./fr-ch": 863,
	"./fr-ch.js": 863,
	"./fr.js": 861,
	"./fy": 864,
	"./fy.js": 864,
	"./ga": 865,
	"./ga.js": 865,
	"./gd": 866,
	"./gd.js": 866,
	"./gl": 867,
	"./gl.js": 867,
	"./gom-deva": 868,
	"./gom-deva.js": 868,
	"./gom-latn": 869,
	"./gom-latn.js": 869,
	"./gu": 870,
	"./gu.js": 870,
	"./he": 871,
	"./he.js": 871,
	"./hi": 872,
	"./hi.js": 872,
	"./hr": 873,
	"./hr.js": 873,
	"./hu": 874,
	"./hu.js": 874,
	"./hy-am": 875,
	"./hy-am.js": 875,
	"./id": 876,
	"./id.js": 876,
	"./is": 877,
	"./is.js": 877,
	"./it": 878,
	"./it-ch": 879,
	"./it-ch.js": 879,
	"./it.js": 878,
	"./ja": 880,
	"./ja.js": 880,
	"./jv": 881,
	"./jv.js": 881,
	"./ka": 882,
	"./ka.js": 882,
	"./kk": 883,
	"./kk.js": 883,
	"./km": 884,
	"./km.js": 884,
	"./kn": 885,
	"./kn.js": 885,
	"./ko": 886,
	"./ko.js": 886,
	"./ku": 887,
	"./ku.js": 887,
	"./ky": 888,
	"./ky.js": 888,
	"./lb": 889,
	"./lb.js": 889,
	"./lo": 890,
	"./lo.js": 890,
	"./lt": 891,
	"./lt.js": 891,
	"./lv": 892,
	"./lv.js": 892,
	"./me": 893,
	"./me.js": 893,
	"./mi": 894,
	"./mi.js": 894,
	"./mk": 895,
	"./mk.js": 895,
	"./ml": 896,
	"./ml.js": 896,
	"./mn": 897,
	"./mn.js": 897,
	"./mr": 898,
	"./mr.js": 898,
	"./ms": 899,
	"./ms-my": 900,
	"./ms-my.js": 900,
	"./ms.js": 899,
	"./mt": 901,
	"./mt.js": 901,
	"./my": 902,
	"./my.js": 902,
	"./nb": 903,
	"./nb.js": 903,
	"./ne": 904,
	"./ne.js": 904,
	"./nl": 905,
	"./nl-be": 906,
	"./nl-be.js": 906,
	"./nl.js": 905,
	"./nn": 907,
	"./nn.js": 907,
	"./oc-lnc": 908,
	"./oc-lnc.js": 908,
	"./pa-in": 909,
	"./pa-in.js": 909,
	"./pl": 910,
	"./pl.js": 910,
	"./pt": 911,
	"./pt-br": 912,
	"./pt-br.js": 912,
	"./pt.js": 911,
	"./ro": 913,
	"./ro.js": 913,
	"./ru": 914,
	"./ru.js": 914,
	"./sd": 915,
	"./sd.js": 915,
	"./se": 916,
	"./se.js": 916,
	"./si": 917,
	"./si.js": 917,
	"./sk": 918,
	"./sk.js": 918,
	"./sl": 919,
	"./sl.js": 919,
	"./sq": 920,
	"./sq.js": 920,
	"./sr": 921,
	"./sr-cyrl": 922,
	"./sr-cyrl.js": 922,
	"./sr.js": 921,
	"./ss": 923,
	"./ss.js": 923,
	"./sv": 924,
	"./sv.js": 924,
	"./sw": 925,
	"./sw.js": 925,
	"./ta": 926,
	"./ta.js": 926,
	"./te": 927,
	"./te.js": 927,
	"./tet": 928,
	"./tet.js": 928,
	"./tg": 929,
	"./tg.js": 929,
	"./th": 930,
	"./th.js": 930,
	"./tk": 931,
	"./tk.js": 931,
	"./tl-ph": 932,
	"./tl-ph.js": 932,
	"./tlh": 933,
	"./tlh.js": 933,
	"./tr": 934,
	"./tr.js": 934,
	"./tzl": 935,
	"./tzl.js": 935,
	"./tzm": 936,
	"./tzm-latn": 937,
	"./tzm-latn.js": 937,
	"./tzm.js": 936,
	"./ug-cn": 938,
	"./ug-cn.js": 938,
	"./uk": 939,
	"./uk.js": 939,
	"./ur": 940,
	"./ur.js": 940,
	"./uz": 941,
	"./uz-latn": 942,
	"./uz-latn.js": 942,
	"./uz.js": 941,
	"./vi": 943,
	"./vi.js": 943,
	"./x-pseudo": 944,
	"./x-pseudo.js": 944,
	"./yo": 945,
	"./yo.js": 945,
	"./zh-cn": 946,
	"./zh-cn.js": 946,
	"./zh-hk": 947,
	"./zh-hk.js": 947,
	"./zh-mo": 948,
	"./zh-mo.js": 948,
	"./zh-tw": 949,
	"./zh-tw.js": 949
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1485;

/***/ }),

/***/ 1486:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_i18n__ = __webpack_require__(1487);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]);

function loadLocaleMessages() {
  var locales = __webpack_require__(1488);
  var messages = {};
  locales.keys().forEach(function (key) {
    var matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      var locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_i18n__["a" /* default */]({
  locale: 'English',
  fallbackLocale: 'English',
  messages: loadLocaleMessages()
}));

/***/ }),

/***/ 1488:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./English.json": 1489,
	"./Norwegian.json": 1490,
	"./Polish.json": 1491,
	"./Translation.json": 1492
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1488;

/***/ }),

/***/ 1489:
/***/ (function(module, exports) {

module.exports = {"ej2LocaleCulture":"en-US","NAME":"NAME","Anonymous":"Anonymous","MAP":"MAP","DASHBOARD":"DASHBOARD","SYSTEMS":"SYSTEMS","ALARMS":"ALARMS","SERVICE":"SERVICE","USERS":"USERS","CONTACTS":"CONTACTS","FAQ":"FAQ","NoRole":"No Role","Admin":"Admin","Service":"Service","User":"User","Profile":"Profile","Logout":"Logout","Theme":"Theme","ThemeLight":"Light","ThemeDark":"Dark","ThemeSystem":"System","Language":"Language","ALL_SYSTEMS":"ALL SYSTEMS","ACTIVE_MONITORING":"ACTIVE MONITORING","WITHOUT_MONITORING":"WITHOUT MONITORING","WORKING_FINE":"WORKING FINE","WITH_ISSUES":"WITH ISSUES","No_system_selected":"No system selected","SystemStatus":"System Status","FarmName":"Farm Name","Group":"Group","FarmAddress":"Farm Address","Name":"Name","Responsibility":"Responsibility","PhoneNumber":"Phone Number","Email":"Email","Contact":"Contact","ContactPerson":"Contact Person","FarmOwner":"Farm Owner","BaseInfo":"Base info","GoToSystem":"Go To System","General":"General","BlackBox":"BlackBox","Device":"Device","Rapid24":"Rapid24","Rapid24h":"Rapid24h","Photocells":"Photocells","Pressure":"Pressure","Database":"Database","System Down":"System Down","System down":"System down","Error":"Error","Warning":"Warning","Working Fine":"Working Fine","SearchSystem":"Search system","NoSystemsToShow":"No systems match the criteria","LastUpdate":"Last Update","CPUTemperature":"Temperature","FreeSpace":"Free Space","Operational":"Operational","Free space alarm!":"Free space alarm!","days":"days","ago":"ago","No Monitoring":"No Monitoring","Edit":"Edit","Delete":"Delete","INVITATIONS":"INVITATIONS","NUMBER":"NUMBER","DESCRIPTION":"DESCRIPTION","SEND_TO_MOBILE":"SEND TO MOBILE","SEND_PUSH":"PUSH NOTIFICATION","PushRequiresSendToMobile":"Enable \"Send to mobile\" first - the notification opens the alarm list in the app.","AlarmTypeUpdateFailed":"Could not save the change","PRIORITY":"PRIORITY","HIGH":"HIGH","MID":"MID","LOW":"LOW","totalItemsInfo":"({0} items)","CancelButton":"CANCEL","pagerDropDown":"Items per page","currentPageInfo":"{0} of {1} pages","OKButton":"OK","ChooseColumns":"Choose Columns","SelectAll":"Select All","Columnchooser":"Columns","ClearFilter":"Clear Filter","NoResult":"No Matches Found","EnterValue":"Enter the value","ChooseDate":"Choose a Date","GreaterThan":"Greater Than","GreaterThanOrEqual":"Greater Than Or Equal","LessThan":"Less Than","LessThanOrEqual":"Less Than Or Equal","NotEqual":"Not Equal","Equal":"Equal","Contains":"Contains","StartsWith":"Starts With","EndsWith":"Ends With","ClearButton":"Clear","FilterButton":"Filter","Csvexport":"CSV Export","Excelexport":"Excel Export","Pdfexport":"PDF Export","search":"Search","items":"Items","item":"Item","emptyRecord":"No records to display","Country":"Country","SystemStatusInfo":"System Status Info","Status":"Status","HighLevelAlarm":"High Level Alarm","MidLevelAlarm":"Mid Level Alarm","LowLevelAlarm":"Low Level Alarm","Blackbox":"Blackbox","Weight alarm":"Weight alarm","Max manger weight alarm":"Max manger weight alarm","Loadcell data alarm":"Loadcell data alarm","Photocell not covered in the last 24h":"Photocell not covered in the last 24h","Manger long low weight alarm":"Manger long low weight alarm","Animal weight drastically changed.":"Animal weight drastically changed","Loading in down state alarm":"Loading in down state alarm","Floating cell alarm":"Floating cell alarm","Abnormal gate state alarm":"Abnormal gate state alarm","Wagon alarm":"Wagon alarm","Photocell alarm":"Photocell alarm","Missing log, no log between two visit alarm":"Missing log, no log between two visit alarm","Loadcell error code alarm":"Loadcell error code alarm","Communication, quality alarm":"Communication, quality alarm","Sync alarm":"Sync alarm","Low disk space (below 10GB)":"Low disk space (below 10GB)","Animal not eat":"Animal not eat","Communication, no communication alarm":"Communication, no communication alarm","Low pressure in system alarm":"Low pressure in system alarm","Systems":"Systems","FullName":"Full Name","Description":"Description","SystemName":"System Name","AddSystem":"Add System","EditSystem":"Edit System","GenerateReport":"Generate Report","Devices":"Devices","Services":"Services","Alarms":"Alarms","Charts":"Charts","Settings":"Settings","Messages":"Messages","today":"today","daysAgo":"days ago","Unit":"Unit","Type":"Type","AlarmType":"Alarm Type","CreateDate":"Create Date","EndDate":"End Date","ShowGraph":"Show Graph","Visits":"Visits","Priority":"Priority","7daysAgo":"7 days ago","Today":"Today","Details":"Details","High":"High","Mid":"Mid","Low":"Low","UpdateDate":"Update Date","DelayLog":"Delay Log","Dec.Value":"Dec. Value","Inc.Value":"Inc. Value","DelayOpen":"Delay Open","StabilizationGap":"Stabilization Gap","MinMangerWeight":"Min Manger Weight","CalibrationWeight":"Calibration Weight","MaxEatingSpeed":"Max Eating Speed","NoControlOfLogBelow":"No Control Of Log Below","StabilizationTime":"Stabilization Time","WagonAutoCloseTime":"Wagon Auto Close Time","NumberOfDevices":"Number of devices","SoftwareVersionUi":"Software version - UI","SoftwareVersionAPI":"Software version - API","SoftwareVersionBlackBox":"Software version - BlackBox","SoftwareVersionDiagnostic":"Software version - Diagnostic","SoftwareVersionSystem":"Software version - System","NumberOfAlarmsToday":"Number of alarms today","NumberOfAlarmsYesterday":"Number of alarms yesterday","InstallationDate":"Installation date","UnderWarranty":"Under warranty","ServiceAgreement":"Service agreement","ExternalAccess":"External Access","Platform":"Platform","Login":"Login","Password":"Password","Add":"Add","EditPassword":"Edit Password","Photos":"Photos","SystemAddress":"System Address","Number":"Number","Mode":"Mode","Software":"Software","SoftwareDownloads":"Software Downloads","SoftwareVersions":"Versions","AddShortcut":"Add Shortcut","EditShortcut":"Edit Shortcut","DeleteShortcut":"Delete Shortcut","ShortcutName":"Name","NoShortcuts":"No shortcuts added yet.","NoVersionAvailable":"No stable version","Icon":"Icon","NoIcon":"No icon","SelectIcon":"Select Icon","RemoveIcon":"Remove","IconTooLarge":"Icon must be smaller than 1MB.","ShortcutRequiredFields":"Name, product and platform are required.","Calibration":"Calibration","Photocell":"Photocell","Loadcell":"Loadcell","Connection":"Connection","ErrorLogs":"Error Logs","Lid":"Lid","Tilt":"Tilt","InitPhotodelay":"Init Photodelay","Photodelay":"Photodelay","AutoTaraTimer":"Auto Tara Timer","AutoTaraWeight":"Auto Tara Weight","AnimalWeightCalibration":"Animal Weight Calibration","ErrorGate":"Error Gate","NoDecisionTime":"No Decision Time","SprayTime":"Spray Time","MinWeightOnPlatform":"Min Weight On Platform","WeightTime":"Weight Time","SortingMode":"Sorting Mode","SortByWeightRanges":"Sort By Weight Ranges","SettingsSorting":"Settings Sorting","totalItemInfo":"({0} item)","Date":"Date","Logs":"Logs","WeightLogsCount":"Weight Logs Count","OtherReasonLogs":"Other Reason Logs","Statistics":"Statistics","Title":"Title","ReportedDate":"Reported Date","ResolvedDate":"Resolved Date","Incomplete":"Incomplete","Under Observation":"Under Observation","Pending For Spares":"Pending For Spares","Complete":"Complete","AddProblem":"Add Problem","EditProblem":"Edit Problem","LastMessageDate":"Last Message Date","LastMessageFrom":"Last Message From","Subject":"Subject","AddVisit":"Add Visit","EditVisit":"Edit Visit","Assignee":"Assignee","DateFrom":"Date From","DateTo":"Date To","System":"System","Problems":"Problems","Solutions":"Solutions","CreatedBy":"Created By","ProblemTitle":"Problem Title","SystemStatusCheck":"System Status Check","Created":"Created","Resolved":"Resolved","AddSolution":"Add solution","EditSolution":"Edit solution","AddContact":"Add Contact","Contacts":"Contacts","UserName":"User Name","Role":"Role","AccessToSystem":"Access To System","SystemGroups":"System Groups","AddUser":"Add User","Users":"Users","ExpirationDate":"Expiration Date","Invitations":"Invitations","AddInvitation":"Add Invitation","ADD_INVITATION":"ADD INVITATION","EDIT_INVITATION":"EDIT INVITATION","DELETE_INVITATION":"DELETE INVITATION","ENABLE_INVITATION":"ENABLE INVITATION","DISABLE_INVITATION":"DISABLE INVITATION","AreYouSureEnable":"Are you sure you want to enable?","AreYouSureDisable":"Are you sure you want to disable?","Enable":"Enable","Disable":"Disable","DeleteInvitation-":"Delete Invitation - {0}","EnableInvitation-":"Enable Invitation - {0}","DisableInvitation-":"Disable Invitation - {0}","FirstName":"First Name","LastName":"Last Name","EmailsLanguage":"Email Language","AccessToSystems":"Access To Systems","AccessByGroups":"Access By Groups","Groups":"Groups","Surname":"Surname","Save":"Save","PINtoConfirm":"Enter PIN to confirm action","Cancel":"Cancel","Confirm":"Confirm","AreYouSureDelete":"Are you sure you want to delete?","SelectSystem":"Select system to proceed.","Ok":"Ok","ADD_SYSTEM":"ADD SYSTEM","EDIT_SYSTEM":"EDIT SYSTEM","SYSTEM_INFORMATION":"SYSTEM INFORMATION","SystemType":"System Type","Address":"Address","SystemGroup":"System Group","Problem":"Problem","Gallery":"Gallery","Graph":"Graph","STATUS":"STATUS","PER_DEVICE":"PER DEVICE","NoAlarmsInRange":"No alarms found in current range","AllAlarmTypes":"All Alarm Types","ResetPassword":"Reset Password","USER_INFORMATION":"USER INFORMATION","ChangePassword":"Change Password","City":"City","EditProfile":"Edit Profile","SelectFarmBeforeSaving":"Select attached Farm before saving.","SelectSystemBeforeSaving":"Select attached System before saving.","SelectDeviceBeofreSaving":"Select or write device before saving.","SelectTitleBeforeSaving":"Select or write title before saving.","SelectDescriptionBeforeSaving":"Select or write description before saving.","FieldName":"Field Name","Value":"Value","LeftTare":"Left Tare","LeftCalibration":"Left Calibration","RightTare":"Right Tare","RightCalibration":"Right Calibration","Tare":"Tare","TareCalibration":"Tare Calibration","Version":"Version","WhichAlarmsPriorityChoose":"Which alarms priority do you choose?","ReportDate":"Report date","Generate":"Generate","OptionsSelected":"options selected","Now":"Now","Yesterday":"Yesterday","Last7Days":"Last 7 days","PROBLEMSTATUS":"PROBLEM STATUS","UNDEROBSERVATION":"UNDER\nOBSERVATION","PENDINGFORSPARES":"PENDING\nFOR SPARES","Problem/Suggestion":"Problem/Suggestion","RequiredSpareParts":"Required spare parts","Notes":"Notes","WhatWasDone":"What was done","SystemCheck":"System check","FurtherWork":"Further work","ADDREMOTEACCESS":"ADD REMOTE ACCESS","REMOTEACCESS":"REMOTE ACCESS","Show":"Show","SelectElement":"Select element to proceed.","SHOWPASSWORD":"SHOW PASSWORD","DELETEREMOTEACCESS":"DELETE REMOTE ACCESS","EDITPASSWORD":"EDIT PASSWORD","ShowPassword":"Show Password","Pin":"Pin","CurrentPassword":"Current password","NewPassword":"New password","Close":"Close","Open":"Open","Up":"Up","Down":"Down","Normal":"Normal","Restricitve":"Restricitve","FreeAccess":"Free Access","StatusAlarms":"Status Alarms","SettingsRoughage":"Settings Roughage","OnlySortByAnimalSettings":"Only sort by animal settings","WeightAndSortByAnimalSettings":"Weight and sort by animal settings","WeightAndSortByWeightRange":"Weight and sort by weight range","From":"From","to":"to","goToGate":"go to gate","Over":"Over","CrossReadingLogs":"Cross-Reading Logs","OtherTagInAntennaLogs":"Other Tag In Antenna Logs","Creator":"Creator","ProblemInfo":"Problem Info","DeviceName":"Device Name","Visit":"Visit","WorkDone":"Work Done","MainAssignee":"Main Assignee","PreviewSolution":"Preview Solution","VisitInfo":"Visit Info","EditUser":"Edit User","DeleteUser":"Delete User","EditContact":"Edit Contact","CONTACTINFORMATION":"CONTACT INFORMATION","DeleteContact":"Delete Contact","ShowChat":"Show Chat","CloseTicket":"Close Ticket","AreYouSureYouWantToCloseThisTicket":"Are you sure you want to close this ticket?","Client":"Client","You":"You","Send":"Send","FIT_EVERYTHING":"RESET MAP","FIT_MAP_TO_SHOW_ALL":"ZOOM OUT TO SHOW ALL SYSTEMS","Map":"Map","Dashboard":"Dashboard","AlarmsCRFI":"Alarms CRFI","AlarmsMonitoring":"Alarms Monitoring","ADD_ALARM_RULE":"Add New Alarm Rule","TurnOffFarm":"Turn Off Farm","AlarmsTurnedOff":"Alarms Turned Off","AlarmNumber":"Alarm Number","AlarmName":"Alarm Name","Options":"Options","AreYouSureTurnOffFarm":"Are you sure you want to turn off farm?","AreYouSureTurnOnFarm":"Are you sure you want to turn on farm?","TURN_FARM_ON":"TURN ON THE SYSTEM","TURN_ON":"TURN ON","TURN_FARM_OFF":"TURN OFF THE SYSTEM","TurnOnAlarms":"Turn On All Alarms","TurnOnFarm":"Turn On All Alarms?","AreYouSureTurnOnAllSystemAlarms":"Are you sure you want to turn on all farm alarms?","Tasks":"Tasks","Tickets":"Tickets","Roughage":"Roughage","Sorting":"Sorting","General Alarms":"General Alarms","TurnOn":"Turn On","AddRule":"Add Rule","Weight under min. open level":"Weight under min. open level","Animal Eaten Too Much":"Animal has eaten too much","LoadcellError":"Loadcell Error","DlcRight":"DLC Right","DlcLeft":"DLC Left","UnderAlarmLevelTime":"Under Alarm Level Time","NoRapidLogTime":"No RapidLog Time","CorrectPercent":"Correct (%)","WeekResult":"7 days before (Correct/Total)","TodayResult":"Today (Correct/Total)","UnderMinOpenLevelTime":"Under Min. Open Level Time","DeviceAlarms":"Device Alarms","NothingSelected":"Nothing is selected.","LastCheckup":"Last Checkup","LastCheckupDate":"Last checkup date","LastCheckupPerson":"Last checkup person","Checkup":"Checkup","TO_CHECKUP":"TO CHECKUP","SetAsChecked":"Set as checked","TheSettingHasBeenSaved":"The setting has been saved","UnknownAnimalWeightLogsCount":"Unknown Animal Weight Logs Count","UnknownAnimalWeightAlarmPercent":"Unknown Animal Weight Alarm Percent","ErrorLogsChecked":"Error Logs / Checked","errorLogsCheckedTT":"Show values from today and 3 days before.","CheckedLogs":"Checked Logs","ghostUnknownAnimalsTT":"Show values from today and 3 days before.","GhostUnknownAnimals":"Ghost / Unknown Animals","GhostAnimals":"Ghost Animals","UnknownAnimals":"Unknown Animals","WeightErrorLogsChecked":"Weight Error Logs / Checked","weightErrorLogsCheckedTT":"Show values from today and 3 days before.","AssigneeNotSelected":"Assignee should be selected.","SubjectNotFilled":"Subject cannot be empty.","ContentNotFilled":"Content cannot be empty.","CalibrationDateErrorAfterDays":"Calibration Date Error After Days","Animals":"Animals","ShowResolvedTasks":"Show Resolved Tasks","ShowUnresolvedTasks":"Show Unresolved Tasks","leftAxis":"Left Axis","rightAxis":"Right Axis","noDataFromSensors":"No data from sensors available","Loading":"Loading data","Reload":"Reload","Ram":"Ram Available (GB)","Temperature":"CPU Temperature (°C)","rightMovingAvg":"Right chart frame size","leftMovingAvg":"Left chart frame size","Apply":"Apply","AnimalEatingButNotWeighed":"Animal was eating but wasn't weighed","AnimalAteOverLimit":"Animal has ate over the limit","UnknownEatingAnimal":"Unknown eating animal","UnknownBTransponder":"Unknown BTransponder","RefillWithoutUp":"Refill without gate in UP","AnimalTooManyWeightErrorLogs":"Animal too many weight error logs","LowPressure":"Low pressure","AnimalNotEat":"Animal didn't eat","UnknownWeightedAnimal":"Unknown weighted animal","LowPressureDaily":"Low pressure daily","VisitProblem":"Visit Problem","DismissMany":"Dismiss Many","DISMISS_ALARMS":"Dismiss Alarm","DISMISS_ALARMSMANY":"Dismiss Alarms","AssignedSystems":"Assigned Systems","AddSystems":"Assign Systems","AddServer":"Add Server Configuration","HerdIdentifier":"Herd Identifier","ProducerNumber":"Producer Number","ADD_SYSTEMS_TO_SERVER":"Assign systems to server","AddConfiguration":"Add Config","EditConfiguration":"Edit Config","NEW_SERVER_CONFIG":"New Server Configuration","Dismiss":"Dismiss","Loadcell ErrorCode":"Loadcell Error Code","LoadcellErrorTime":"Loadcell Error Time","PROBLEM_ALARMS":"PROBLEM FROM ALARM","UnitNumber":"Unit Number","MissingLog":"Weight Gap / Missing Log","Loadcell Data Out Of Range":"Loadcell Data Out Of Range","Loadcell Dlc Error Time":"Loadcell Dlc Error Time","Weights":"Weights","trendLine":"Trend line","Feeding":"Feeding","CHECKUP":"CHECKUP","Cloud":"Cloud","Product":"Product","SoftwareVersion":"Version","AddVersion":"Add Version","ChangeLog":"ChangeLog","VersionFile":"Version File","Alarms Off":"Alarms Off","Off":"Off","On":"On","UploadFailed":"Upload failed. Exit","UploadProgress":"File Upload Progress","Preparing":"Preparing...","DownloadProgress":"Download Progress","Download":"Download","DELETEVERSION":"DELETE VERSION","EditVersion":"Edit Version","ChangeFile":"Change File","DropFileOrBrowse":"Drop a file here or click to browse","AllowedFileTypes":"Allowed","ClickOrDropToReplace":"click or drop to replace","RemoveFile":"Remove file","InvalidFileType":"Unsupported file type","Restart":"Restart","Never":"Never","ErrorLogsTodayYesterday7Days":"Error Logs Today / Yesterday / 7 Days","errorLogsTodayYesterday7DaysTT":"Show values from today / yesterday / last 7 days.","WeightErrorLogsTodayYesterday7Days":"Weight Error Logs Today / Yesterday / 7 Days","weightErrorLogsTodayYesterday7DaysTT":"Show values from today / yesterday / last 7 days.","DELETEBACKUP":"DELETE BACKUP","CopyLink":"Copy Link","Requirements":"Requirements","Backups":"Backups","Copied":"Copied","ReceivedDate":"Received Date","FileSize":"File Size","DELETEREQUIREMENT":"DELETE REQUIREMENT","AddRequirement":"Add Requirement","EditRequirement":"Edit Requirement","MaxSupportedVersion":"Max supported version","MaxVersion":"Max Version","Program":"Application","IsTestVersion":"Test version","Architecture":"Architecture","No":"No","Yes":"Yes","IsBeta":"Is Beta","Beta":"Beta Version","ScheduledReports":"Email Reports","AddScheduledReport":"Add Report","EditScheduledReport":"Edit Report","DeleteScheduledReport":"Delete Report","ReportName":"Report Name","ReportNameRequired":"Report name is required.","Frequency":"Frequency","Daily":"Daily","Weekly":"Weekly","Monthly":"Monthly","SendTime":"Send Time","DayOfWeek":"Day of Week","DayOfMonth":"Day of Month","ReportLanguage":"Report Language","Recipients":"Recipients","ExternalEmails":"External Emails","AddEmail":"Add","ReportScope":"Scope","PreviewReport":"Preview","SendNow":"Send Now","SentToRecipients":"Sent to recipients","LastSent":"Last Sent","NextRun":"Next Run","Active":"Active","InvalidEmail":"Invalid email address.","SelectAtLeastOneRecipient":"Select at least one recipient.","SelectAtLeastOneSystemOrGroup":"Select at least one system or group.","PeriodHintDaily":"The report covers the previous day.","PeriodHintWeekly":"The report covers the previous 7 days.","PeriodHintMonthly":"The report covers the previous calendar month.","PeriodHintDailySkipWeekends":"The report covers the previous day, and on Monday it combines Friday, Saturday and Sunday.","PeriodHintSkipWeekends":"A delivery falling on Saturday or Sunday is moved to Monday.","SkipWeekends":"Skip weekends","WithoutWeekends":"without weekends","Monday":"Monday","Tuesday":"Tuesday","Wednesday":"Wednesday","Thursday":"Thursday","Friday":"Friday","Saturday":"Saturday","Sunday":"Sunday","Retry":"Try again","NoSystemsWithWeight":"No systems with herd weight","SystemsLoadFailed":"Could not load the list of systems","HerdWeightNoData":"No weight data","HerdWeightLoadFailed":"Could not load the chart","Notifications":"Notifications","Recipient":"Recipient","Sent":"Sent","Waiting":"Waiting","NotificationTypeNewTask":"New task","NotificationTypeClosedTask":"Task closed","NotificationTypeResponseToTask":"Task message","NotificationTypeAnimalDidNotEat":"Animal did not eat","NotificationTypeNewAlarm":"New alarm","Processed":"Processed","NotificationsStatusHint":"Status shows what happened to each notification: sent to FCM, retried after an error, rejected, or deliberately skipped. Rows from before status tracking are marked as processed.","NotificationsSendResult":"Queued: {pending}, sent: {sent}, failed: {failed}, rejected: {rejected}, skipped: {skipped}","SendNowFailed":"Could not start the sending run","NotificationStatusPending":"Pending","NotificationStatusSent":"Sent","NotificationStatusFailed":"Failed (will retry)","NotificationStatusFailedPermanently":"Failed (not retried)","NotificationStatusSkippedStale":"Expired","NotificationStatusSkippedNoRecipient":"No recipient","NotificationStatusSkippedNoSystem":"No system","NotificationStatusSkippedAlreadyRead":"Already read on the web","NotificationStatusSkippedSeenInApp":"Seen in the app","NotificationStatusLegacyProcessed":"Processed (before status tracking)","SentAt":"Sent at","NotificationError":"Error","NotificationsFailedCount":"Failed: {count}","AddTicket":"Add ticket","AssigneeName":"Assignee","LastMessage":"Last message","ShowAllTickets":"Show all","ShowActiveTickets":"Show active","SelectTicket":"Select a ticket to see the conversation","TicketStatusNew":"New","TicketStatusOngoing":"Ongoing","TicketStatusWaitingForApprove":"Close requested","TicketStatusRejected":"Close rejected","TicketStatusClosed":"Closed","TicketEventRequestedClose":"Requested to close the ticket","TicketEventClosed":"Ticket closed","TicketEventConfirmedClose":"Close confirmed","TicketEventCloseDenied":"Close request denied","CloseTicketButton":"Close ticket","CloseTicketConfirm":"Close this ticket?","TicketCloseRequested":"The farmer asks to close this ticket","Accept":"Accept","Deny":"Deny","TicketClosedInfo":"This ticket is closed","WriteMessage":"Write a message…","AttachPhotos":"Attach photos","Remove":"Remove","Back":"Back","Sending":"Sending…","MessageNotSent":"Not sent.","TryAgain":"Try again","NoMessages":"No messages","LoadingMessagesFailed":"Could not load messages.","DropPhotosHere":"Drop photos to attach","VersionAvailable":"Available","VersionUnavailable_NoFileName":"No file name","VersionUnavailable_NoFileName_Hint":"The version has no file assigned. Edit it and upload the file.","VersionUnavailable_NotUploaded":"File not uploaded","VersionUnavailable_NotUploaded_Hint":"No SHA-256 checksum - the file was never uploaded or the upload failed. Edit the version and upload the file again.","VersionUnavailable_FileMissing":"File missing on server","VersionUnavailable_FileMissing_Hint":"The checksum is stored, but the file is missing on the server disk. Edit the version and upload the file again.","Missing Animal Weight":"Missing Animal Weight","Weight under alarm level":"Weight under alarm level","Unknown Eating Animal":"Unknown Eating Animal","Unknown Animal":"Unknown Animal","Unknown Weighted Animal":"Unknown Weighted Animal","Daily Low Pressure":"Daily Low Pressure","Animal Eating But Not Weighed":"Animal Eating But Not Weighed","Animal Eating But Not Weighed ":"Animal Eating But Not Weighed","Refill Without Up":"Refill Without Up","Unknown BTransponder":"Unknown BTransponder","Animal Ate Over Limit":"Animal Ate Over Limit","Animal Too Many Weight Error Logs":"Animal Too Many Weight Error Logs","Weight Device Too Many Error Logs":"Weight Device Too Many Error Logs","USB Pendrive":"USB Pendrive","No Delpro Sync":"No Delpro Sync","Cloud Login":"Cloud Login","Too Many Error Logs Alarm":"Too Many Error Logs Alarm","Temperature Alarm":"Temperature Alarm","Weight Device No Visits":"Weight Device No Visits","Animal Weight Difference Between Devices":"Animal Weight Difference Between Devices","Herd Weight":"Herd Weight","No Antenna Readings":"No Antenna Readings","Manger Too Long In Down":"Manger Too Long In Down","Manger Too Long In Up":"Manger Too Long In Up","Weight Device Visits Dropped":"Weight Device Visits Dropped","CloudNoVisits":"No visits in the cloud","WagonSensor":"Wagon sensor","Communication":"Communication","AlarmMangerTooLongInDown":"Manger too long in down","AlarmMangerTooLongInUp":"Manger too long in up","AlarmNoAntennaReadings":"No antenna readings","AbnormalVisit":"Abnormal visit","TooManyErrorLogs":"Too many error logs","Weight":"Weight","WeightTooManyErrorLogs":"Weight device too many error logs","WeightDeviceNoVisits":"Weight device no visits","WeightVisitsDrop":"Weight device visits dropped","AlarmHerdWeight":"Herd weight","CowWeight":"Animal weight drastically changed","MissingAnimalWeight":"Missing animal weight","AnimalWeightDiffBetweenDevices":"Animal weight difference between devices","NoDelproSynchronization":"No Delpro synchronization","LowSpace":"Low disk space","UnknownAnimal":"Unknown animal","Cloud Login!":"Cloud login failed!","ClientId":"Client ID","SelectAlarmToDisable":"Select alarm to disable","NewRules":"New rules","DismissAlarms":"Dismiss alarms","Annotation":"Annotation","SENSORS":"SENSORS","New problems":"New problems","Content":"Content","Report":"Report","PendingProblems":"Pending problems","ActiveProblems":"Active problems","MoreInfo":"More info","PasswordToConfirm":"Enter your password to confirm","Last7days":"Last 7 days","Last10days":"Last 10 days","ThisMonth":"This month","LastMonth":"Last month","Last3Months":"Last 3 months","January":"January","February":"February","March":"March","April":"April","May":"May","June":"June","July":"July","August":"August","September":"September","October":"October","November":"November","December":"December","Jan":"Jan","Feb":"Feb","Mar":"Mar","Apr":"Apr","MayShort":"May","Jun":"Jun","Jul":"Jul","Aug":"Aug","Sep":"Sep","Oct":"Oct","Nov":"Nov","Dec":"Dec","Sun":"Sun","Mon":"Mon","Tue":"Tue","Wed":"Wed","Thu":"Thu","Fri":"Fri","Sat":"Sat","Su":"Su","Mo":"Mo","Tu":"Tu","We":"We","Th":"Th","Fr":"Fr","Sa":"Sa","Farm":"Farm","SelectDeviceBeforeSaving":"Select or write device before saving.","years":"years","day":"day","CRFIVersions":"CRFI versions","DownloadPack":"Download pack","Components":"Components","DownloadWSS":"Download WSS","DownloadLTC":"Download LTC","DownloadBlackBox":"Download BlackBox","NotFound":"Not found","Herd weight":"Herd weight","SyncTodayResult":"Sync today (correct/total)","No animals to display":"No animals to display","Select an animal to see details":"Select an animal to see details","DismissDate":"Dismiss Date","SaveAlarms":"Save alarms","INSERT_PIN":"ENTER PIN","enterPin":"Enter PIN to show the password","RESET_PASSWORD":"RESET PASSWORD","reset_password":"Send a password reset link to this user?","DoneDuringVisit":"Done during visit","PlannedFrom":"Planned from","PlannedTo":"Planned to","Started":"Started","Ended":"Ended","Pending":"Pending","Finished":"Finished","CONTACT_PERSON":"CONTACT PERSON","FARM_OWNER":"FARM OWNER","RepeatNewPassword":"Repeat new password","Comment":"Comment","ConfirmPassword":"Confirm password","Transponder":"Transponder","LastVisit":"Last visit","Discontinued":"Discontinued","DeleteConfiguration":"Delete config","CookiesText":"BioControl asks you to accept service performance cookies. For more information or to adjust your settings, please click the \"More Information\" button or select \"Cookie Settings\" at the bottom of the site. More information about cookies and the processing of personal data can be found in the Privacy Policy and Cookie Policy. Do you accept these cookies and the related processing of personal data?","CookieSettings":"Cookie Settings","MoreInformation":"More information","CookiesChangeSettings":"You can change your settings at any time by going to","CookiesThisPage":"this page","CookiesPolicyDetails":"For details, please refer to the GDPR Privacy Policy and Cookie Policy.","LoginHeadline":"Monitor your farm.","LoginSubline":"Monitor farm status in a convenient way wherever you want.","SignIn":"Sign In","SignOn":"Sign On","or":"or","FIRST_NAME":"FIRST NAME","LAST_NAME":"LAST NAME","E_MAIL":"E-MAIL","PASSWORD":"PASSWORD","CONFIRM_PASSWORD":"CONFIRM PASSWORD","EnterFirstName":"Enter your first name","EnterLastName":"Enter your last name","EnterEmail":"Enter your e-mail","EnterPassword":"Enter your password","ConfirmYourPassword":"Confirm your password","IAgreeStatements":"I agree all statements in","TermsOfService":"terms of service","AlreadyMember":"I'm already member","GdprPrivacyPolicy":"GDPR Privacy Policy","CookiePolicy":"Cookie Policy","LoginIncorrect":"Login/password incorrect.","UnauthorizedRole":"Unauthorized Role","EmailRequired":"Email is required.","EmailInvalid":"Email is in not valid format.","PasswordRequired":"Password is required.","PasswordRules":"Password should contains at least one lower and upper character, number and special character.","ConfirmPasswordRequired":"Confirm password is required.","FirstNameRequired":"First name is required.","LastNameRequired":"Last name is required.","Required":"Required.","ApiUsage":"API usage","ApiUsageLayout":"Layout","ApiUsagePerUser":"Per user","ApiUsagePerEndpoint":"Per endpoint","ApiUsageEndpoint":"Endpoint","ApiUsageMethod":"Method","ApiUsageCalls":"Calls","ApiUsageErrors":"Errors","ApiUsageAvgMs":"Avg. time [ms]","ApiUsageMaxMs":"Max. time [ms]","ApiUsageEndpointsCount":"Endpoints","ApiUsageUsersCount":"Users","ApiUsageLastSeen":"Last used","ApiUsageCallsOverTime":"Calls over time","ApiUsageShowAll":"Show all","All":"All","Roles":"Roles"}

/***/ }),

/***/ 1490:
/***/ (function(module, exports) {

module.exports = {"ej2LocaleCulture":"no-NL","NAME":"NAVN","Anonymous":"Anonym","MAP":"KART","DASHBOARD":"OVERSIKT","SYSTEMS":"SYSTEMER","ALARMS":"ALARMER","SERVICE":"SERVICE","USERS":"BRUKERE","CONTACTS":"KONTAKTER","FAQ":"FAQ","NoRole":"Ingen rolle","Admin":"Admin","Service":"Service","User":"Bruker","Profile":"Profil","Logout":"Logg ut","Theme":"Tema","ThemeLight":"Lyst","ThemeDark":"Mørkt","ThemeSystem":"System","Language":"Språk","ALL_SYSTEMS":"ALLE SYSTEMER","ACTIVE_MONITORING":"AKTIV OVERVÅKING","WITHOUT_MONITORING":"UTEN OVERVÅKING","WORKING_FINE":"FUNGERER","WITH_ISSUES":"MED PROBLEMER","No_system_selected":"Ingen system valgt","SystemStatus":"Systemstatus","FarmName":"Gårdsnavn","Group":"Gruppe","FarmAddress":"Gårdsadresse","Name":"Navn","Responsibility":"Ansvar","PhoneNumber":"Telefonnummer","Email":"E-post","Contact":"Kontakt","ContactPerson":"Kontaktperson","FarmOwner":"Gårdeier","BaseInfo":"Grunninfo","GoToSystem":"Gå til system","General":"Generelt","BlackBox":"BlackBox","Device":"Enhet","Rapid24":"Rapid24","Rapid24h":"Rapid24h","Photocells":"Fotoceller","Pressure":"Trykk","Database":"Database","System Down":"System nede","System down":"System nede","Error":"Feil","Warning":"Advarsel","Working Fine":"Fungerer","SearchSystem":"Søk etter system","NoSystemsToShow":"Ingen systemer samsvarer med kriteriene","LastUpdate":"Sist oppdatert","CPUTemperature":"Temperatur","FreeSpace":"Ledig plass","Operational":"I drift","Free space alarm!":"Alarm for ledig plass!","days":"dager","ago":"siden","No Monitoring":"Ingen overvåking","Edit":"Rediger","Delete":"Slett","INVITATIONS":"INVITASJONER","NUMBER":"NUMMER","DESCRIPTION":"BESKRIVELSE","SEND_TO_MOBILE":"SEND TIL MOBIL","SEND_PUSH":"PUSHVARSEL","PushRequiresSendToMobile":"Slå på «Send til mobil» først - varselet åpner alarmlisten i appen.","AlarmTypeUpdateFailed":"Kunne ikke lagre endringen","PRIORITY":"PRIORITET","HIGH":"HØY","MID":"MIDDELS","LOW":"LAV","totalItemsInfo":"({0} elementer)","CancelButton":"AVBRYT","pagerDropDown":"Elementer per side","currentPageInfo":"{0} av {1} sider","OKButton":"OK","ChooseColumns":"Velg kolonner","SelectAll":"Velg alle","Columnchooser":"Kolonner","ClearFilter":"Fjern filter","NoResult":"Ingen treff","EnterValue":"Skriv inn verdien","ChooseDate":"Velg en dato","GreaterThan":"Større enn","GreaterThanOrEqual":"Større enn eller lik","LessThan":"Mindre enn","LessThanOrEqual":"Mindre enn eller lik","NotEqual":"Ikke lik","Equal":"Lik","Contains":"Inneholder","StartsWith":"Starter med","EndsWith":"Slutter med","ClearButton":"Fjern","FilterButton":"Filtrer","Csvexport":"CSV-eksport","Excelexport":"Excel-eksport","Pdfexport":"PDF-eksport","search":"Søk","items":"Elementer","item":"Element","emptyRecord":"Ingen poster å vise","Country":"Land","SystemStatusInfo":"Info om systemstatus","Status":"Status","HighLevelAlarm":"Alarm med høy prioritet","MidLevelAlarm":"Alarm med middels prioritet","LowLevelAlarm":"Alarm med lav prioritet","Blackbox":"Blackbox","Weight alarm":"Vektalarm","Max manger weight alarm":"Alarm for maks krybbevekt","Loadcell data alarm":"Alarm for veiecelledata","Photocell not covered in the last 24h":"Fotocellen ikke dekket de siste 24 t","Manger long low weight alarm":"Alarm for lenge lav krybbevekt","Animal weight drastically changed.":"Dyrets vekt er drastisk endret","Loading in down state alarm":"Alarm for påfylling i nede-stilling","Floating cell alarm":"Alarm for flytende veiecelle","Abnormal gate state alarm":"Alarm for unormal portstatus","Wagon alarm":"Vognalarm","Photocell alarm":"Fotocellealarm","Missing log, no log between two visit alarm":"Manglende logg, ingen logg mellom to besøk","Loadcell error code alarm":"Alarm for feilkode på veiecelle","Communication, quality alarm":"Kommunikasjon, kvalitetsalarm","Sync alarm":"Synkroniseringsalarm","Low disk space (below 10GB)":"Lite diskplass (under 10 GB)","Animal not eat":"Dyret har ikke spist","Communication, no communication alarm":"Kommunikasjon, ingen kommunikasjon","Low pressure in system alarm":"Alarm for lavt trykk i systemet","Systems":"Systemer","FullName":"Fullt navn","Description":"Beskrivelse","SystemName":"Systemnavn","AddSystem":"Legg til system","EditSystem":"Rediger system","GenerateReport":"Generer rapport","Devices":"Enheter","Services":"Service","Alarms":"Alarmer","Charts":"Diagrammer","Settings":"Innstillinger","Messages":"Meldinger","today":"i dag","daysAgo":"dager siden","Unit":"Enhet","Type":"Type","AlarmType":"Alarmtype","CreateDate":"Opprettet","EndDate":"Sluttdato","ShowGraph":"Vis graf","Visits":"Besøk","Priority":"Prioritet","7daysAgo":"7 dager siden","Today":"I dag","Details":"Detaljer","High":"Høy","Mid":"Middels","Low":"Lav","UpdateDate":"Oppdatert","DelayLog":"Loggforsinkelse","Dec.Value":"Red. verdi","Inc.Value":"Øk. verdi","DelayOpen":"Åpningsforsinkelse","StabilizationGap":"Stabiliseringsgap","MinMangerWeight":"Min. krybbevekt","CalibrationWeight":"Kalibreringsvekt","MaxEatingSpeed":"Maks ethastighet","NoControlOfLogBelow":"Ingen loggkontroll under","StabilizationTime":"Stabiliseringstid","WagonAutoCloseTime":"Tid for automatisk lukking av vogn","NumberOfDevices":"Antall enheter","SoftwareVersionUi":"Programvareversjon - UI","SoftwareVersionAPI":"Programvareversjon - API","SoftwareVersionBlackBox":"Programvareversjon - BlackBox","SoftwareVersionDiagnostic":"Programvareversjon - Diagnostic","SoftwareVersionSystem":"Programvareversjon - System","NumberOfAlarmsToday":"Antall alarmer i dag","NumberOfAlarmsYesterday":"Antall alarmer i går","InstallationDate":"Installasjonsdato","UnderWarranty":"Under garanti","ServiceAgreement":"Serviceavtale","ExternalAccess":"Ekstern tilgang","Platform":"Plattform","Login":"Brukernavn","Password":"Passord","Add":"Legg til","EditPassword":"Endre passord","Photos":"Bilder","SystemAddress":"Systemadresse","Number":"Nummer","Mode":"Modus","Software":"Programvare","SoftwareDownloads":"Nedlastinger","SoftwareVersions":"Versjoner","AddShortcut":"Legg til snarvei","EditShortcut":"Rediger snarvei","DeleteShortcut":"Slett snarvei","ShortcutName":"Navn","NoShortcuts":"Ingen snarveier lagt til ennå.","NoVersionAvailable":"Ingen stabil versjon","Icon":"Ikon","NoIcon":"Uten ikon","SelectIcon":"Velg ikon","RemoveIcon":"Fjern","IconTooLarge":"Ikonet må være mindre enn 1 MB.","ShortcutRequiredFields":"Navn, produkt og plattform er påkrevd.","Calibration":"Kalibrering","Photocell":"Fotocelle","Loadcell":"Veiecelle","Connection":"Tilkobling","ErrorLogs":"Feillogger","Lid":"Lokk","Tilt":"Vipp","InitPhotodelay":"Innledende fotoforsinkelse","Photodelay":"Fotoforsinkelse","AutoTaraTimer":"Auto-tara-tidtaker","AutoTaraWeight":"Auto-tara-vekt","AnimalWeightCalibration":"Kalibrering av dyrevekt","ErrorGate":"Feilport","NoDecisionTime":"Tid uten avgjørelse","SprayTime":"Spraytid","MinWeightOnPlatform":"Min. vekt på plattformen","WeightTime":"Veietid","SortingMode":"Sorteringsmodus","SortByWeightRanges":"Sorter etter vektintervaller","SettingsSorting":"Innstillinger for sortering","totalItemInfo":"({0} element)","Date":"Dato","Logs":"Logger","WeightLogsCount":"Antall vektlogger","OtherReasonLogs":"Logger med annen årsak","Statistics":"Statistikk","Title":"Tittel","ReportedDate":"Rapportert","ResolvedDate":"Løst","Incomplete":"Ufullstendig","Under Observation":"Under observasjon","Pending For Spares":"Venter på reservedeler","Complete":"Fullført","AddProblem":"Legg til problem","EditProblem":"Rediger problem","LastMessageDate":"Dato for siste melding","LastMessageFrom":"Siste melding fra","Subject":"Emne","AddVisit":"Legg til besøk","EditVisit":"Rediger besøk","Assignee":"Ansvarlig","DateFrom":"Dato fra","DateTo":"Dato til","System":"System","Problems":"Problemer","Solutions":"Løsninger","CreatedBy":"Opprettet av","ProblemTitle":"Problemtittel","SystemStatusCheck":"Kontroll av systemstatus","Created":"Opprettet","Resolved":"Løst","AddSolution":"Legg til løsning","EditSolution":"Rediger løsning","AddContact":"Legg til kontakt","Contacts":"Kontakter","UserName":"Brukernavn","Role":"Rolle","AccessToSystem":"Tilgang til system","SystemGroups":"Systemgrupper","AddUser":"Legg til bruker","Users":"Brukere","ExpirationDate":"Utløpsdato","Invitations":"Invitasjoner","AddInvitation":"Legg til invitasjon","ADD_INVITATION":"LEGG TIL INVITASJON","EDIT_INVITATION":"REDIGER INVITASJON","DELETE_INVITATION":"SLETT INVITASJON","ENABLE_INVITATION":"AKTIVER INVITASJON","DISABLE_INVITATION":"DEAKTIVER INVITASJON","AreYouSureEnable":"Er du sikker på at du vil aktivere?","AreYouSureDisable":"Er du sikker på at du vil deaktivere?","Enable":"Aktiver","Disable":"Deaktiver","DeleteInvitation-":"Slett invitasjon - {0}","EnableInvitation-":"Aktiver invitasjon - {0}","DisableInvitation-":"Deaktiver invitasjon - {0}","FirstName":"Fornavn","LastName":"Etternavn","EmailsLanguage":"Språk i e-post","AccessToSystems":"Tilgang til systemer","AccessByGroups":"Tilgang via grupper","Groups":"Grupper","Surname":"Etternavn","Save":"Lagre","PINtoConfirm":"Skriv inn PIN for å bekrefte","Cancel":"Avbryt","Confirm":"Bekreft","AreYouSureDelete":"Er du sikker på at du vil slette?","SelectSystem":"Velg system for å fortsette.","Ok":"Ok","ADD_SYSTEM":"LEGG TIL SYSTEM","EDIT_SYSTEM":"REDIGER SYSTEM","SYSTEM_INFORMATION":"SYSTEMINFORMASJON","SystemType":"Systemtype","Address":"Adresse","SystemGroup":"Systemgruppe","Problem":"Problem","Gallery":"Galleri","Graph":"Graf","STATUS":"STATUS","PER_DEVICE":"PER ENHET","NoAlarmsInRange":"Ingen alarmer i valgt periode","AllAlarmTypes":"Alle alarmtyper","ResetPassword":"Tilbakestill passord","USER_INFORMATION":"BRUKERINFORMASJON","ChangePassword":"Endre passord","City":"By","EditProfile":"Rediger profil","SelectFarmBeforeSaving":"Velg tilknyttet gård før du lagrer.","SelectSystemBeforeSaving":"Velg tilknyttet system før du lagrer.","SelectDeviceBeofreSaving":"Velg eller skriv inn enhet før du lagrer.","SelectTitleBeforeSaving":"Velg eller skriv inn tittel før du lagrer.","SelectDescriptionBeforeSaving":"Velg eller skriv inn beskrivelse før du lagrer.","FieldName":"Feltnavn","Value":"Verdi","LeftTare":"Venstre tara","LeftCalibration":"Venstre kalibrering","RightTare":"Høyre tara","RightCalibration":"Høyre kalibrering","Tare":"Tara","TareCalibration":"Tarakalibrering","Version":"Versjon","WhichAlarmsPriorityChoose":"Hvilken alarmprioritet velger du?","ReportDate":"Rapportdato","Generate":"Generer","OptionsSelected":"valg valgt","Now":"Nå","Yesterday":"I går","Last7Days":"Siste 7 dager","PROBLEMSTATUS":"PROBLEMSTATUS","UNDEROBSERVATION":"UNDER\nOBSERVASJON","PENDINGFORSPARES":"VENTER PÅ\nRESERVEDELER","Problem/Suggestion":"Problem/forslag","RequiredSpareParts":"Nødvendige reservedeler","Notes":"Notater","WhatWasDone":"Hva ble gjort","SystemCheck":"Systemkontroll","FurtherWork":"Videre arbeid","ADDREMOTEACCESS":"LEGG TIL FJERNTILGANG","REMOTEACCESS":"FJERNTILGANG","Show":"Vis","SelectElement":"Velg et element for å fortsette.","SHOWPASSWORD":"VIS PASSORD","DELETEREMOTEACCESS":"SLETT FJERNTILGANG","EDITPASSWORD":"ENDRE PASSORD","ShowPassword":"Vis passord","Pin":"PIN","CurrentPassword":"Nåværende passord","NewPassword":"Nytt passord","Close":"Lukk","Open":"Åpne","Up":"Oppe","Down":"Nede","Normal":"Normal","Restricitve":"Restriktiv","FreeAccess":"Fri tilgang","StatusAlarms":"Statusalarmer","SettingsRoughage":"Innstillinger for grovfôr","OnlySortByAnimalSettings":"Sorter kun etter dyreinnstillinger","WeightAndSortByAnimalSettings":"Vei og sorter etter dyreinnstillinger","WeightAndSortByWeightRange":"Vei og sorter etter vektintervall","From":"Fra","to":"til","goToGate":"gå til port","Over":"Over","CrossReadingLogs":"Logger med krysslesing","OtherTagInAntennaLogs":"Logger med annen brikke i antennen","Creator":"Oppretter","ProblemInfo":"Probleminfo","DeviceName":"Enhetsnavn","Visit":"Besøk","WorkDone":"Utført arbeid","MainAssignee":"Hovedansvarlig","PreviewSolution":"Forhåndsvis løsning","VisitInfo":"Besøksinfo","EditUser":"Rediger bruker","DeleteUser":"Slett bruker","EditContact":"Rediger kontakt","CONTACTINFORMATION":"KONTAKTINFORMASJON","DeleteContact":"Slett kontakt","ShowChat":"Vis chat","CloseTicket":"Lukk sak","AreYouSureYouWantToCloseThisTicket":"Er du sikker på at du vil lukke denne saken?","Client":"Kunde","You":"Du","Send":"Send","FIT_EVERYTHING":"TILBAKESTILL KART","FIT_MAP_TO_SHOW_ALL":"ZOOM UT FOR Å VISE ALLE SYSTEMER","Map":"Kart","Dashboard":"Oversikt","AlarmsCRFI":"Alarmer CRFI","AlarmsMonitoring":"Alarmer overvåking","ADD_ALARM_RULE":"Legg til ny alarmregel","TurnOffFarm":"Slå av gård","AlarmsTurnedOff":"Alarmer slått av","AlarmNumber":"Alarmnummer","AlarmName":"Alarmnavn","Options":"Alternativer","AreYouSureTurnOffFarm":"Er du sikker på at du vil slå av gården?","AreYouSureTurnOnFarm":"Er du sikker på at du vil slå på gården?","TURN_FARM_ON":"SLÅ PÅ SYSTEMET","TURN_ON":"SLÅ PÅ","TURN_FARM_OFF":"SLÅ AV SYSTEMET","TurnOnAlarms":"Slå på alle alarmer","TurnOnFarm":"Slå på alle alarmer?","AreYouSureTurnOnAllSystemAlarms":"Er du sikker på at du vil slå på alle alarmer for gården?","Tasks":"Oppgaver","Tickets":"Saker","Roughage":"Grovfôr","Sorting":"Sortering","General Alarms":"Generelle alarmer","TurnOn":"Slå på","AddRule":"Legg til regel","Weight under min. open level":"Vekt under min. åpningsnivå","Animal Eaten Too Much":"Dyret har spist for mye","LoadcellError":"Veiecellefeil","DlcRight":"DLC høyre","DlcLeft":"DLC venstre","UnderAlarmLevelTime":"Tid under alarmnivå","NoRapidLogTime":"Tid uten RapidLog","CorrectPercent":"Korrekte (%)","WeekResult":"7 dager før (korrekte/totalt)","TodayResult":"I dag (korrekte/totalt)","UnderMinOpenLevelTime":"Tid under min. åpningsnivå","DeviceAlarms":"Enhetsalarmer","NothingSelected":"Ingenting er valgt.","LastCheckup":"Siste kontroll","LastCheckupDate":"Dato for siste kontroll","LastCheckupPerson":"Siste kontroll utført av","Checkup":"Kontroll","TO_CHECKUP":"TIL KONTROLL","SetAsChecked":"Merk som kontrollert","TheSettingHasBeenSaved":"Innstillingen er lagret","UnknownAnimalWeightLogsCount":"Antall vektlogger for ukjente dyr","UnknownAnimalWeightAlarmPercent":"Alarmprosent for vekt av ukjente dyr","ErrorLogsChecked":"Feillogger / kontrollert","errorLogsCheckedTT":"Viser verdier fra i dag og 3 dager tilbake.","CheckedLogs":"Kontrollerte logger","ghostUnknownAnimalsTT":"Viser verdier fra i dag og 3 dager tilbake.","GhostUnknownAnimals":"Spøkelsesdyr / ukjente dyr","GhostAnimals":"Spøkelsesdyr","UnknownAnimals":"Ukjente dyr","WeightErrorLogsChecked":"Vektfeillogger / kontrollert","weightErrorLogsCheckedTT":"Viser verdier fra i dag og 3 dager tilbake.","AssigneeNotSelected":"Ansvarlig må velges.","SubjectNotFilled":"Emnet kan ikke være tomt.","ContentNotFilled":"Innholdet kan ikke være tomt.","CalibrationDateErrorAfterDays":"Feil på kalibreringsdato etter antall dager","Animals":"Dyr","ShowResolvedTasks":"Vis løste oppgaver","ShowUnresolvedTasks":"Vis uløste oppgaver","leftAxis":"Venstre akse","rightAxis":"Høyre akse","noDataFromSensors":"Ingen data fra sensorene","Loading":"Laster data","Reload":"Last inn på nytt","Ram":"Tilgjengelig RAM (GB)","Temperature":"CPU-temperatur (°C)","rightMovingAvg":"Vindusstørrelse, høyre diagram","leftMovingAvg":"Vindusstørrelse, venstre diagram","Apply":"Bruk","AnimalEatingButNotWeighed":"Dyret spiste, men ble ikke veid","AnimalAteOverLimit":"Dyret har spist over grensen","UnknownEatingAnimal":"Ukjent dyr spiser","UnknownBTransponder":"Ukjent B-transponder","RefillWithoutUp":"Påfylling uten port i oppe-stilling","AnimalTooManyWeightErrorLogs":"For mange vektfeillogger for dyret","LowPressure":"Lavt trykk","AnimalNotEat":"Dyret har ikke spist","UnknownWeightedAnimal":"Ukjent veid dyr","LowPressureDaily":"Lavt trykk daglig","VisitProblem":"Besøksproblem","DismissMany":"Avvis flere","DISMISS_ALARMS":"Avvis alarm","DISMISS_ALARMSMANY":"Avvis alarmer","AssignedSystems":"Tildelte systemer","AddSystems":"Tildel systemer","AddServer":"Legg til serverkonfigurasjon","HerdIdentifier":"Besetnings-ID","ProducerNumber":"Produsentnummer","ADD_SYSTEMS_TO_SERVER":"Tildel systemer til server","AddConfiguration":"Legg til konfig.","EditConfiguration":"Rediger konfig.","NEW_SERVER_CONFIG":"Ny serverkonfigurasjon","Dismiss":"Avvis","Loadcell ErrorCode":"Feilkode for veiecelle","LoadcellErrorTime":"Feiltid for veiecelle","PROBLEM_ALARMS":"PROBLEM FRA ALARM","UnitNumber":"Enhetsnummer","MissingLog":"Vektgap / manglende logg","Loadcell Data Out Of Range":"Veiecelledata utenfor område","Loadcell Dlc Error Time":"DLC-feiltid for veiecelle","Weights":"Vekter","trendLine":"Trendlinje","Feeding":"Fôring","CHECKUP":"KONTROLL","Cloud":"Sky","Product":"Produkt","SoftwareVersion":"Versjon","AddVersion":"Legg til versjon","ChangeLog":"Endringslogg","VersionFile":"Versjonsfil","Alarms Off":"Alarmer av","Off":"Av","On":"På","UploadFailed":"Opplastingen mislyktes. Avslutt","UploadProgress":"Opplasting av fil","Preparing":"Forbereder...","DownloadProgress":"Nedlasting","Download":"Last ned","DELETEVERSION":"SLETT VERSJON","EditVersion":"Rediger versjon","ChangeFile":"Bytt fil","DropFileOrBrowse":"Slipp en fil her eller klikk for å bla","AllowedFileTypes":"Tillatt","ClickOrDropToReplace":"klikk eller slipp for å erstatte","RemoveFile":"Fjern fil","InvalidFileType":"Filtypen støttes ikke","Restart":"Start på nytt","Never":"Aldri","ErrorLogsTodayYesterday7Days":"Feillogger i dag / i går / 7 dager","errorLogsTodayYesterday7DaysTT":"Viser verdier fra i dag / i går / siste 7 dager.","WeightErrorLogsTodayYesterday7Days":"Vektfeillogger i dag / i går / 7 dager","weightErrorLogsTodayYesterday7DaysTT":"Viser verdier fra i dag / i går / siste 7 dager.","DELETEBACKUP":"SLETT SIKKERHETSKOPI","CopyLink":"Kopier lenke","Requirements":"Krav","Backups":"Sikkerhetskopier","Copied":"Kopiert","ReceivedDate":"Mottatt","FileSize":"Filstørrelse","DELETEREQUIREMENT":"SLETT KRAV","AddRequirement":"Legg til krav","EditRequirement":"Rediger krav","MaxSupportedVersion":"Maks støttet versjon","MaxVersion":"Maks versjon","Program":"Applikasjon","IsTestVersion":"Testversjon","Architecture":"Arkitektur","No":"Nei","Yes":"Ja","IsBeta":"Er beta","Beta":"Betaversjon","ScheduledReports":"E-postrapporter","AddScheduledReport":"Legg til rapport","EditScheduledReport":"Rediger rapport","DeleteScheduledReport":"Slett rapport","ReportName":"Rapportnavn","ReportNameRequired":"Rapportnavn er påkrevd.","Frequency":"Frekvens","Daily":"Daglig","Weekly":"Ukentlig","Monthly":"Månedlig","SendTime":"Sendetidspunkt","DayOfWeek":"Ukedag","DayOfMonth":"Dag i måneden","ReportLanguage":"Rapportspråk","Recipients":"Mottakere","ExternalEmails":"Eksterne e-poster","AddEmail":"Legg til","ReportScope":"Omfang","PreviewReport":"Forhåndsvis","SendNow":"Send nå","SentToRecipients":"Sendt til mottakerne","LastSent":"Sist sendt","NextRun":"Neste kjøring","Active":"Aktiv","InvalidEmail":"Ugyldig e-postadresse.","SelectAtLeastOneRecipient":"Velg minst én mottaker.","SelectAtLeastOneSystemOrGroup":"Velg minst ett system eller én gruppe.","PeriodHintDaily":"Rapporten dekker forrige dag.","PeriodHintWeekly":"Rapporten dekker de siste 7 dagene.","PeriodHintMonthly":"Rapporten dekker forrige kalendermåned.","PeriodHintDailySkipWeekends":"Rapporten dekker forrige dag, og på mandag slår den sammen fredag, lørdag og søndag.","PeriodHintSkipWeekends":"En utsendelse som faller på lørdag eller søndag flyttes til mandag.","SkipWeekends":"Hopp over helger","WithoutWeekends":"uten helger","Monday":"Mandag","Tuesday":"Tirsdag","Wednesday":"Onsdag","Thursday":"Torsdag","Friday":"Fredag","Saturday":"Lørdag","Sunday":"Søndag","Retry":"Prøv igjen","NoSystemsWithWeight":"Ingen systemer med besetningsvekt","SystemsLoadFailed":"Kunne ikke laste listen over systemer","HerdWeightNoData":"Ingen vektdata","HerdWeightLoadFailed":"Kunne ikke laste diagrammet","Notifications":"Varsler","Recipient":"Mottaker","Sent":"Sendt","Waiting":"Venter","NotificationTypeNewTask":"Ny oppgave","NotificationTypeClosedTask":"Oppgave lukket","NotificationTypeResponseToTask":"Melding i oppgave","NotificationTypeAnimalDidNotEat":"Dyret har ikke spist","NotificationTypeNewAlarm":"Ny alarm","Processed":"Behandlet","NotificationsStatusHint":"Status viser hva som skjedde med hvert varsel: sendt til FCM, prøvd på nytt etter en feil, avvist eller bevisst hoppet over. Rader fra før statussporingen er merket som behandlet.","NotificationsSendResult":"I kø: {pending}, sendt: {sent}, mislyktes: {failed}, avvist: {rejected}, hoppet over: {skipped}","SendNowFailed":"Kunne ikke starte utsendelsen","NotificationStatusPending":"Venter","NotificationStatusSent":"Sendt","NotificationStatusFailed":"Mislyktes (prøves igjen)","NotificationStatusFailedPermanently":"Mislyktes (prøves ikke igjen)","NotificationStatusSkippedStale":"Utløpt","NotificationStatusSkippedNoRecipient":"Ingen mottaker","NotificationStatusSkippedNoSystem":"Ingen system","NotificationStatusSkippedAlreadyRead":"Allerede lest på nett","NotificationStatusSkippedSeenInApp":"Sett i appen","NotificationStatusLegacyProcessed":"Behandlet (før statussporing)","SentAt":"Sendt","NotificationError":"Feil","NotificationsFailedCount":"Mislyktes: {count}","AddTicket":"Legg til sak","AssigneeName":"Ansvarlig","LastMessage":"Siste melding","ShowAllTickets":"Vis alle","ShowActiveTickets":"Vis aktive","SelectTicket":"Velg en sak for å se samtalen","TicketStatusNew":"Ny","TicketStatusOngoing":"Pågår","TicketStatusWaitingForApprove":"Lukking forespurt","TicketStatusRejected":"Lukking avslått","TicketStatusClosed":"Lukket","TicketEventRequestedClose":"Ba om å lukke saken","TicketEventClosed":"Saken er lukket","TicketEventConfirmedClose":"Lukking bekreftet","TicketEventCloseDenied":"Forespørsel om lukking avslått","CloseTicketButton":"Lukk sak","CloseTicketConfirm":"Lukke denne saken?","TicketCloseRequested":"Bonden ber om å lukke denne saken","Accept":"Godta","Deny":"Avslå","TicketClosedInfo":"Denne saken er lukket","WriteMessage":"Skriv en melding…","AttachPhotos":"Legg ved bilder","Remove":"Fjern","Back":"Tilbake","Sending":"Sender…","MessageNotSent":"Ikke sendt.","TryAgain":"Prøv igjen","NoMessages":"Ingen meldinger","LoadingMessagesFailed":"Kunne ikke laste meldingene.","DropPhotosHere":"Slipp bilder for å legge dem ved","VersionAvailable":"Tilgjengelig","VersionUnavailable_NoFileName":"Mangler filnavn","VersionUnavailable_NoFileName_Hint":"Versjonen har ingen fil tilknyttet. Rediger den og last opp filen.","VersionUnavailable_NotUploaded":"Filen er ikke lastet opp","VersionUnavailable_NotUploaded_Hint":"Ingen SHA-256-sjekksum – filen ble aldri lastet opp, eller opplastingen mislyktes. Rediger versjonen og last opp filen på nytt.","VersionUnavailable_FileMissing":"Filen mangler på serveren","VersionUnavailable_FileMissing_Hint":"Sjekksummen er lagret, men filen mangler på serverdisken. Rediger versjonen og last opp filen på nytt.","Missing Animal Weight":"Manglende dyrevekt","Weight under alarm level":"Vekt under alarmnivå","Unknown Eating Animal":"Ukjent dyr spiser","Unknown Animal":"Ukjent dyr","Unknown Weighted Animal":"Ukjent veid dyr","Daily Low Pressure":"Daglig lavt trykk","Animal Eating But Not Weighed":"Dyret spiste, men ble ikke veid","Animal Eating But Not Weighed ":"Dyret spiste, men ble ikke veid","Refill Without Up":"Påfylling uten port i oppe-stilling","Unknown BTransponder":"Ukjent B-transponder","Animal Ate Over Limit":"Dyret spiste over grensen","Animal Too Many Weight Error Logs":"For mange vektfeillogger for dyret","Weight Device Too Many Error Logs":"Vektenheten har for mange feillogger","USB Pendrive":"USB-minnepinne","No Delpro Sync":"Ingen Delpro-synkronisering","Cloud Login":"Innlogging i skyen","Too Many Error Logs Alarm":"For mange feillogger","Temperature Alarm":"Temperaturalarm","Weight Device No Visits":"Ingen besøk på vektenheten","Animal Weight Difference Between Devices":"Vektforskjell for dyr mellom enheter","Herd Weight":"Besetningsvekt","No Antenna Readings":"Ingen antenneavlesninger","Manger Too Long In Down":"Krybben for lenge nede","Manger Too Long In Up":"Krybben for lenge oppe","Weight Device Visits Dropped":"Færre besøk på vektenheten","CloudNoVisits":"Ingen besøk i skyen","WagonSensor":"Vognsensor","Communication":"Kommunikasjon","AlarmMangerTooLongInDown":"Krybben for lenge nede","AlarmMangerTooLongInUp":"Krybben for lenge oppe","AlarmNoAntennaReadings":"Ingen antenneavlesninger","AbnormalVisit":"Unormalt besøk","TooManyErrorLogs":"For mange feillogger","Weight":"Vekt","WeightTooManyErrorLogs":"Vektenheten har for mange feillogger","WeightDeviceNoVisits":"Ingen besøk på vektenheten","WeightVisitsDrop":"Færre besøk på vektenheten","AlarmHerdWeight":"Besetningsvekt","CowWeight":"Dyrets vekt er drastisk endret","MissingAnimalWeight":"Manglende dyrevekt","AnimalWeightDiffBetweenDevices":"Vektforskjell for dyr mellom enheter","NoDelproSynchronization":"Ingen Delpro-synkronisering","LowSpace":"Lite diskplass","UnknownAnimal":"Ukjent dyr","Cloud Login!":"Innlogging i skyen mislyktes!","ClientId":"Klient-ID","SelectAlarmToDisable":"Velg alarm som skal slås av","NewRules":"Nye regler","DismissAlarms":"Avvis alarmer","Annotation":"Merknad","SENSORS":"SENSORER","New problems":"Nye problemer","Content":"Innhold","Report":"Rapport","PendingProblems":"Ventende problemer","ActiveProblems":"Aktive problemer","MoreInfo":"Mer info","PasswordToConfirm":"Skriv inn passordet ditt for å bekrefte","Last7days":"Siste 7 dager","Last10days":"Siste 10 dager","ThisMonth":"Denne måneden","LastMonth":"Forrige måned","Last3Months":"Siste 3 måneder","January":"Januar","February":"Februar","March":"Mars","April":"April","May":"Mai","June":"Juni","July":"Juli","August":"August","September":"September","October":"Oktober","November":"November","December":"Desember","Jan":"Jan","Feb":"Feb","Mar":"Mar","Apr":"Apr","MayShort":"Mai","Jun":"Jun","Jul":"Jul","Aug":"Aug","Sep":"Sep","Oct":"Okt","Nov":"Nov","Dec":"Des","Sun":"Søn","Mon":"Man","Tue":"Tir","Wed":"Ons","Thu":"Tor","Fri":"Fre","Sat":"Lør","Su":"Sø","Mo":"Ma","Tu":"Ti","We":"On","Th":"To","Fr":"Fr","Sa":"Lø","Farm":"Gård","SelectDeviceBeforeSaving":"Velg eller skriv inn enhet før du lagrer.","years":"år","day":"dag","CRFIVersions":"CRFI-versjoner","DownloadPack":"Last ned pakke","Components":"Komponenter","DownloadWSS":"Last ned WSS","DownloadLTC":"Last ned LTC","DownloadBlackBox":"Last ned BlackBox","NotFound":"Ikke funnet","Herd weight":"Besetningsvekt","SyncTodayResult":"Synkronisering i dag (korrekte/totalt)","No animals to display":"Ingen dyr å vise","Select an animal to see details":"Velg et dyr for å se detaljer","DismissDate":"Avvist dato","SaveAlarms":"Lagre alarmer","INSERT_PIN":"SKRIV INN PIN","enterPin":"Skriv inn PIN for å vise passordet","RESET_PASSWORD":"TILBAKESTILL PASSORD","reset_password":"Sende en lenke for tilbakestilling av passord til denne brukeren?","DoneDuringVisit":"Utført under besøket","PlannedFrom":"Planlagt fra","PlannedTo":"Planlagt til","Started":"Startet","Ended":"Avsluttet","Pending":"Venter","Finished":"Fullført","CONTACT_PERSON":"KONTAKTPERSON","FARM_OWNER":"GÅRDEIER","RepeatNewPassword":"Gjenta nytt passord","Comment":"Kommentar","ConfirmPassword":"Bekreft passord","Transponder":"Transponder","LastVisit":"Siste besøk","Discontinued":"Utgått","DeleteConfiguration":"Slett konfig.","CookiesText":"BioControl ber deg godta informasjonskapsler for ytelsesmåling av tjenesten. For mer informasjon eller for å endre innstillingene, klikk på «Mer informasjon» eller velg «Innstillinger for informasjonskapsler» nederst på siden. Mer om informasjonskapsler og behandling av personopplysninger finner du i personvernerklæringen og retningslinjene for informasjonskapsler. Godtar du disse informasjonskapslene og tilhørende behandling av personopplysninger?","CookieSettings":"Innstillinger for informasjonskapsler","MoreInformation":"Mer informasjon","CookiesChangeSettings":"Du kan når som helst endre innstillingene på","CookiesThisPage":"denne siden","CookiesPolicyDetails":"For detaljer, se personvernerklæringen (GDPR) og retningslinjene for informasjonskapsler.","LoginHeadline":"Overvåk gården din.","LoginSubline":"Følg med på gårdens status på en enkel måte, uansett hvor du er.","SignIn":"Logg inn","SignOn":"Registrer deg","or":"eller","FIRST_NAME":"FORNAVN","LAST_NAME":"ETTERNAVN","E_MAIL":"E-POST","PASSWORD":"PASSORD","CONFIRM_PASSWORD":"BEKREFT PASSORD","EnterFirstName":"Skriv inn fornavnet ditt","EnterLastName":"Skriv inn etternavnet ditt","EnterEmail":"Skriv inn e-postadressen din","EnterPassword":"Skriv inn passordet ditt","ConfirmYourPassword":"Bekreft passordet ditt","IAgreeStatements":"Jeg godtar alle vilkårene i","TermsOfService":"tjenestevilkårene","AlreadyMember":"Jeg har allerede en konto","GdprPrivacyPolicy":"Personvernerklæring (GDPR)","CookiePolicy":"Retningslinjer for informasjonskapsler","LoginIncorrect":"Feil brukernavn eller passord.","UnauthorizedRole":"Rollen har ikke tilgang","EmailRequired":"E-post er påkrevd.","EmailInvalid":"E-postadressen har ugyldig format.","PasswordRequired":"Passord er påkrevd.","PasswordRules":"Passordet må inneholde minst én liten og én stor bokstav, ett tall og ett spesialtegn.","ConfirmPasswordRequired":"Bekreftelse av passord er påkrevd.","FirstNameRequired":"Fornavn er påkrevd.","LastNameRequired":"Etternavn er påkrevd.","Required":"Påkrevd.","ApiUsage":"API-bruk","ApiUsageLayout":"Oppsett","ApiUsagePerUser":"Per bruker","ApiUsagePerEndpoint":"Per endepunkt","ApiUsageEndpoint":"Endepunkt","ApiUsageMethod":"Metode","ApiUsageCalls":"Kall","ApiUsageErrors":"Feil","ApiUsageAvgMs":"Snitt tid [ms]","ApiUsageMaxMs":"Maks tid [ms]","ApiUsageEndpointsCount":"Endepunkter","ApiUsageUsersCount":"Brukere","ApiUsageLastSeen":"Sist brukt","ApiUsageCallsOverTime":"Kall over tid","ApiUsageShowAll":"Vis alle","All":"Alle","Roles":"Roller"}

/***/ }),

/***/ 1491:
/***/ (function(module, exports) {

module.exports = {"ej2LocaleCulture":"pl","NAME":"NAZWA","Anonymous":"Anonimowo","MAP":"MAPA","DASHBOARD":"TABLICA","SYSTEMS":"SYSTEMY","ALARMS":"ALARMY","SERVICE":"SERWISY","USERS":"UŻYTKOWNICY","CONTACTS":"KONTAKTY","FAQ":"FAQ","NoRole":"Bez Roli","Admin":"Administrator","Service":"Serwis","User":"Użytkownik","Profile":"Profil","Logout":"Wyloguj","Theme":"Motyw","ThemeLight":"Jasny","ThemeDark":"Ciemny","ThemeSystem":"Systemowy","Language":"Język","ALL_SYSTEMS":"WSZYSTKIE SYSTEMY","ACTIVE_MONITORING":"AKTYWNY MONITORING","WITHOUT_MONITORING":"BEZ MONITORINGU","WORKING_FINE":"DZIAŁAJĄCE DOBRZE","WITH_ISSUES":"Z PROBLEMAMI","No_system_selected":"Nie wybrano systemu","SystemStatus":"Status Systemu","FarmName":"Nazwa Farmy","Group":"Grupa","FarmAddress":"Adres farmy","Name":"Imię i nazwisko","Responsibility":"Rola","PhoneNumber":"Numer telefonu","Email":"Email","Contact":"Kontakt","ContactPerson":"Osoba kontaktowa","FarmOwner":"Właściciel","BaseInfo":"Informacje ogólne","GoToSystem":"Idź do systemu","General":"Ogólny","BlackBox":"BlackBox","Device":"Urządzenia WSS","Rapid24":"Rapid24","Rapid24h":"Rapid24h","Photocells":"Fotocele","Pressure":"Ciśnienie","Database":"Baza danych","System Down":"System wyłączony","System down":"System wyłączony","Error":"Z błędami","Warning":"Z ostrzeżeniami","Working Fine":"Działające dobrze","SearchSystem":"Szukaj systemu","NoSystemsToShow":"Brak systemów spełniających kryteria","LastUpdate":"Ostatnia aktualizacja:","CPUTemperature":"Temperatura","FreeSpace":"Wolne miejsce","Operational":"Operacyjne","Free space alarm!":"Brak wolnego miejsca!","days":"dni","ago":"temu","No Monitoring":"Bez monitoringu","Edit":"Edytuj","Delete":"Usuń","INVITATIONS":"ZAPROSZENIA","NUMBER":"NUMER","DESCRIPTION":"OPIS","SEND_TO_MOBILE":"WYSYŁAJ DO APLIKACJI","SEND_PUSH":"POWIADOMIENIE PUSH","PushRequiresSendToMobile":"Najpierw włącz „Wysyłaj do aplikacji” - powiadomienie otwiera listę alarmów w aplikacji.","AlarmTypeUpdateFailed":"Nie udało się zapisać zmiany","PRIORITY":"PRIORYTET","HIGH":"WYSOKI","MID":"ŚREDNI","LOW":"NISKI","totalItemsInfo":"({0} elementów)","CancelButton":"ANULUJ","pagerDropDown":"Elementów na stronie","currentPageInfo":"{0} z {1} stron","OKButton":"OK","ChooseColumns":"Wybierz Kolumny","SelectAll":"Zaznacz Wszystko","Columnchooser":"Kolumny","ClearFilter":"Wyczyść filtry","NoResult":"Brak wyników","EnterValue":"Wstaw wartość","ChooseDate":"Wybierz datę","GreaterThan":"Większe Niż","GreaterThanOrEqual":"Większe lub Równe Niż","LessThan":"Mniejsze Niż","LessThanOrEqual":"Mniejsze lub Równe Niż","NotEqual":"Nie Równe","Equal":"Równe","Contains":"Zawiera","StartsWith":"Zaczyna się od","EndsWith":"Kończy się na","ClearButton":"Wyczyść","FilterButton":"Przefiltruj","Csvexport":"CSV Eksport","Excelexport":"Excel Eksport","Pdfexport":"PDF Eksport","search":"Wyszukaj","items":"Elementów","item":"Element","emptyRecord":"Brak elementów do wyświetlenia","Country":"Kraj","SystemStatusInfo":"Status Systemu","Status":"Status","HighLevelAlarm":"Ważne Alarmy","MidLevelAlarm":"Średnie Alarmy","LowLevelAlarm":"Niskie Alarmy","Blackbox":"Blackbox","Weight alarm":"Alarm wagi","Max manger weight alarm":"Alarm maksymalnej wagi karmnika","Loadcell data alarm":"Alarm danych loadcelli","Photocell not covered in the last 24h":"Fotocela nie zakryta przez 24godz.","Manger long low weight alarm":"Karmnik pusty przez długi czas","Animal weight drastically changed.":"Waga zwierzęcia diametralnie się zmieniła","Loading in down state alarm":"Napełnianie karmnika przy otwartej bramce","Floating cell alarm":"Alarm 'pływającej wagi'","Abnormal gate state alarm":"Alarm nieprawidłowego stanu bramy","Wagon alarm":"Alarm wagonu","Photocell alarm":"Alarm fotoceli","Missing log, no log between two visit alarm":"Brakujący log, brak loga między dwoma wizytami alarmowymi","Loadcell error code alarm":"Alarm kodu błędu ogniwa obciążnikowego","Communication, quality alarm":"Komunikacja, alarm sygnału","Sync alarm":"Alarm synchronizacji","Low disk space (below 10GB)":"Mało miejsca na dysku (mniej niż 10GB)","Animal not eat":"Zwierzę nie jadło","Communication, no communication alarm":"Komunikacja, alarm braku komunikacji","Low pressure in system alarm":"Niskie ciśnienie w systemie","Systems":"Systemy","FullName":"Imię i nazwisko","Description":"Opis","SystemName":"Nazwa Systemu","AddSystem":"Dodaj System","EditSystem":"Edytuj System","GenerateReport":"Generuj Raport","Devices":"Urządzenia","Services":"Serwisy","Alarms":"Alarmy","Charts":"Wykresy","Settings":"Ustawienia","Messages":"Wiadomości","today":"dziś","daysAgo":"dni temu","Unit":"WSS","Type":"Typ","AlarmType":"Typ Alarmu","CreateDate":"Data Stworzenia","EndDate":"Data Końca","ShowGraph":"Pokaż Wykres","Visits":"Wizyty","Priority":"Priorytet","7daysAgo":"7 dni temu","Today":"Dziś","Details":"Szczegóły","GENERAL":"OGÓLNE","DEVICES":"URZĄDZENIA","ROUGHAGE":"KARMNIKI","SORTING":"SORTOWNICA","STATISTICS":"STATYSTYKI","PROBLEMS":"PROBLEMY","TICKETS":"WIADOMOŚCI","High":"Wysoki","Mid":"Średni","Low":"Niski","UpdateDate":"Data aktualizacji","DelayLog":"Opóźnienie loga","Dec.Value":"Dec. Value","Inc.Value":"Inc. Value","DelayOpen":"Opóźnienie otwarcia","StabilizationGap":"Przerwa w stabilizacji","MinMangerWeight":"Min. waga karmnika","CalibrationWeight":"Waga kalibracji","MaxEatingSpeed":"Max. prędkość jedzenia","NoControlOfLogBelow":"Brak loga kontroli ponizej","StabilizationTime":"Czas stabilizacji","WagonAutoCloseTime":"Czas autozamknięcia po wagonie","NumberOfDevices":"Liczba karmników","SoftwareVersionUi":"Wersja software - UI","SoftwareVersionAPI":"Wersja software - API","SoftwareVersionBlackBox":"Wersja software - BlackBox","SoftwareVersionDiagnostic":"Wersja software - Diagnostic","SoftwareVersionSystem":"Wersja software - System","NumberOfAlarmsToday":"Liczba alarmów dzisiaj","NumberOfAlarmsYesterday":"Liczba alarmów wczoraj","InstallationDate":"Data instalacji","UnderWarranty":"Gwarancja","ServiceAgreement":"Umowa serwisowa","ExternalAccess":"Dostęp zdalny","Platform":"Platforma","Login":"Login","Password":"Hasło","Add":"Dodaj","EditPassword":"Edytuj Hasło","Photos":"Zdjęcia","SystemAddress":"Adres systemu","Number":"Numer","Mode":"Tryb","Software":"Wersja","SoftwareDownloads":"Pobieranie oprogramowania","SoftwareVersions":"Wersje","AddShortcut":"Dodaj skrót","EditShortcut":"Edytuj skrót","DeleteShortcut":"Usuń skrót","ShortcutName":"Nazwa","NoShortcuts":"Nie dodano jeszcze żadnych skrótów.","NoVersionAvailable":"Brak stabilnej wersji","Icon":"Ikona","NoIcon":"Brak ikony","SelectIcon":"Wybierz ikonę","RemoveIcon":"Usuń","IconTooLarge":"Ikona musi być mniejsza niż 1MB.","ShortcutRequiredFields":"Nazwa, produkt i platforma są wymagane.","Product":"Produkt","Architecture":"Architektura","Download":"Pobierz","DownloadProgress":"Postęp pobierania","Preparing":"Przygotowywanie","DropFileOrBrowse":"Upuść plik tutaj lub kliknij, aby wybrać","AllowedFileTypes":"Dozwolone","ClickOrDropToReplace":"kliknij lub upuść, aby zmienić","RemoveFile":"Usuń plik","InvalidFileType":"Nieobsługiwany typ pliku","Calibration":"Kalibracja","Photocell":"Fotocela","Loadcell":"Ogniwo obciążnikowe","Connection":"Połączenie","ErrorLogs":"Błędne Logi","Lid":"Pokrywa","Tilt":"Przechylenie","InitPhotodelay":"Wstępne opóźnienie fotoceli","Photodelay":"Opóźnienie fotoceli","AutoTaraTimer":"Czas autotary","AutoTaraWeight":"Automatyczna waga tary","AnimalWeightCalibration":"Kalibracja wagi zwierzęcia","ErrorGate":"Błąd bramki","NoDecisionTime":"Czas braku decyzji","SprayTime":"Czas sprayowania","MinWeightOnPlatform":"Min waga na platofrmie","WeightTime":"Czas ważenia","SortingMode":"Tryb sortowania","SortByWeightRanges":"Sortowanie po zakresach wagi","SettingsSorting":"Ustawienia sortowania","totalItemInfo":"({0} elementów)","Date":"Data","Logs":"Logi","WeightLogsCount":"Liczba logów wagi","OtherReasonLogs":"Liczba innych logów","Statistics":"Statystyki","Title":"Tytuł","ReportedDate":"Data zgłoszenia","ResolvedDate":"Data wykonania","Incomplete":"Niekompletne","Under Observation":"Pod obserwacją","Pending For Spares":"Wymagane części","Complete":"Zakończone","AddProblem":"Dodaj Problem","EditProblem":"Edytuj Problem","LastMessageDate":"Data ostatniej wiadomości","LastMessageFrom":"Ostatni nadawca","Subject":"Temat","AddVisit":"Dodaj wizytę","EditVisit":"Edytuj wizytę","Assignee":"Os. Odpowiedzialna","DateFrom":"Data Od","DateTo":"Data Do","System":"System","Problems":"Problemy","Solutions":"Rozwiązania","CreatedBy":"Stworzone Przez","ProblemTitle":"Tytuł problemu","SystemStatusCheck":"Status systemu","Created":"Stworzono","Resolved":"Rozwiązano","AddSolution":"Dodaj rozwiązanie","EditSolution":"Edytuj rozwiązanie","AddContact":"Dodaj Kontakt","Contacts":"Kontakty","UserName":"Nazwa użytkownika","Role":"Rola","AccessToSystem":"Dostęp do systemów","SystemGroups":"Dostęp do grup","AddUser":"Dodaj użytkownika","Users":"Użytkownicy","ExpirationDate":"Data wygaśnięcia","Invitations":"Zaproszenia","AddInvitation":"Dodaj zaproszenie","ADD_INVITATION":"DODAJ ZAPROSZENIE","EDIT_INVITATION":"EDYTUJ ZAPROSZENIE","DELETE_INVITATION":"USUŃ ZAPROSZENIE","ENABLE_INVITATION":"AKTYWUJ ZAPROSZENIE","DISABLE_INVITATION":"DEZAKTYWUJ ZAPROSZENIE","AreYouSureEnable":"Na pewno chcesz aktywować?","AreYouSureDisable":"Na pewno chcesz dezaktywować?","Enable":"Aktywuj","Disable":"Dezaktywuj","DeleteInvitation-":"Usuń zaproszenie - {0}","EnableInvitation-":"Aktywuj zaproszenie - {0}","DisableInvitation-":"Dezaktywuj zaproszenie - {0}","FirstName":"Imię","LastName":"Nazwisko","EmailsLanguage":"Języka emaila","AccessToSystems":"Dostęp do systemów","AccessByGroups":"Dostęp do grup","Groups":"Grupy","Surname":"Nazwisko","Save":"Zapisz","PINtoConfirm":"Wprowadź PIN aby zatwierdzić","Cancel":"Anuluj","Confirm":"Potwierdź","AreYouSureDelete":"Na pewno chcesz usunąć?","SelectSystem":"Wybierz system aby kontyuować.","Ok":"Ok","ADD_SYSTEM":"DODAJ SYSTEM","EDIT_SYSTEM":"EDYTUJ SYSTEM","SYSTEM_INFORMATION":"INFORMACJE O SYSTEMIE","SystemType":"Typ Systemu","Address":"Adres","SystemGroup":"Grupa Systemu","Problem":"Problem","Gallery":"Galeria","Graph":"Wykres","STATUS":"STATUS","PER_DEVICE":"URZĄDZENIAMI","NoAlarmsInRange":"Brak alarmów w aktualnym zakresie","AllAlarmTypes":"Wszystkie typy alarmów","ResetPassword":"Zresetuj Hasło","USER_INFORMATION":"INFORMACJE O UŻYTKOWNIKU","ChangePassword":"Zmień Hasło","City":"Miasto","EditProfile":"Edytuj Profil","SelectFarmBeforeSaving":"Wybierz farmę przed zapisaniem.","SelectSystemBeforeSaving":"Wybierz system przed zapisaniem.","SelectDeviceBeofreSaving":"Wybierz lub wpisz urządzenie przed zapisaniem.","SelectTitleBeforeSaving":"Wybierz lub wpisz tytuł przed zapisaniem.","SelectDescriptionBeforeSaving":"Wybierz lub wpisz opis przed zapisaniem.","FieldName":"Nazwa Pola","Value":"Wartość","LeftTare":"Lewa Tara","LeftCalibration":"Lewa Kalibracja","RightTare":"Prawa Tara","RightCalibration":"Prawa Kalibracja","Tare":"Tara","TareCalibration":"Kalibracja Tary","Version":"Wersja","WhichAlarmsPriorityChoose":"Który priorytet alarmów wybierasz?","ReportDate":"Data raportu","Generate":"Generuj","OptionsSelected":"wybrane opcje","Now":"Teraz","Yesterday":"Wczoraj","Last7Days":"Ostatnie 7 dni","PROBLEMSTATUS":"STATUS PROBLEMU","UNDEROBSERVATION":"POD\nOBSERWACJĄ","PENDINGFORSPARES":"WYMAGANE\nCZĘŚCI","Problem/Suggestion":"Problem/Sugestia","RequiredSpareParts":"Wymagane części zamienne","Notes":"Notatki","WhatWasDone":"Co zostało zrobione","SystemCheck":"Kontrola systemu","FurtherWork":"Dalsze prace","ADDREMOTEACCESS":"DODAJ ZDALNY DOSTĘP","REMOTEACCESS":"ZDALNY DOSTĘP","Show":"Pokaż","SelectElement":"Wybierz element aby kontyuować.","SHOWPASSWORD":"Pokaż hasło","DELETEREMOTEACCESS":"USUŃ ZDALNY DOSTĘP","EDITPASSWORD":"EDYTUJ HASŁO","ShowPassword":"Pokaż hasło","Pin":"Pin","CurrentPassword":"Bieżące hasło","NewPassword":"Nowe hasło","Close":"Zamknięty","Open":"Otwarty","Up":"W górę","Down":"W dół","Normal":"Normalny","Restricitve":"Restrykcyjny","FreeAccess":"Wolny dostęp","StatusAlarms":"Status Alarmów","SettingsRoughage":"Ustawienia Karmników","OnlySortByAnimalSettings":"Tylko sortuj według ustawień zwierząt","WeighAndSortByAnimalSettings":"Waż i sortuj według ustawień zwierząt","WeightAndSortByWeightRange":"Waż i sortuj po zakresach wagi","From":"Od","to":"do","goToGate":"idź do bramki","Over":"Ponad","CrossReadingLogs":"Liczba logów czytania krzyżowego","OtherTagInAntennaLogs":"Liczba logów inny tag w antenie","Creator":"Twórca","ProblemInfo":"Informacje o problemie","DeviceName":"Nazwa Urządzenia","Visit":"Wizyta","WorkDone":"Prace zrobione","MainAssignee":"Główna Os. Odpowiedzialna","PreviewSolution":"Podgląd Rozwiązania","VisitInfo":"Informacje o wizycie","EditUser":"Edytuj Użytkownika","DeleteUser":"Usuń Użytkownika","EditContact":"Edytuj Kontakt","CONTACTINFORMATION":"INFORMACJE O KONTAKCIE","DeleteContact":"Usuń Kontakt","ShowChat":"Pokaż chat","CloseTicket":"Zamknij","AreYouSureYouWantToCloseThisTicket":"Na pewno chcesz zamknąć?","Client":"Klient","You":"Ty","Send":"Wyślij","FIT_EVERYTHING":"RESETUJ MAPĘ","FIT_MAP_TO_SHOW_ALL":"ODDAL MAPĘ I POKAŻ WSZYSTKIE SYSTEMY","Map":"Mapa","Dashboard":"Tablica","AlarmsCRFI":"Alarmy CRFI","AlarmsMonitoring":"Alarmy Monitoringu","ADD_ALARM_RULE":"Dodaj nową zasadę alarmów","TurnOffFarm":"Wyłącz farmę","AlarmsTurnedOff":"Wyłączone Alarmy","AlarmNumber":"Numer Alarmu","AlarmName":"Nazwa Alarmu","Options":"Opcje","AreYouSureTurnOffFarm":"Jesteś pewien, że chcesz wyłączyć farmę?","AreYouSureTurnOnFarm":"Jesteś pewien, że chcesz włączyć farmę?","TURN_FARM_ON":"WŁĄCZ SYSTEM","TURN_ON":"WŁĄCZ","TURN_FARM_OFF":"WYŁĄCZ SYSTEM","TurnOnAlarms":"Włącz wszystkie alarmy","TurnOnFarm":"Włączyć wszystkie alarmy?","AreYouSureTurnOnAllSystemAlarms":"Jesteś pewien, że chcesz włączyć wszystkie alarmy?","Tasks":"Zadania","Tickets":"Wiadomości","Roughage":"Karmniki","Sorting":"Sortownice","General Alarms":"Alarmy Ogólne","TurnOn":"Włącz","AddRule":"Dodaj zasadę","Weight under min. open level":"Waga poniżej poziomu otwarcia","Animal Eaten Too Much":"Zwierzę zjadło za dużo","LoadcellError":"Błąd ogniwa obciążnikowego","DlcRight":"DLC Prawe","DlcLeft":"DLC Lewe","UnderAlarmLevelTime":"Czas poniżej poziomu alarmu","NoRapidLogTime":"Czas bez rapidlogów","CorrectPercent":"Poprawne (%)","WeekResult":"7 dni przed (Poprawnych/Łącznie)","TodayResult":"Dziś (Poprawnych/Łącznie)","UnderMinOpenLevelTime":"Czas poniżej poziomu otwarcia","DeviceAlarms":"Alarmy Urządzeń","NothingSelected":"Nic nie jest zaznaczone.","LastCheckup":"Ostatnia Kontrola","LastCheckupDate":"Data ostatniej kontroli","LastCheckupPerson":"Osoba przeprowadzająca ostatnią kontrolę","Checkup":"Kontrola","TO_CHECKUP":"DO KONTROLI","SetAsChecked":"Ustaw jako sprawdzone","TheSettingHasBeenSaved":"Zapisano","UnknownAnimalWeightLogsCount":"Wagi Nieznanych Zwierząt","UnknownAnimalWeightAlarmPercent":"Procent alarmów nieznanych zwierząt","ErrorLogsChecked":"Błędne Logi / Sprawdzono","errorLogsCheckedTT":"Pokaż błędy z dziś i 3 dni wcześniej.","AssigneeNotSelected":"Wybierz osobę odpowiedzialną","SubjectNotFilled":"Temat nie może być pusty.","ContentNotFilled":"Treść nie może być pusta.","CalibrationDateErrorAfterDays":"Calibration Date Error After Days","Animals":"Zwierzęta","ShowResolvedTasks":"Pokaż zakończone zadania","ShowUnresolvedTasks":"Pokaż nowe zadania","leftAxis":"Lewa oś","rightAxis":"Prawa oś","noDataFromSensors":"BRak danych z sensorów","Loading":"Ładowanie danych","Reload":"Odśwież","Ram":"Dostępna pamięć RAM (GB)","Temperature":"Temperatura procesora (°C)","rightMovingAvg":"Rozmiar ramki prawej osi","leftMovingAvg":"Rozmiar ramki lewej osi","Apply":"Zatwierdź","AnimalEatingButNotWeighed":"Zwierzę jadło i nie było zważone","AnimalAteOverLimit":"Zwierzę zjadło ponad limit","UnknownEatingAnimal":"Nieznane jedzące zwierzę","UnknownBTransponder":"Nieznany BTransponder","RefillWithoutUp":"Uzupełnienie mangera bez zamknięcia gate","AnimalTooManyWeightErrorLogs":"Zwierzę ma za dużo błędnych logów wagi","LowPressure":"Niskie ciśnienie","AnimalNotEat":"Zwierzę nie jadło","UnknownWeightedAnimal":"Nieznane zważone zwierzę","LowPressureDaily":"Dzienne niskie ciśnienie","VisitProblem":"Problem z wizytą","DismissMany":"Odrzuć zaznaczone","DISMISS_ALARMSMANY":"Odrzuć Alarmy","DISMISS_ALARMS":"Odrzuć Alarm","DELETEBACKUP":"USUŃ KOPIĘ ZAPASOWĄ","CopyLink":"Skopiuj link","Weights":"Wagi","Cloud":"Chmura","Requirements":"Wymagania","Backups":"Kopie zapasowe","Copied":"Skopiowano","ReceivedDate":"Data otrzymania","FileSize":"Rozmiar pliku","Yes":"Tak","No":"Nie","ScheduledReports":"Raporty e-mail","AddScheduledReport":"Dodaj raport","EditScheduledReport":"Edytuj raport","DeleteScheduledReport":"Usuń raport","ReportName":"Nazwa raportu","ReportNameRequired":"Nazwa raportu jest wymagana.","Frequency":"Cykl","Daily":"Codziennie","Weekly":"Co tydzień","Monthly":"Co miesiąc","SendTime":"Godzina wysyłki","DayOfWeek":"Dzień tygodnia","DayOfMonth":"Dzień miesiąca","ReportLanguage":"Język raportu","Recipients":"Odbiorcy","ExternalEmails":"Adresy zewnętrzne","AddEmail":"Dodaj","ReportScope":"Zakres","PreviewReport":"Podgląd","SendNow":"Wyślij teraz","SentToRecipients":"Wysłano do odbiorców","LastSent":"Ostatnia wysyłka","NextRun":"Najbliższa wysyłka","Active":"Aktywny","InvalidEmail":"Niepoprawny adres e-mail.","SelectAtLeastOneRecipient":"Wybierz co najmniej jednego odbiorcę.","SelectAtLeastOneSystemOrGroup":"Wybierz co najmniej jeden system lub grupę.","PeriodHintDaily":"Raport obejmuje poprzedni dzień.","PeriodHintWeekly":"Raport obejmuje poprzednie 7 dni.","PeriodHintMonthly":"Raport obejmuje poprzedni miesiąc kalendarzowy.","PeriodHintDailySkipWeekends":"Raport obejmuje poprzedni dzień, a w poniedziałek zbiorczo piątek, sobotę i niedzielę.","PeriodHintSkipWeekends":"Wysyłka wypadająca w sobotę lub niedzielę zostanie przeniesiona na poniedziałek.","SkipWeekends":"Pomijaj weekendy","WithoutWeekends":"bez weekendów","Monday":"Poniedziałek","Tuesday":"Wtorek","Wednesday":"Środa","Thursday":"Czwartek","Friday":"Piątek","Saturday":"Sobota","Sunday":"Niedziela","Retry":"Spróbuj ponownie","NoSystemsWithWeight":"Brak systemów z wagą stada","SystemsLoadFailed":"Nie udało się pobrać listy systemów","HerdWeightNoData":"Brak danych wagowych","HerdWeightLoadFailed":"Nie udało się wczytać wykresu","Notifications":"Powiadomienia","Recipient":"Odbiorca","Sent":"Wysłane","Waiting":"Oczekuje","NotificationTypeNewTask":"Nowe zadanie","NotificationTypeClosedTask":"Zamknięcie zadania","NotificationTypeResponseToTask":"Wiadomość w zadaniu","NotificationTypeAnimalDidNotEat":"Zwierzę nie jadło","NotificationTypeNewAlarm":"Nowy alarm","Processed":"Przetworzone","NotificationsStatusHint":"Status pokazuje, co stało się z powiadomieniem: wysłane do FCM, ponawiane po błędzie, odrzucone albo świadomie pominięte. Wiersze sprzed wdrożenia statusów są oznaczone jako przetworzone.","NotificationsSendResult":"W kolejce: {pending}, wysłane: {sent}, nieudane: {failed}, odrzucone: {rejected}, pominięte: {skipped}","SendNowFailed":"Nie udało się uruchomić wysyłki","NotificationStatusPending":"Oczekuje","NotificationStatusSent":"Wysłane","NotificationStatusFailed":"Błąd (ponawiane)","NotificationStatusFailedPermanently":"Błąd (bez ponawiania)","NotificationStatusSkippedStale":"Przeterminowane","NotificationStatusSkippedNoRecipient":"Brak odbiorcy","NotificationStatusSkippedNoSystem":"Brak systemu","NotificationStatusSkippedAlreadyRead":"Przeczytane w przeglądarce","NotificationStatusSkippedSeenInApp":"Odczytane w aplikacji","NotificationStatusLegacyProcessed":"Przetworzone (przed wdrożeniem statusów)","SentAt":"Data wysyłki","NotificationError":"Błąd","NotificationsFailedCount":"Nieudane: {count}","AddTicket":"Dodaj zgłoszenie","AssigneeName":"Przypisany","LastMessage":"Ostatnia wiadomość","ShowAllTickets":"Pokaż wszystkie","ShowActiveTickets":"Pokaż aktywne","SelectTicket":"Wybierz zgłoszenie, aby zobaczyć rozmowę","TicketStatusNew":"Nowe","TicketStatusOngoing":"W toku","TicketStatusWaitingForApprove":"Prośba o zamknięcie","TicketStatusRejected":"Zamknięcie odrzucone","TicketStatusClosed":"Zamknięte","TicketEventRequestedClose":"Poproszono o zamknięcie zgłoszenia","TicketEventClosed":"Zgłoszenie zamknięte","TicketEventConfirmedClose":"Zamknięcie zatwierdzone","TicketEventCloseDenied":"Prośba o zamknięcie odrzucona","CloseTicketButton":"Zamknij zgłoszenie","CloseTicketConfirm":"Zamknąć zgłoszenie?","TicketCloseRequested":"Rolnik prosi o zamknięcie zgłoszenia","Accept":"Akceptuj","Deny":"Odrzuć","TicketClosedInfo":"Zgłoszenie jest zamknięte","WriteMessage":"Napisz wiadomość…","AttachPhotos":"Dołącz zdjęcia","Remove":"Usuń","Back":"Wstecz","Sending":"Wysyłanie…","MessageNotSent":"Nie wysłano.","TryAgain":"Spróbuj ponownie","NoMessages":"Brak wiadomości","LoadingMessagesFailed":"Nie udało się wczytać wiadomości.","DropPhotosHere":"Upuść zdjęcia, aby je dołączyć","VersionAvailable":"Dostępna","VersionUnavailable_NoFileName":"Brak nazwy pliku","VersionUnavailable_NoFileName_Hint":"Wersja nie ma przypisanego pliku. Edytuj ją i wgraj plik.","VersionUnavailable_NotUploaded":"Plik niewgrany","VersionUnavailable_NotUploaded_Hint":"Brak sumy SHA-256 – plik nie został wgrany albo wgrywanie się nie powiodło. Edytuj wersję i wgraj plik ponownie.","VersionUnavailable_FileMissing":"Brak pliku na serwerze","VersionUnavailable_FileMissing_Hint":"Suma kontrolna jest zapisana, ale pliku nie ma na dysku serwera. Edytuj wersję i wgraj plik ponownie.","Missing Animal Weight":"Brak wagi zwierzęcia","Weight under alarm level":"Waga poniżej poziomu alarmowego","Unknown Eating Animal":"Nieznane zwierzę jadło","Unknown Animal":"Nieznane zwierzę","Unknown Weighted Animal":"Nieznane zważone zwierzę","Daily Low Pressure":"Dzienne niskie ciśnienie","Animal Eating But Not Weighed":"Zwierzę jadło, ale nie zostało zważone","Animal Eating But Not Weighed ":"Zwierzę jadło, ale nie zostało zważone","Loadcell Data Out Of Range":"Dane ogniwa obciążnikowego poza zakresem","Refill Without Up":"Uzupełnienie karmnika bez bramki w górze","Loadcell Dlc Error Time":"Czas błędu DLC ogniwa obciążnikowego","Unknown BTransponder":"Nieznany BTransponder","Animal Ate Over Limit":"Zwierzę zjadło ponad limit","Animal Too Many Weight Error Logs":"Zwierzę ma za dużo błędnych logów wagi","Weight Device Too Many Error Logs":"Waga ma za dużo błędnych logów","USB Pendrive":"Pendrive USB","No Delpro Sync":"Brak synchronizacji z Delpro","Cloud Login":"Logowanie do chmury","Too Many Error Logs Alarm":"Za dużo błędnych logów","Temperature Alarm":"Alarm temperatury","Weight Device No Visits":"Brak wizyt na wadze","Animal Weight Difference Between Devices":"Różnica wagi zwierzęcia między urządzeniami","Herd Weight":"Waga stada","No Antenna Readings":"Brak odczytów anteny","Manger Too Long In Down":"Karmnik zbyt długo w pozycji dolnej","Manger Too Long In Up":"Karmnik zbyt długo w pozycji górnej","Weight Device Visits Dropped":"Spadek liczby wizyt na wadze","CloudNoVisits":"Brak wizyt w chmurze","WagonSensor":"Czujnik wózka","Communication":"Komunikacja","AlarmMangerTooLongInDown":"Karmnik zbyt długo w pozycji dolnej","AlarmMangerTooLongInUp":"Karmnik zbyt długo w pozycji górnej","AlarmNoAntennaReadings":"Brak odczytów anteny","Loadcell ErrorCode":"Kod błędu ogniwa obciążnikowego","LoadcellErrorTime":"Czas błędu ogniwa obciążnikowego","AbnormalVisit":"Nietypowa wizyta","MissingLog":"Luka w wadze / brakujący log","TooManyErrorLogs":"Za dużo błędnych logów","Weight":"Waga","WeightTooManyErrorLogs":"Waga ma za dużo błędnych logów","WeightDeviceNoVisits":"Brak wizyt na wadze","WeightVisitsDrop":"Spadek liczby wizyt na wadze","AlarmHerdWeight":"Waga stada","CowWeight":"Waga zwierzęcia drastycznie się zmieniła","MissingAnimalWeight":"Brak wagi zwierzęcia","AnimalWeightDiffBetweenDevices":"Różnica wagi zwierzęcia między urządzeniami","NoDelproSynchronization":"Brak synchronizacji z Delpro","LowSpace":"Mało miejsca na dysku","UnknownAnimal":"Nieznane zwierzę","Cloud Login!":"Błąd logowania do chmury!","ClientId":"ID klienta","SelectAlarmToDisable":"Wybierz alarm do wyłączenia","NewRules":"Nowe reguły","DismissAlarms":"Odrzuć alarmy","Annotation":"Adnotacja","SENSORS":"CZUJNIKI","New problems":"Nowe problemy","Content":"Treść","Report":"Raport","PendingProblems":"Oczekujące problemy","ActiveProblems":"Aktywne problemy","MoreInfo":"Więcej informacji","PasswordToConfirm":"Wpisz hasło, aby potwierdzić","Last7days":"Ostatnie 7 dni","Last10days":"Ostatnie 10 dni","ThisMonth":"Ten miesiąc","LastMonth":"Poprzedni miesiąc","Last3Months":"Ostatnie 3 miesiące","January":"Styczeń","February":"Luty","March":"Marzec","April":"Kwiecień","May":"Maj","June":"Czerwiec","July":"Lipiec","August":"Sierpień","September":"Wrzesień","October":"Październik","November":"Listopad","December":"Grudzień","Jan":"Sty","Feb":"Lut","Mar":"Mar","Apr":"Kwi","MayShort":"Maj","Jun":"Cze","Jul":"Lip","Aug":"Sie","Sep":"Wrz","Oct":"Paź","Nov":"Lis","Dec":"Gru","Sun":"Nd","Mon":"Pn","Tue":"Wt","Wed":"Śr","Thu":"Cz","Fri":"Pt","Sat":"So","Su":"Nd","Mo":"Pn","Tu":"Wt","We":"Śr","Th":"Cz","Fr":"Pt","Sa":"So","Farm":"Farma","SelectDeviceBeforeSaving":"Wybierz lub wpisz urządzenie przed zapisaniem.","years":"lat","day":"dzień","CRFIVersions":"Wersje CRFI","DownloadPack":"Pobierz pakiet","Components":"Komponenty","DownloadWSS":"Pobierz WSS","DownloadLTC":"Pobierz LTC","DownloadBlackBox":"Pobierz BlackBox","NotFound":"Nie znaleziono","Herd weight":"Waga stada","SyncTodayResult":"Synchronizacja dziś (poprawne/wszystkie)","No animals to display":"Brak zwierząt do wyświetlenia","Select an animal to see details":"Wybierz zwierzę, aby zobaczyć szczegóły","DismissDate":"Data odrzucenia","SaveAlarms":"Zapisz alarmy","INSERT_PIN":"WPISZ PIN","enterPin":"Wpisz PIN, aby pokazać hasło","RESET_PASSWORD":"RESETUJ HASŁO","reset_password":"Wysłać temu użytkownikowi link do zresetowania hasła?","DoneDuringVisit":"Wykonane podczas wizyty","PlannedFrom":"Zaplanowano od","PlannedTo":"Zaplanowano do","Started":"Rozpoczęto","Ended":"Zakończono","Pending":"Oczekuje","Finished":"Zakończona","CONTACT_PERSON":"OSOBA KONTAKTOWA","FARM_OWNER":"WŁAŚCICIEL FARMY","RepeatNewPassword":"Powtórz nowe hasło","Comment":"Komentarz","ConfirmPassword":"Potwierdź hasło","Transponder":"Transponder","LastVisit":"Ostatnia wizyta","Discontinued":"Wycofany","DeleteConfiguration":"Usuń konfigurację","CookiesText":"BioControl prosi o zgodę na pliki cookie służące do pomiaru wydajności serwisu. Aby dowiedzieć się więcej lub zmienić ustawienia, kliknij „Więcej informacji” albo wybierz „Ustawienia cookie” na dole strony. Więcej o plikach cookie i przetwarzaniu danych osobowych znajdziesz w Polityce prywatności i Polityce cookie. Czy akceptujesz te pliki cookie i związane z nimi przetwarzanie danych osobowych?","CookieSettings":"Ustawienia cookie","MoreInformation":"Więcej informacji","CookiesChangeSettings":"Ustawienia możesz zmienić w każdej chwili na","CookiesThisPage":"tej stronie","CookiesPolicyDetails":"Szczegóły znajdziesz w Polityce prywatności RODO i Polityce cookie.","WeightAndSortByAnimalSettings":"Waż i sortuj według ustawień zwierząt","CheckedLogs":"Sprawdzone logi","ghostUnknownAnimalsTT":"Pokazuje wartości z dziś i 3 dni wstecz.","GhostUnknownAnimals":"Zwierzęta widma / nieznane","GhostAnimals":"Zwierzęta widma","UnknownAnimals":"Nieznane zwierzęta","WeightErrorLogsChecked":"Błędne logi wagi / sprawdzone","weightErrorLogsCheckedTT":"Pokazuje wartości z dziś i 3 dni wstecz.","AssignedSystems":"Przypisane systemy","AddSystems":"Przypisz systemy","AddServer":"Dodaj konfigurację serwera","HerdIdentifier":"Identyfikator stada","ProducerNumber":"Numer producenta","ADD_SYSTEMS_TO_SERVER":"Przypisz systemy do serwera","AddConfiguration":"Dodaj konfigurację","EditConfiguration":"Edytuj konfigurację","NEW_SERVER_CONFIG":"Nowa konfiguracja serwera","Dismiss":"Odrzuć","PROBLEM_ALARMS":"PROBLEM Z ALARMU","UnitNumber":"Numer jednostki","trendLine":"Linia trendu","Feeding":"Karmienie","CHECKUP":"PRZEGLĄD","SoftwareVersion":"Wersja","AddVersion":"Dodaj wersję","ChangeLog":"Lista zmian","VersionFile":"Plik wersji","Alarms Off":"Alarmy wyłączone","Off":"Wył.","On":"Wł.","UploadFailed":"Przesyłanie nie powiodło się. Zamknij","UploadProgress":"Przesyłanie pliku","DELETEVERSION":"USUŃ WERSJĘ","EditVersion":"Edytuj wersję","ChangeFile":"Zmień plik","Restart":"Uruchom ponownie","Never":"Nigdy","ErrorLogsTodayYesterday7Days":"Błędne logi dziś / wczoraj / 7 dni","errorLogsTodayYesterday7DaysTT":"Pokazuje wartości z dziś / wczoraj / ostatnich 7 dni.","WeightErrorLogsTodayYesterday7Days":"Błędne logi wagi dziś / wczoraj / 7 dni","weightErrorLogsTodayYesterday7DaysTT":"Pokazuje wartości z dziś / wczoraj / ostatnich 7 dni.","DELETEREQUIREMENT":"USUŃ WYMAGANIE","AddRequirement":"Dodaj wymaganie","EditRequirement":"Edytuj wymaganie","MaxSupportedVersion":"Maks. obsługiwana wersja","MaxVersion":"Maks. wersja","Program":"Aplikacja","IsTestVersion":"Wersja testowa","IsBeta":"Beta","Beta":"Wersja beta","LoginHeadline":"Monitoruj swoją farmę.","LoginSubline":"Sprawdzaj stan farmy wygodnie, gdziekolwiek jesteś.","SignIn":"Zaloguj się","SignOn":"Zarejestruj się","or":"lub","FIRST_NAME":"IMIĘ","LAST_NAME":"NAZWISKO","E_MAIL":"E-MAIL","PASSWORD":"HASŁO","CONFIRM_PASSWORD":"POTWIERDŹ HASŁO","EnterFirstName":"Wpisz imię","EnterLastName":"Wpisz nazwisko","EnterEmail":"Wpisz e-mail","EnterPassword":"Wpisz hasło","ConfirmYourPassword":"Potwierdź hasło","IAgreeStatements":"Akceptuję wszystkie postanowienia","TermsOfService":"regulaminu","AlreadyMember":"Mam już konto","GdprPrivacyPolicy":"Polityka prywatności RODO","CookiePolicy":"Polityka cookie","LoginIncorrect":"Nieprawidłowy login lub hasło.","UnauthorizedRole":"Brak uprawnień dla tej roli","EmailRequired":"E-mail jest wymagany.","EmailInvalid":"Nieprawidłowy format adresu e-mail.","PasswordRequired":"Hasło jest wymagane.","PasswordRules":"Hasło musi zawierać co najmniej jedną małą i wielką literę, cyfrę i znak specjalny.","ConfirmPasswordRequired":"Potwierdzenie hasła jest wymagane.","FirstNameRequired":"Imię jest wymagane.","LastNameRequired":"Nazwisko jest wymagane.","Required":"Wymagane.","ApiUsage":"Użycie API","ApiUsageLayout":"Układ","ApiUsagePerUser":"Per użytkownik","ApiUsagePerEndpoint":"Per endpoint","ApiUsageEndpoint":"Endpoint","ApiUsageMethod":"Metoda","ApiUsageCalls":"Wywołania","ApiUsageErrors":"Błędy","ApiUsageAvgMs":"Śr. czas [ms]","ApiUsageMaxMs":"Maks. czas [ms]","ApiUsageEndpointsCount":"Endpointy","ApiUsageUsersCount":"Użytkownicy","ApiUsageLastSeen":"Ostatnio","ApiUsageCallsOverTime":"Wywołania w czasie","ApiUsageShowAll":"Pokaż wszystko","All":"Wszystkie","Roles":"Role"}

/***/ }),

/***/ 1492:
/***/ (function(module, exports) {

module.exports = {"ej2LocaleCulture":"no-NL","NAME":"1","Anonymous":"2","MAP":"3","DASHBOARD":"4","SYSTEMS":"5","ALARMS":"6","SERVICE":"7","USERS":"8","CONTACTS":"9","FAQ":"10","NoRole":"11","Admin":"12","Service":"13","User":"14","Profile":"15","Logout":"16","ALL_SYSTEMS":"17","ACTIVE_MONITORING":"18","WITHOUT_MONITORING":"19","WORKING_FINE":"20","WITH_ISSUES":"21","No_system_selected":"22","SystemStatus":"23","FarmName":"24","Group":"25","FarmAddress":"26","Name":"27","Responsibility":"28","PhoneNumber":"29","Email":"30","Contact":"31","ContactPerson":"32","FarmOwner":"33","BaseInfo":"34","GoToSystem":"35","General":"36","BlackBox":"37","Device":"38","Rapid24":"39","Rapid24h":"40","Photocells":"41","Pressure":"42","Database":"43","System Down":"44","System down":"45","Error":"46","Warning":"47","Working Fine":"48","LastUpdate":"49","Temperature":"50","FreeSpace":"51","Operational":"52","Free space alarm!":"53","days":"54","ago":"55","No Monitoring":"56","Edit":"57","Delete":"58","INVITATIONS":"59","NUMBER":"60","DESCRIPTION":"61","SEND_TO_MOBILE":"62","PRIORITY":"63","HIGH":"64","MID":"65","LOW":"66","totalItemsInfo":"({0} 67)","CancelButton":"68","pagerDropDown":"69","currentPageInfo":"{0} / {1} 70","OKButton":"71","ChooseColumns":"72","SelectAll":"73","Columnchooser":"74","ClearFilter":"75","NoResult":"76","EnterValue":"77","ChooseDate":"78","GreaterThan":"79","GreaterThanOrEqual":"80","LessThan":"81","LessThanOrEqual":"82","NotEqual":"83","Equal":"84","Contains":"85","StartsWith":"86","EndsWith":"87","ClearButton":"88","FilterButton":"89","Csvexport":"90","Excelexport":"91","Pdfexport":"92","search":"93","items":"94","item":"95","emptyRecord":"96","Country":"97","SystemStatusInfo":"98","Status":"99","HighLevelAlarm":"100","MidLevelAlarm":"101","LowLevelAlarm":"102","Blackbox":"103","Weight alarm":"104","Max manger weight alarm":"105","Loadcell data alarm":"106","Photocell not covered in the last 24h":"107","Manger long low weight alarm":"108","Animal weight drastically changed.":"109","Loading in down state alarm":"110","Floating cell alarm":"111","Abnormal gate state alarm":"112","Wagon alarm":"113","Photocell alarm":"114","Missing log, no log between two visit alarm":"115","Loadcell error code alarm":"116","Communication, quality alarm":"117","Sync alarm":"118","Low disk space (below 10GB)":"119","Animal not eat":"120","Communication, no communication alarm":"121","Low pressure in system alarm":"122","Systems":"123","FullName":"124","Description":"125","SystemName":"126","AddSystem":"127","EditSystem":"128","GenerateReport":"129","Devices":"130","Services":"131","Alarms":"132","Charts":"133","Settings":"134","Messages":"135","today":"136","daysAgo":"137","Unit":"138","Type":"139","AlarmType":"140","CreateDate":"141","EndDate":"142","ShowGraph":"143","Visits":"144","Priority":"145","7daysAgo":"146","Today":"147","Details":"148","GENERAL":"149","DEVICES":"150","ROUGHAGE":"151","SORTING":"152","STATISTICS":"153","PROBLEMS":"154","TICKETS":"155","High":"156","Mid":"157","Low":"158","UpdateDate":"159","DelayLog":"160","Dec.Value":"161","Inc.Value":"162","DelayOpen":"163","StabilizationGap":"164","MinMangerWeight":"165","CalibrationWeight":"166","MaxEatingSpeed":"167","NoControlOfLogBelow":"168","StabilizationTime":"169","WagonAutoCloseTime":"170","NumberOfDevices":"171","SoftwareVersionUi":"172","SoftwareVersionAPI":"173","SoftwareVersionBlackBox":"174","SoftwareVersionDiagnostic":"175","SoftwareVersionSystem":"176","NumberOfAlarmsToday":"177","NumberOfAlarmsYesterday":"178","InstallationDate":"179","UnderWarranty":"180","ServiceAgreement":"181","ExternalAccess":"182","Platform":"183","Login":"184","Password":"185","Add":"186","EditPassword":"187","Photos":"188","SystemAddress":"189","Number":"190","Mode":"191","Software":"192","Calibration":"193","Photocell":"194","Loadcell":"195","Connection":"196","ErrorLogs":"197","Lid":"198","Tilt":"199","InitPhotodelay":"200","Photodelay":"201","AutoTaraTimer":"202","AutoTaraWeight":"203","AnimalWeightCalibration":"204","ErrorGate":"205","NoDecisionTime":"206","SprayTime":"207","MinWeightOnPlatform":"208","WeightTime":"209","SortingMode":"210","SortByWeightRanges":"211","SettingsSorting":"212","totalItemInfo":"({0} 213)","Date":"214","Logs":"215","WeightLogsCount":"216","OtherReasonLogs":"217","Statistics":"218","Title":"219","ReportedDate":"220","ResolvedDate":"221","Incomplete":"222","Under Observation":"223","Pending For Spares":"224","Complete":"225","AddProblem":"226","EditProblem":"227","LastMessageDate":"228","LastMessageFrom":"229","Subject":"230","AddVisit":"231","EditVisit":"232","Assignee":"233","DateFrom":"234","DateTo":"235","System":"236","Problems":"237","Solutions":"238","CreatedBy":"239","ProblemTitle":"240","SystemStatusCheck":"241","Created":"242","Resolved":"243","AddSolution":"244","EditSolution":"245","AddContact":"246","Contacts":"247","UserName":"248","Role":"249","AccessToSystem":"250","SystemGroups":"251","AddUser":"252","Users":"253","ExpirationDate":"254","Invitations":"255","AddInvitation":"256","ADD_INVITATION":"257","EDIT_INVITATION":"258","DELETE_INVITATION":"259","ENABLE_INVITATION":"260","DISABLE_INVITATION":"261","AreYouSureEnable":"262","AreYouSureDisable":"263","Enable":"264","Disable":"265","DeleteInvitation-":"266 - {0}","EnableInvitation-":"267 - {0}","DisableInvitation-":"268 - {0}","FirstName":"269","LastName":"270","EmailsLanguage":"271","AccessToSystems":"272","AccessByGroups":"273","Groups":"274","Surname":"275","Save":"276","PINtoConfirm":"277","Cancel":"278","Confirm":"279","AreYouSureDelete":"280","SelectSystem":"281","Ok":"282","ADD_SYSTEM":"283","EDIT_SYSTEM":"284","SYSTEM_INFORMATION":"285","SystemType":"286","Address":"287","SystemGroup":"288","Problem":"289","Gallery":"290","Graph":"291","STATUS":"292","PER_DEVICE":"293","NoAlarmsInRange":"294","AllAlarmTypes":"295","ResetPassword":"296","USER_INFORMATION":"297","ChangePassword":"298","City":"299","EditProfile":"300","SelectFarmBeforeSaving":"301","SelectSystemBeforeSaving":"302","SelectDeviceBeofreSaving":"303","SelectTitleBeforeSaving":"304","SelectDescriptionBeforeSaving":"305","FieldName":"306","Value":"307","LeftTare":"308","LeftCalibration":"309","RightTare":"310","RightCalibration":"311","Tare":"312","TareCalibration":"313","Version":"314","WhichAlarmsPriorityChoose":"315","ReportDate":"316","Generate":"317","OptionsSelected":"318","Now":"319","Yesterday":"320","Last7Days":"321","PROBLEMSTATUS":"322","UNDEROBSERVATION":"323","PENDINGFORSPARES":"324","Problem/Suggestion":"325","RequiredSpareParts":"326","Notes":"327","WhatWasDone":"328","SystemCheck":"329","FurtherWork":"330","ADDREMOTEACCESS":"331","REMOTEACCESS":"332","Show":"333","SelectElement":"334","SHOWPASSWORD":"335","DELETEREMOTEACCESS":"336","EDITPASSWORD":"337","ShowPassword":"338","Pin":"339","CurrentPassword":"340","NewPassword":"341","Close":"342","Open":"343","Up":"344","Down":"345","Normal":"346","Restricitve":"347","FreeAccess":"348","StatusAlarms":"349","SettingsRoughage":"350","OnlySortByAnimalSettings":"351","WeightAndSortByAnimalSettings":"352","WeightAndSortByWeightRange":"353","From":"354","to":"355","goToGate":"356","Over":"357","CrossReadingLogs":"358","OtherTagInAntennaLogs":"359","Creator":"360","ProblemInfo":"361","DeviceName":"362","Visit":"363","WorkDone":"364","MainAssignee":"365","PreviewSolution":"366","VisitInfo":"367","EditUser":"368","DeleteUser":"369","EditContact":"370","CONTACTINFORMATION":"371","DeleteContact":"372","ShowChat":"373","CloseTicket":"374","AreYouSureYouWantToCloseThisTicket":"375","Client":"376","You":"377","Send":"378","FIT_EVERYTHING":"379","FIT_MAP_TO_SHOW_ALL":"380","Map":"381","Dashboard":"382","AlarmsCRFI":"383","AlarmsMonitoring":"384","ADD_ALARM_RULE":"385","TurnOffFarm":"386","AlarmsTurnedOff":"387","AlarmNumber":"389","AlarmName":"390","Options":"391","AreYouSureTurnOffFarm":"392","AreYouSureTurnOnFarm":"393","TURN_FARM_ON":"394","TURN_ON":"395","TURN_FARM_OFF":"396","TurnOnAlarms":"397","TurnOnFarm":"398","AreYouSureTurnOnAllSystemAlarms":"399","Tasks":"400","Tickets":"401","Roughage":"402","Sorting":"403","General Alarms":"404","TurnOn":"405","AddRule":"406","Weight under min. open level":"407","Animal Eaten Too Much":"408","LoadcellError":"409","DlcRight":"410","DlcLeft":"411","UnderAlarmLevelTime":"412","NoRapidLogTime":"413","CorrectPercent":"414","WeekResult":"415","TodayResult":"416","UnderMinOpenLevelTime":"417","DeviceAlarms":"418","NothingSelected":"419","LastCheckup":"420","LastCheckupDate":"421","LastCheckupPerson":"422","Checkup":"423","TO_CHECKUP":"424","SetAsChecked":"425","TheSettingHasBeenSaved":"426","UnknownAnimalWeightLogsCount":"427","UnknownAnimalWeightAlarmPercent":"428","ErrorLogsChecked":"429","errorLogsCheckedTT":"430","CheckedLogs":"431","ghostUnknownAnimalsTT":"432","GhostUnknownAnimals":"433","GhostAnimals":"434","UnknownAnimals":"435","WeightErrorLogsChecked":"436","weightErrorLogsCheckedTT":"437"}

/***/ }),

/***/ 1494:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1495:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1498:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export EffectScope */
/* unused harmony export computed */
/* unused harmony export createApp */
/* unused harmony export createRef */
/* unused harmony export customRef */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Plugin; });
/* unused harmony export defineAsyncComponent */
/* unused harmony export defineComponent */
/* unused harmony export del */
/* unused harmony export effectScope */
/* unused harmony export getCurrentInstance */
/* unused harmony export getCurrentScope */
/* unused harmony export h */
/* unused harmony export inject */
/* unused harmony export isRaw */
/* unused harmony export isReactive */
/* unused harmony export isReadonly */
/* unused harmony export isRef */
/* unused harmony export markRaw */
/* unused harmony export nextTick */
/* unused harmony export onActivated */
/* unused harmony export onBeforeMount */
/* unused harmony export onBeforeUnmount */
/* unused harmony export onBeforeUpdate */
/* unused harmony export onDeactivated */
/* unused harmony export onErrorCaptured */
/* unused harmony export onMounted */
/* unused harmony export onScopeDispose */
/* unused harmony export onServerPrefetch */
/* unused harmony export onUnmounted */
/* unused harmony export onUpdated */
/* unused harmony export provide */
/* unused harmony export proxyRefs */
/* unused harmony export reactive */
/* unused harmony export readonly */
/* unused harmony export ref */
/* unused harmony export set */
/* unused harmony export shallowReactive */
/* unused harmony export shallowReadonly */
/* unused harmony export shallowRef */
/* unused harmony export toRaw */
/* unused harmony export toRef */
/* unused harmony export toRefs */
/* unused harmony export triggerRef */
/* unused harmony export unref */
/* unused harmony export useAttrs */
/* unused harmony export useCSSModule */
/* unused harmony export useCssModule */
/* unused harmony export useSlots */
/* unused harmony export version */
/* unused harmony export warn */
/* unused harmony export watch */
/* unused harmony export watchEffect */
/* unused harmony export watchPostEffect */
/* unused harmony export watchSyncEffect */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

/**
 * Displays a warning message (using console.error) with a stack trace if the
 * function is called inside of active component.
 *
 * @param message warning message to be displayed
 */
function warn$1(message) {
    var _a;
    warn(message, (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
}

var activeEffectScope;
var effectScopeStack = [];
var EffectScopeImpl = /** @class */ (function () {
    function EffectScopeImpl(vm) {
        this.active = true;
        this.effects = [];
        this.cleanups = [];
        this.vm = vm;
    }
    EffectScopeImpl.prototype.run = function (fn) {
        if (this.active) {
            try {
                this.on();
                return fn();
            }
            finally {
                this.off();
            }
        }
        else if ((false)) {
            warn$1("cannot run an inactive effect scope.");
        }
        return;
    };
    EffectScopeImpl.prototype.on = function () {
        if (this.active) {
            effectScopeStack.push(this);
            activeEffectScope = this;
        }
    };
    EffectScopeImpl.prototype.off = function () {
        if (this.active) {
            effectScopeStack.pop();
            activeEffectScope = effectScopeStack[effectScopeStack.length - 1];
        }
    };
    EffectScopeImpl.prototype.stop = function () {
        if (this.active) {
            this.vm.$destroy();
            this.effects.forEach(function (e) { return e.stop(); });
            this.cleanups.forEach(function (cleanup) { return cleanup(); });
            this.active = false;
        }
    };
    return EffectScopeImpl;
}());
var EffectScope = /** @class */ (function (_super) {
    __extends(EffectScope, _super);
    function EffectScope(detached) {
        if (detached === void 0) { detached = false; }
        var _this = this;
        var vm = undefined;
        withCurrentInstanceTrackingDisabled(function () {
            vm = defineComponentInstance(getVueConstructor());
        });
        _this = _super.call(this, vm) || this;
        if (!detached) {
            recordEffectScope(_this);
        }
        return _this;
    }
    return EffectScope;
}(EffectScopeImpl));
function recordEffectScope(effect, scope) {
    var _a;
    scope = scope || activeEffectScope;
    if (scope && scope.active) {
        scope.effects.push(effect);
        return;
    }
    // destroy on parent component unmounted
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    vm && vm.$on('hook:destroyed', function () { return effect.stop(); });
}
function effectScope(detached) {
    return new EffectScope(detached);
}
function getCurrentScope() {
    return activeEffectScope;
}
function onScopeDispose(fn) {
    if (activeEffectScope) {
        activeEffectScope.cleanups.push(fn);
    }
    else if ((false)) {
        warn$1("onScopeDispose() is called when there is no active effect scope" +
            " to be associated with.");
    }
}
/**
 * @internal
 **/
function getCurrentScopeVM() {
    var _a, _b;
    return ((_a = getCurrentScope()) === null || _a === void 0 ? void 0 : _a.vm) || ((_b = getCurrentInstance()) === null || _b === void 0 ? void 0 : _b.proxy);
}
/**
 * @internal
 **/
function bindCurrentScopeToVM(vm) {
    if (!vm.scope) {
        var scope_1 = new EffectScopeImpl(vm.proxy);
        vm.scope = scope_1;
        vm.proxy.$on('hook:destroyed', function () { return scope_1.stop(); });
    }
    return vm.scope;
}

var vueDependency = undefined;
try {
    var requiredVue = __webpack_require__(122);
    if (requiredVue && isVue(requiredVue)) {
        vueDependency = requiredVue;
    }
    else if (requiredVue &&
        'default' in requiredVue &&
        isVue(requiredVue.default)) {
        vueDependency = requiredVue.default;
    }
}
catch (_a) {
    // not available
}
var vueConstructor = null;
var currentInstance = null;
var currentInstanceTracking = true;
var PluginInstalledFlag = '__composition_api_installed__';
function isVue(obj) {
    return obj && isFunction(obj) && obj.name === 'Vue';
}
function isVueRegistered(Vue) {
    // resolve issue: https://github.com/vuejs/composition-api/issues/876#issue-1087619365
    return vueConstructor && hasOwn(Vue, PluginInstalledFlag);
}
function getVueConstructor() {
    if ((false)) {
        assert(vueConstructor, "must call Vue.use(VueCompositionAPI) before using any function.");
    }
    return vueConstructor;
}
// returns registered vue or `vue` dependency
function getRegisteredVueOrDefault() {
    var constructor = vueConstructor || vueDependency;
    if ((false)) {
        assert(constructor, "No vue dependency found.");
    }
    return constructor;
}
function setVueConstructor(Vue) {
    // @ts-ignore
    if (false) {
        warn('[vue-composition-api] another instance of Vue installed');
    }
    vueConstructor = Vue;
    Object.defineProperty(Vue, PluginInstalledFlag, {
        configurable: true,
        writable: true,
        value: true,
    });
}
/**
 * For `effectScope` to create instance without populate the current instance
 * @internal
 **/
function withCurrentInstanceTrackingDisabled(fn) {
    var prev = currentInstanceTracking;
    currentInstanceTracking = false;
    try {
        fn();
    }
    finally {
        currentInstanceTracking = prev;
    }
}
function setCurrentInstance(instance) {
    if (!currentInstanceTracking)
        return;
    var prev = currentInstance;
    prev === null || prev === void 0 ? void 0 : prev.scope.off();
    currentInstance = instance;
    currentInstance === null || currentInstance === void 0 ? void 0 : currentInstance.scope.on();
}
function getCurrentInstance() {
    return currentInstance;
}
var instanceMapCache = new WeakMap();
function toVue3ComponentInstance(vm) {
    if (instanceMapCache.has(vm)) {
        return instanceMapCache.get(vm);
    }
    var instance = {
        proxy: vm,
        update: vm.$forceUpdate,
        type: vm.$options,
        uid: vm._uid,
        // $emit is defined on prototype and it expected to be bound
        emit: vm.$emit.bind(vm),
        parent: null,
        root: null, // to be immediately set
    };
    bindCurrentScopeToVM(instance);
    // map vm.$props =
    var instanceProps = [
        'data',
        'props',
        'attrs',
        'refs',
        'vnode',
        'slots',
    ];
    instanceProps.forEach(function (prop) {
        proxy(instance, prop, {
            get: function () {
                return vm["$".concat(prop)];
            },
        });
    });
    proxy(instance, 'isMounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isMounted;
        },
    });
    proxy(instance, 'isUnmounted', {
        get: function () {
            // @ts-expect-error private api
            return vm._isDestroyed;
        },
    });
    proxy(instance, 'isDeactivated', {
        get: function () {
            // @ts-expect-error private api
            return vm._inactive;
        },
    });
    proxy(instance, 'emitted', {
        get: function () {
            // @ts-expect-error private api
            return vm._events;
        },
    });
    instanceMapCache.set(vm, instance);
    if (vm.$parent) {
        instance.parent = toVue3ComponentInstance(vm.$parent);
    }
    if (vm.$root) {
        instance.root = toVue3ComponentInstance(vm.$root);
    }
    return instance;
}

var toString = function (x) { return Object.prototype.toString.call(x); };
function isNative(Ctor) {
    return typeof Ctor === 'function' && /native code/.test(Ctor.toString());
}
var hasSymbol = typeof Symbol !== 'undefined' &&
    isNative(Symbol) &&
    typeof Reflect !== 'undefined' &&
    isNative(Reflect.ownKeys);
var noopFn = function (_) { return _; };
function proxy(target, key, _a) {
    var get = _a.get, set = _a.set;
    Object.defineProperty(target, key, {
        enumerable: true,
        configurable: true,
        get: get || noopFn,
        set: set || noopFn,
    });
}
function def(obj, key, val, enumerable) {
    Object.defineProperty(obj, key, {
        value: val,
        enumerable: !!enumerable,
        writable: true,
        configurable: true,
    });
}
function hasOwn(obj, key) {
    return Object.hasOwnProperty.call(obj, key);
}
function assert(condition, msg) {
    if (!condition) {
        throw new Error("[vue-composition-api] ".concat(msg));
    }
}
function isPrimitive(value) {
    return (typeof value === 'string' ||
        typeof value === 'number' ||
        // $flow-disable-line
        typeof value === 'symbol' ||
        typeof value === 'boolean');
}
function isArray(x) {
    return Array.isArray(x);
}
var objectToString = Object.prototype.toString;
var toTypeString = function (value) {
    return objectToString.call(value);
};
var isMap = function (val) {
    return toTypeString(val) === '[object Map]';
};
var isSet = function (val) {
    return toTypeString(val) === '[object Set]';
};
var MAX_VALID_ARRAY_LENGTH = 4294967295; // Math.pow(2, 32) - 1
function isValidArrayIndex(val) {
    var n = parseFloat(String(val));
    return (n >= 0 &&
        Math.floor(n) === n &&
        isFinite(val) &&
        n <= MAX_VALID_ARRAY_LENGTH);
}
function isObject(val) {
    return val !== null && typeof val === 'object';
}
function isPlainObject(x) {
    return toString(x) === '[object Object]';
}
function isFunction(x) {
    return typeof x === 'function';
}
function isUndef(v) {
    return v === undefined || v === null;
}
function warn(msg, vm) {
    var Vue = getRegisteredVueOrDefault();
    if (!Vue || !Vue.util)
        console.warn("[vue-composition-api] ".concat(msg));
    else
        Vue.util.warn(msg, vm);
}
function logError(err, vm, info) {
    if ((false)) {
        warn("Error in ".concat(info, ": \"").concat(err.toString(), "\""), vm);
    }
    if (typeof window !== 'undefined' && typeof console !== 'undefined') {
        console.error(err);
    }
    else {
        throw err;
    }
}
/**
 * Object.is polyfill
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 * */
function isSame(value1, value2) {
    if (value1 === value2) {
        return value1 !== 0 || 1 / value1 === 1 / value2;
    }
    else {
        return value1 !== value1 && value2 !== value2;
    }
}

function getCurrentInstanceForFn(hook, target) {
    target = target || getCurrentInstance();
    if (false) {
        warn("".concat(hook, " is called when there is no active component instance to be ") +
            "associated with. " +
            "Lifecycle injection APIs can only be used during execution of setup().");
    }
    return target;
}
function defineComponentInstance(Ctor, options) {
    if (options === void 0) { options = {}; }
    var silent = Ctor.config.silent;
    Ctor.config.silent = true;
    var vm = new Ctor(options);
    Ctor.config.silent = silent;
    return vm;
}
function isComponentInstance(obj) {
    var Vue = getVueConstructor();
    return Vue && obj instanceof Vue;
}
function createSlotProxy(vm, slotName) {
    return (function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!vm.$scopedSlots[slotName]) {
            if ((false))
                return warn("slots.".concat(slotName, "() got called outside of the \"render()\" scope"), vm);
            return;
        }
        return vm.$scopedSlots[slotName].apply(vm, args);
    });
}
function resolveSlots(slots, normalSlots) {
    var res;
    if (!slots) {
        res = {};
    }
    else if (slots._normalized) {
        // fast path 1: child component re-render only, parent did not change
        return slots._normalized;
    }
    else {
        res = {};
        for (var key in slots) {
            if (slots[key] && key[0] !== '$') {
                res[key] = true;
            }
        }
    }
    // expose normal slots on scopedSlots
    for (var key in normalSlots) {
        if (!(key in res)) {
            res[key] = true;
        }
    }
    return res;
}
var vueInternalClasses;
var getVueInternalClasses = function () {
    if (!vueInternalClasses) {
        var vm = defineComponentInstance(getVueConstructor(), {
            computed: {
                value: function () {
                    return 0;
                },
            },
        });
        // to get Watcher class
        var Watcher = vm._computedWatchers.value.constructor;
        // to get Dep class
        var Dep = vm._data.__ob__.dep.constructor;
        vueInternalClasses = {
            Watcher: Watcher,
            Dep: Dep,
        };
        vm.$destroy();
    }
    return vueInternalClasses;
};

function createSymbol(name) {
    return hasSymbol ? Symbol.for(name) : name;
}
var WatcherPreFlushQueueKey = createSymbol('composition-api.preFlushQueue');
var WatcherPostFlushQueueKey = createSymbol('composition-api.postFlushQueue');
// must be a string, symbol key is ignored in reactive
var RefKey = 'composition-api.refKey';

var accessModifiedSet = new WeakMap();
var rawSet = new WeakMap();
var readonlySet = new WeakMap();

/**
 * Set a property on an object. Adds the new property, triggers change
 * notification and intercept it's subsequent access if the property doesn't
 * already exist.
 */
function set$1(target, key, val) {
    var Vue = getVueConstructor();
    // @ts-expect-error https://github.com/vuejs/vue/pull/12132
    var _a = Vue.util, warn = _a.warn, defineReactive = _a.defineReactive;
    if (false) {
        warn("Cannot set reactive property on undefined, null, or primitive value: ".concat(target));
    }
    var ob = target.__ob__;
    function ssrMockReactivity() {
        // in SSR, there is no __ob__. Mock for reactivity check
        if (ob && isObject(val) && !hasOwn(val, '__ob__')) {
            mockReactivityDeep(val);
        }
    }
    if (isArray(target)) {
        if (isValidArrayIndex(key)) {
            target.length = Math.max(target.length, key);
            target.splice(key, 1, val);
            ssrMockReactivity();
            return val;
        }
        else if (key === 'length' && val !== target.length) {
            target.length = val;
            ob === null || ob === void 0 ? void 0 : ob.dep.notify();
            return val;
        }
    }
    if (key in target && !(key in Object.prototype)) {
        target[key] = val;
        ssrMockReactivity();
        return val;
    }
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid adding reactive properties to a Vue instance or its root $data ' +
                'at runtime - declare it upfront in the data option.');
        return val;
    }
    if (!ob) {
        target[key] = val;
        return val;
    }
    defineReactive(ob.value, key, val);
    // IMPORTANT: define access control before trigger watcher
    defineAccessControl(target, key, val);
    ssrMockReactivity();
    ob.dep.notify();
    return val;
}

var _isForceTrigger = false;
function isForceTrigger() {
    return _isForceTrigger;
}
function setForceTrigger(v) {
    _isForceTrigger = v;
}

var RefImpl = /** @class */ (function () {
    function RefImpl(_a) {
        var get = _a.get, set = _a.set;
        proxy(this, 'value', {
            get: get,
            set: set,
        });
    }
    return RefImpl;
}());
function createRef(options, isReadonly, isComputed) {
    if (isReadonly === void 0) { isReadonly = false; }
    if (isComputed === void 0) { isComputed = false; }
    var r = new RefImpl(options);
    // add effect to differentiate refs from computed
    if (isComputed)
        r.effect = true;
    // seal the ref, this could prevent ref from being observed
    // It's safe to seal the ref, since we really shouldn't extend it.
    // related issues: #79
    var sealed = Object.seal(r);
    if (isReadonly)
        readonlySet.set(sealed, true);
    return sealed;
}
function ref(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = reactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function isRef(value) {
    return value instanceof RefImpl;
}
function unref(ref) {
    return isRef(ref) ? ref.value : ref;
}
function toRefs(obj) {
    if (false) {
        warn("toRefs() expects a reactive object but received a plain one.");
    }
    if (!isPlainObject(obj))
        return obj;
    var ret = {};
    for (var key in obj) {
        ret[key] = toRef(obj, key);
    }
    return ret;
}
function customRef(factory) {
    var version = ref(0);
    return createRef(factory(function () { return void version.value; }, function () {
        ++version.value;
    }));
}
function toRef(object, key) {
    if (!(key in object))
        set$1(object, key, undefined);
    var v = object[key];
    if (isRef(v))
        return v;
    return createRef({
        get: function () { return object[key]; },
        set: function (v) { return (object[key] = v); },
    });
}
function shallowRef(raw) {
    var _a;
    if (isRef(raw)) {
        return raw;
    }
    var value = shallowReactive((_a = {}, _a[RefKey] = raw, _a));
    return createRef({
        get: function () { return value[RefKey]; },
        set: function (v) { return (value[RefKey] = v); },
    });
}
function triggerRef(value) {
    if (!isRef(value))
        return;
    setForceTrigger(true);
    value.value = value.value;
    setForceTrigger(false);
}
function proxyRefs(objectWithRefs) {
    var _a, e_1, _b;
    if (isReactive(objectWithRefs)) {
        return objectWithRefs;
    }
    var value = reactive((_a = {}, _a[RefKey] = objectWithRefs, _a));
    def(value, RefKey, value[RefKey], false);
    var _loop_1 = function (key) {
        proxy(value, key, {
            get: function () {
                if (isRef(value[RefKey][key])) {
                    return value[RefKey][key].value;
                }
                return value[RefKey][key];
            },
            set: function (v) {
                if (isRef(value[RefKey][key])) {
                    return (value[RefKey][key].value = unref(v));
                }
                value[RefKey][key] = unref(v);
            },
        });
    };
    try {
        for (var _c = __values(Object.keys(objectWithRefs)), _d = _c.next(); !_d.done; _d = _c.next()) {
            var key = _d.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_d && !_d.done && (_b = _c.return)) _b.call(_c);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return value;
}

var SKIPFLAG = '__v_skip';
function isRaw(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        ((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
function isReactive(obj) {
    var _a;
    return Boolean(obj &&
        hasOwn(obj, '__ob__') &&
        typeof obj.__ob__ === 'object' &&
        !((_a = obj.__ob__) === null || _a === void 0 ? void 0 : _a[SKIPFLAG]));
}
/**
 * Proxing property access of target.
 * We can do unwrapping and other things here.
 */
function setupAccessControl(target) {
    if (!isPlainObject(target) ||
        isRaw(target) ||
        isArray(target) ||
        isRef(target) ||
        isComponentInstance(target) ||
        accessModifiedSet.has(target))
        return;
    accessModifiedSet.set(target, true);
    var keys = Object.keys(target);
    for (var i = 0; i < keys.length; i++) {
        defineAccessControl(target, keys[i]);
    }
}
/**
 * Auto unwrapping when access property
 */
function defineAccessControl(target, key, val) {
    if (key === '__ob__')
        return;
    if (isRaw(target[key]))
        return;
    var getter;
    var setter;
    var property = Object.getOwnPropertyDescriptor(target, key);
    if (property) {
        if (property.configurable === false) {
            return;
        }
        getter = property.get;
        setter = property.set;
        if ((!getter || setter) /* not only have getter */ &&
            arguments.length === 2) {
            val = target[key];
        }
    }
    setupAccessControl(val);
    proxy(target, key, {
        get: function getterHandler() {
            var value = getter ? getter.call(target) : val;
            // if the key is equal to RefKey, skip the unwrap logic
            if (key !== RefKey && isRef(value)) {
                return value.value;
            }
            else {
                return value;
            }
        },
        set: function setterHandler(newVal) {
            if (getter && !setter)
                return;
            // If the key is equal to RefKey, skip the unwrap logic
            // If and only if "value" is ref and "newVal" is not a ref,
            // the assignment should be proxied to "value" ref.
            if (key !== RefKey && isRef(val) && !isRef(newVal)) {
                val.value = newVal;
            }
            else if (setter) {
                setter.call(target, newVal);
                val = newVal;
            }
            else {
                val = newVal;
            }
            setupAccessControl(newVal);
        },
    });
}
function observe(obj) {
    var Vue = getRegisteredVueOrDefault();
    var observed;
    if (Vue.observable) {
        observed = Vue.observable(obj);
    }
    else {
        var vm = defineComponentInstance(Vue, {
            data: {
                $$state: obj,
            },
        });
        observed = vm._data.$$state;
    }
    // in SSR, there is no __ob__. Mock for reactivity check
    if (!hasOwn(observed, '__ob__')) {
        mockReactivityDeep(observed);
    }
    return observed;
}
/**
 * Mock __ob__ for object recursively
 */
function mockReactivityDeep(obj, seen) {
    var e_1, _a;
    if (seen === void 0) { seen = new Set(); }
    if (seen.has(obj) || hasOwn(obj, '__ob__') || !Object.isExtensible(obj))
        return;
    def(obj, '__ob__', mockObserver(obj));
    seen.add(obj);
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            var value = obj[key];
            if (!(isPlainObject(value) || isArray(value)) ||
                isRaw(value) ||
                !Object.isExtensible(value)) {
                continue;
            }
            mockReactivityDeep(value, seen);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function mockObserver(value) {
    if (value === void 0) { value = {}; }
    return {
        value: value,
        dep: {
            notify: noopFn,
            depend: noopFn,
            addSub: noopFn,
            removeSub: noopFn,
        },
    };
}
function createObserver() {
    return observe({}).__ob__;
}
function shallowReactive(obj) {
    var e_2, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn('"shallowReactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(isArray(obj) ? [] : {});
    var ob = observed.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var setter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false) {
                return "continue";
            }
            getter = property.get;
            setter = property.set;
        }
        proxy(observed, key, {
            get: function getterHandler() {
                var _a;
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.depend();
                return val;
            },
            set: function setterHandler(newVal) {
                var _a;
                if (getter && !setter)
                    return;
                if (!isForceTrigger() && val === newVal)
                    return;
                if (setter) {
                    setter.call(obj, newVal);
                }
                else {
                    val = newVal;
                }
                (_a = ob.dep) === null || _a === void 0 ? void 0 : _a.notify();
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return observed;
}
/**
 * Make obj reactivity
 */
function reactive(obj) {
    if (!isObject(obj)) {
        if ((false)) {
            warn('"reactive()" must be called on an object.');
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        isRaw(obj) ||
        !Object.isExtensible(obj)) {
        return obj;
    }
    var observed = observe(obj);
    setupAccessControl(observed);
    return observed;
}
/**
 * Make sure obj can't be a reactive
 */
function markRaw(obj) {
    if (!(isPlainObject(obj) || isArray(obj)) || !Object.isExtensible(obj)) {
        return obj;
    }
    // set the vue observable flag at obj
    var ob = createObserver();
    ob[SKIPFLAG] = true;
    def(obj, '__ob__', ob);
    // mark as Raw
    rawSet.set(obj, true);
    return obj;
}
function toRaw(observed) {
    var _a;
    if (isRaw(observed) || !Object.isExtensible(observed)) {
        return observed;
    }
    return ((_a = observed === null || observed === void 0 ? void 0 : observed.__ob__) === null || _a === void 0 ? void 0 : _a.value) || observed;
}

function isReadonly(obj) {
    return readonlySet.has(obj);
}
/**
 * **In @vue/composition-api, `reactive` only provides type-level readonly check**
 *
 * Creates a readonly copy of the original object. Note the returned copy is not
 * made reactive, but `readonly` can be called on an already reactive object.
 */
function readonly(target) {
    if (false) {
        warn("value cannot be made reactive: ".concat(String(target)));
    }
    else {
        readonlySet.set(target, true);
    }
    return target;
}
function shallowReadonly(obj) {
    var e_1, _a;
    if (!isObject(obj)) {
        if ((false)) {
            warn("value cannot be made reactive: ".concat(String(obj)));
        }
        return obj;
    }
    if (!(isPlainObject(obj) || isArray(obj)) ||
        (!Object.isExtensible(obj) && !isRef(obj))) {
        return obj;
    }
    var readonlyObj = isRef(obj)
        ? new RefImpl({})
        : isReactive(obj)
            ? observe({})
            : {};
    var source = reactive({});
    var ob = source.__ob__;
    var _loop_1 = function (key) {
        var val = obj[key];
        var getter;
        var property = Object.getOwnPropertyDescriptor(obj, key);
        if (property) {
            if (property.configurable === false && !isRef(obj)) {
                return "continue";
            }
            getter = property.get;
        }
        proxy(readonlyObj, key, {
            get: function getterHandler() {
                var value = getter ? getter.call(obj) : val;
                ob.dep.depend();
                return value;
            },
            set: function (v) {
                if ((false)) {
                    warn("Set operation on key \"".concat(key, "\" failed: target is readonly."));
                }
            },
        });
    };
    try {
        for (var _b = __values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var key = _c.value;
            _loop_1(key);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
    readonlySet.set(readonlyObj, true);
    return readonlyObj;
}

/**
 * Delete a property and trigger change if necessary.
 */
function del(target, key) {
    var Vue = getVueConstructor();
    var warn = Vue.util.warn;
    if (false) {
        warn("Cannot delete reactive property on undefined, null, or primitive value: ".concat(target));
    }
    if (isArray(target) && isValidArrayIndex(key)) {
        target.splice(key, 1);
        return;
    }
    var ob = target.__ob__;
    if (target._isVue || (ob && ob.vmCount)) {
        ("production" !== 'production') &&
            warn('Avoid deleting properties on a Vue instance or its root $data ' +
                '- just set it to null.');
        return;
    }
    if (!hasOwn(target, key)) {
        return;
    }
    delete target[key];
    if (!ob) {
        return;
    }
    ob.dep.notify();
}

var genName = function (name) { return "on".concat(name[0].toUpperCase() + name.slice(1)); };
function createLifeCycle(lifeCyclehook) {
    return function (callback, target) {
        var instance = getCurrentInstanceForFn(genName(lifeCyclehook), target);
        return (instance &&
            injectHookOption(getVueConstructor(), instance, lifeCyclehook, callback));
    };
}
function injectHookOption(Vue, instance, hook, val) {
    var options = instance.proxy.$options;
    var mergeFn = Vue.config.optionMergeStrategies[hook];
    var wrappedHook = wrapHookCall(instance, val);
    options[hook] = mergeFn(options[hook], wrappedHook);
    return wrappedHook;
}
function wrapHookCall(instance, fn) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var prev = getCurrentInstance();
        setCurrentInstance(instance);
        try {
            return fn.apply(void 0, __spreadArray([], __read(args), false));
        }
        finally {
            setCurrentInstance(prev);
        }
    };
}
var onBeforeMount = createLifeCycle('beforeMount');
var onMounted = createLifeCycle('mounted');
var onBeforeUpdate = createLifeCycle('beforeUpdate');
var onUpdated = createLifeCycle('updated');
var onBeforeUnmount = createLifeCycle('beforeDestroy');
var onUnmounted = createLifeCycle('destroyed');
var onErrorCaptured = createLifeCycle('errorCaptured');
var onActivated = createLifeCycle('activated');
var onDeactivated = createLifeCycle('deactivated');
var onServerPrefetch = createLifeCycle('serverPrefetch');

var fallbackVM;
function flushPreQueue() {
    flushQueue(this, WatcherPreFlushQueueKey);
}
function flushPostQueue() {
    flushQueue(this, WatcherPostFlushQueueKey);
}
function hasWatchEnv(vm) {
    return vm[WatcherPreFlushQueueKey] !== undefined;
}
function installWatchEnv(vm) {
    vm[WatcherPreFlushQueueKey] = [];
    vm[WatcherPostFlushQueueKey] = [];
    vm.$on('hook:beforeUpdate', flushPreQueue);
    vm.$on('hook:updated', flushPostQueue);
}
function getWatcherOption(options) {
    return __assign({
        immediate: false,
        deep: false,
        flush: 'pre',
    }, options);
}
function getWatchEffectOption(options) {
    return __assign({
        flush: 'pre',
    }, options);
}
function getWatcherVM() {
    var vm = getCurrentScopeVM();
    if (!vm) {
        if (!fallbackVM) {
            fallbackVM = defineComponentInstance(getVueConstructor());
        }
        vm = fallbackVM;
    }
    else if (!hasWatchEnv(vm)) {
        installWatchEnv(vm);
    }
    return vm;
}
function flushQueue(vm, key) {
    var queue = vm[key];
    for (var index = 0; index < queue.length; index++) {
        queue[index]();
    }
    queue.length = 0;
}
function queueFlushJob(vm, fn, mode) {
    // flush all when beforeUpdate and updated are not fired
    var fallbackFlush = function () {
        vm.$nextTick(function () {
            if (vm[WatcherPreFlushQueueKey].length) {
                flushQueue(vm, WatcherPreFlushQueueKey);
            }
            if (vm[WatcherPostFlushQueueKey].length) {
                flushQueue(vm, WatcherPostFlushQueueKey);
            }
        });
    };
    switch (mode) {
        case 'pre':
            fallbackFlush();
            vm[WatcherPreFlushQueueKey].push(fn);
            break;
        case 'post':
            fallbackFlush();
            vm[WatcherPostFlushQueueKey].push(fn);
            break;
        default:
            assert(false, "flush must be one of [\"post\", \"pre\", \"sync\"], but got ".concat(mode));
            break;
    }
}
function createVueWatcher(vm, getter, callback, options) {
    var index = vm._watchers.length;
    // @ts-ignore: use undocumented options
    vm.$watch(getter, callback, {
        immediate: options.immediateInvokeCallback,
        deep: options.deep,
        lazy: options.noRun,
        sync: options.sync,
        before: options.before,
    });
    return vm._watchers[index];
}
// We have to monkeypatch the teardown function so Vue will run
// runCleanup() when it tears down the watcher on unmounted.
function patchWatcherTeardown(watcher, runCleanup) {
    var _teardown = watcher.teardown;
    watcher.teardown = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        _teardown.apply(watcher, args);
        runCleanup();
    };
}
function createWatcher(vm, source, cb, options) {
    var _a;
    if (false) {
        if (options.immediate !== undefined) {
            warn("watch() \"immediate\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
        if (options.deep !== undefined) {
            warn("watch() \"deep\" option is only respected when using the " +
                "watch(source, callback, options?) signature.");
        }
    }
    var flushMode = options.flush;
    var isSync = flushMode === 'sync';
    var cleanup;
    var registerCleanup = function (fn) {
        cleanup = function () {
            try {
                fn();
            }
            catch (
            // FIXME: remove any
            error) {
                logError(error, vm, 'onCleanup()');
            }
        };
    };
    // cleanup before running getter again
    var runCleanup = function () {
        if (cleanup) {
            cleanup();
            cleanup = null;
        }
    };
    var createScheduler = function (fn) {
        if (isSync ||
            /* without a current active instance, ignore pre|post mode */ vm ===
                fallbackVM) {
            return fn;
        }
        return (function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return queueFlushJob(vm, function () {
                fn.apply(void 0, __spreadArray([], __read(args), false));
            }, flushMode);
        });
    };
    // effect watch
    if (cb === null) {
        var running_1 = false;
        var getter_1 = function () {
            // preventing the watch callback being call in the same execution
            if (running_1) {
                return;
            }
            try {
                running_1 = true;
                source(registerCleanup);
            }
            finally {
                running_1 = false;
            }
        };
        var watcher_1 = createVueWatcher(vm, getter_1, noopFn, {
            deep: options.deep || false,
            sync: isSync,
            before: runCleanup,
        });
        patchWatcherTeardown(watcher_1, runCleanup);
        // enable the watcher update
        watcher_1.lazy = false;
        var originGet = watcher_1.get.bind(watcher_1);
        // always run watchEffect
        watcher_1.get = createScheduler(originGet);
        return function () {
            watcher_1.teardown();
        };
    }
    var deep = options.deep;
    var isMultiSource = false;
    var getter;
    if (isRef(source)) {
        getter = function () { return source.value; };
    }
    else if (isReactive(source)) {
        getter = function () { return source; };
        deep = true;
    }
    else if (isArray(source)) {
        isMultiSource = true;
        getter = function () {
            return source.map(function (s) {
                if (isRef(s)) {
                    return s.value;
                }
                else if (isReactive(s)) {
                    return traverse(s);
                }
                else if (isFunction(s)) {
                    return s();
                }
                else {
                    ("production" !== 'production') &&
                        warn("Invalid watch source: ".concat(JSON.stringify(s), ".\n          A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
                    return noopFn;
                }
            });
        };
    }
    else if (isFunction(source)) {
        getter = source;
    }
    else {
        getter = noopFn;
        ("production" !== 'production') &&
            warn("Invalid watch source: ".concat(JSON.stringify(source), ".\n      A watch source can only be a getter/effect function, a ref, a reactive object, or an array of these types."), vm);
    }
    if (deep) {
        var baseGetter_1 = getter;
        getter = function () { return traverse(baseGetter_1()); };
    }
    var applyCb = function (n, o) {
        if (!deep &&
            isMultiSource &&
            n.every(function (v, i) { return isSame(v, o[i]); }))
            return;
        // cleanup before running cb again
        runCleanup();
        return cb(n, o, registerCleanup);
    };
    var callback = createScheduler(applyCb);
    if (options.immediate) {
        var originalCallback_1 = callback;
        // `shiftCallback` is used to handle the first sync effect run.
        // The subsequent callbacks will redirect to `callback`.
        var shiftCallback_1 = function (n, o) {
            shiftCallback_1 = originalCallback_1;
            // o is undefined on the first call
            return applyCb(n, isArray(n) ? [] : o);
        };
        callback = function (n, o) {
            return shiftCallback_1(n, o);
        };
    }
    // @ts-ignore: use undocumented option "sync"
    var stop = vm.$watch(getter, callback, {
        immediate: options.immediate,
        deep: deep,
        sync: isSync,
    });
    // Once again, we have to hack the watcher for proper teardown
    var watcher = vm._watchers[vm._watchers.length - 1];
    // if the return value is reactive and deep:true
    // watch for changes, this might happen when new key is added
    if (isReactive(watcher.value) && ((_a = watcher.value.__ob__) === null || _a === void 0 ? void 0 : _a.dep) && deep) {
        watcher.value.__ob__.dep.addSub({
            update: function () {
                // this will force the source to be revaluated and the callback
                // executed if needed
                watcher.run();
            },
        });
    }
    patchWatcherTeardown(watcher, runCleanup);
    return function () {
        stop();
    };
}
function watchEffect(effect, options) {
    var opts = getWatchEffectOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, effect, null, opts);
}
function watchPostEffect(effect) {
    return watchEffect(effect, { flush: 'post' });
}
function watchSyncEffect(effect) {
    return watchEffect(effect, { flush: 'sync' });
}
// implementation
function watch(source, cb, options) {
    var callback = null;
    if (isFunction(cb)) {
        // source watch
        callback = cb;
    }
    else {
        // effect watch
        if ((false)) {
            warn("`watch(fn, options?)` signature has been moved to a separate API. " +
                "Use `watchEffect(fn, options?)` instead. `watch` now only " +
                "supports `watch(source, cb, options?) signature.");
        }
        options = cb;
        callback = null;
    }
    var opts = getWatcherOption(options);
    var vm = getWatcherVM();
    return createWatcher(vm, source, callback, opts);
}
function traverse(value, seen) {
    if (seen === void 0) { seen = new Set(); }
    if (!isObject(value) || seen.has(value) || rawSet.has(value)) {
        return value;
    }
    seen.add(value);
    if (isRef(value)) {
        traverse(value.value, seen);
    }
    else if (isArray(value)) {
        for (var i = 0; i < value.length; i++) {
            traverse(value[i], seen);
        }
    }
    else if (isSet(value) || isMap(value)) {
        value.forEach(function (v) {
            traverse(v, seen);
        });
    }
    else if (isPlainObject(value)) {
        for (var key in value) {
            traverse(value[key], seen);
        }
    }
    return value;
}

// implement
function computed(getterOrOptions) {
    var vm = getCurrentScopeVM();
    var getter;
    var setter;
    if (isFunction(getterOrOptions)) {
        getter = getterOrOptions;
    }
    else {
        getter = getterOrOptions.get;
        setter = getterOrOptions.set;
    }
    var computedSetter;
    var computedGetter;
    if (vm && !vm.$isServer) {
        var _a = getVueInternalClasses(), Watcher_1 = _a.Watcher, Dep_1 = _a.Dep;
        var watcher_1;
        computedGetter = function () {
            if (!watcher_1) {
                watcher_1 = new Watcher_1(vm, getter, noopFn, { lazy: true });
            }
            if (watcher_1.dirty) {
                watcher_1.evaluate();
            }
            if (Dep_1.target) {
                watcher_1.depend();
            }
            return watcher_1.value;
        };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            if (setter) {
                setter(v);
            }
        };
    }
    else {
        // fallback
        var computedHost_1 = defineComponentInstance(getVueConstructor(), {
            computed: {
                $$state: {
                    get: getter,
                    set: setter,
                },
            },
        });
        vm && vm.$on('hook:destroyed', function () { return computedHost_1.$destroy(); });
        computedGetter = function () { return computedHost_1.$$state; };
        computedSetter = function (v) {
            if (false) {
                warn('Write operation failed: computed value is readonly.', vm);
                return;
            }
            computedHost_1.$$state = v;
        };
    }
    return createRef({
        get: computedGetter,
        set: computedSetter,
    }, !setter, true);
}

var NOT_FOUND = {};
function resolveInject(provideKey, vm) {
    var source = vm;
    while (source) {
        // @ts-ignore
        if (source._provided && hasOwn(source._provided, provideKey)) {
            //@ts-ignore
            return source._provided[provideKey];
        }
        source = source.$parent;
    }
    return NOT_FOUND;
}
function provide(key, value) {
    var _a;
    var vm = (_a = getCurrentInstanceForFn('provide')) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm)
        return;
    if (!vm._provided) {
        var provideCache_1 = {};
        proxy(vm, '_provided', {
            get: function () { return provideCache_1; },
            set: function (v) { return Object.assign(provideCache_1, v); },
        });
    }
    vm._provided[key] = value;
}
function inject(key, defaultValue, treatDefaultAsFactory) {
    var _a;
    if (treatDefaultAsFactory === void 0) { treatDefaultAsFactory = false; }
    var vm = (_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy;
    if (!vm) {
        ("production" !== 'production') &&
            warn("inject() can only be used inside setup() or functional components.");
        return;
    }
    if (!key) {
        ("production" !== 'production') && warn("injection \"".concat(String(key), "\" not found."), vm);
        return defaultValue;
    }
    var val = resolveInject(key, vm);
    if (val !== NOT_FOUND) {
        return val;
    }
    else if (arguments.length > 1) {
        return treatDefaultAsFactory && isFunction(defaultValue)
            ? defaultValue()
            : defaultValue;
    }
    else if ((false)) {
        warn("Injection \"".concat(String(key), "\" not found."), vm);
    }
}

var EMPTY_OBJ = ( false)
    ? Object.freeze({})
    : {};
var useCssModule = function (name) {
    var _a;
    if (name === void 0) { name = '$style'; }
    var instance = getCurrentInstance();
    if (!instance) {
        ("production" !== 'production') && warn("useCssModule must be called inside setup()");
        return EMPTY_OBJ;
    }
    var mod = (_a = instance.proxy) === null || _a === void 0 ? void 0 : _a[name];
    if (!mod) {
        ("production" !== 'production') &&
            warn("Current instance does not have CSS module named \"".concat(name, "\"."));
        return EMPTY_OBJ;
    }
    return mod;
};
/**
 * @deprecated use `useCssModule` instead.
 */
var useCSSModule = useCssModule;

function createApp(rootComponent, rootProps) {
    if (rootProps === void 0) { rootProps = undefined; }
    var V = getVueConstructor();
    var mountedVM = undefined;
    var provide = {};
    var app = {
        config: V.config,
        use: V.use.bind(V),
        mixin: V.mixin.bind(V),
        component: V.component.bind(V),
        provide: function (key, value) {
            provide[key] = value;
            return this;
        },
        directive: function (name, dir) {
            if (dir) {
                V.directive(name, dir);
                return app;
            }
            else {
                return V.directive(name);
            }
        },
        mount: function (el, hydrating) {
            if (!mountedVM) {
                mountedVM = new V(__assign(__assign({ propsData: rootProps }, rootComponent), { provide: __assign(__assign({}, provide), rootComponent.provide) }));
                mountedVM.$mount(el, hydrating);
                return mountedVM;
            }
            else {
                if ((false)) {
                    warn("App has already been mounted.\n" +
                        "If you want to remount the same app, move your app creation logic " +
                        "into a factory function and create fresh app instances for each " +
                        "mount - e.g. `const createMyApp = () => createApp(App)`");
                }
                return mountedVM;
            }
        },
        unmount: function () {
            if (mountedVM) {
                mountedVM.$destroy();
                mountedVM = undefined;
            }
            else if ((false)) {
                warn("Cannot unmount an app that is not mounted.");
            }
        },
    };
    return app;
}

var nextTick = function nextTick() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return (_a = getVueConstructor()) === null || _a === void 0 ? void 0 : _a.nextTick.apply(this, args);
};

var fallbackCreateElement;
var createElement = function createElement() {
    var _a;
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var instance = (this === null || this === void 0 ? void 0 : this.proxy) || ((_a = getCurrentInstance()) === null || _a === void 0 ? void 0 : _a.proxy);
    if (!instance) {
        ("production" !== 'production') &&
            warn('`createElement()` has been called outside of render function.');
        if (!fallbackCreateElement) {
            fallbackCreateElement = defineComponentInstance(getVueConstructor()).$createElement;
        }
        return fallbackCreateElement.apply(fallbackCreateElement, args);
    }
    return instance.$createElement.apply(instance, args);
};

function useSlots() {
    return getContext().slots;
}
function useAttrs() {
    return getContext().attrs;
}
function getContext() {
    var i = getCurrentInstance();
    if (false) {
        warn("useContext() called without active instance.");
    }
    return i.setupContext;
}

function set(vm, key, value) {
    var state = (vm.__composition_api_state__ =
        vm.__composition_api_state__ || {});
    state[key] = value;
}
function get(vm, key) {
    return (vm.__composition_api_state__ || {})[key];
}
var vmStateManager = {
    set: set,
    get: get,
};

function asVmProperty(vm, propName, propValue) {
    var props = vm.$options.props;
    if (!(propName in vm) && !(props && hasOwn(props, propName))) {
        if (isRef(propValue)) {
            proxy(vm, propName, {
                get: function () { return propValue.value; },
                set: function (val) {
                    propValue.value = val;
                },
            });
        }
        else {
            proxy(vm, propName, {
                get: function () {
                    if (isReactive(propValue)) {
                        propValue.__ob__.dep.depend();
                    }
                    return propValue;
                },
                set: function (val) {
                    propValue = val;
                },
            });
        }
        if ((false)) {
            // expose binding to Vue Devtool as a data property
            // delay this until state has been resolved to prevent repeated works
            vm.$nextTick(function () {
                if (Object.keys(vm._data).indexOf(propName) !== -1) {
                    return;
                }
                if (isRef(propValue)) {
                    proxy(vm._data, propName, {
                        get: function () { return propValue.value; },
                        set: function (val) {
                            propValue.value = val;
                        },
                    });
                }
                else {
                    proxy(vm._data, propName, {
                        get: function () { return propValue; },
                        set: function (val) {
                            propValue = val;
                        },
                    });
                }
            });
        }
    }
    else if ((false)) {
        if (props && hasOwn(props, propName)) {
            warn("The setup binding property \"".concat(propName, "\" is already declared as a prop."), vm);
        }
        else {
            warn("The setup binding property \"".concat(propName, "\" is already declared."), vm);
        }
    }
}
function updateTemplateRef(vm) {
    var rawBindings = vmStateManager.get(vm, 'rawBindings') || {};
    if (!rawBindings || !Object.keys(rawBindings).length)
        return;
    var refs = vm.$refs;
    var oldRefKeys = vmStateManager.get(vm, 'refs') || [];
    for (var index = 0; index < oldRefKeys.length; index++) {
        var key = oldRefKeys[index];
        var setupValue = rawBindings[key];
        if (!refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = null;
        }
    }
    var newKeys = Object.keys(refs);
    var validNewKeys = [];
    for (var index = 0; index < newKeys.length; index++) {
        var key = newKeys[index];
        var setupValue = rawBindings[key];
        if (refs[key] && setupValue && isRef(setupValue)) {
            setupValue.value = refs[key];
            validNewKeys.push(key);
        }
    }
    vmStateManager.set(vm, 'refs', validNewKeys);
}
function afterRender(vm) {
    var stack = [vm._vnode];
    while (stack.length) {
        var vnode = stack.pop();
        if (vnode) {
            if (vnode.context)
                updateTemplateRef(vnode.context);
            if (vnode.children) {
                for (var i = 0; i < vnode.children.length; ++i) {
                    stack.push(vnode.children[i]);
                }
            }
        }
    }
}
function updateVmAttrs(vm, ctx) {
    var e_1, _a;
    if (!vm) {
        return;
    }
    var attrBindings = vmStateManager.get(vm, 'attrBindings');
    if (!attrBindings && !ctx) {
        // fix 840
        return;
    }
    if (!attrBindings) {
        var observedData = reactive({});
        attrBindings = { ctx: ctx, data: observedData };
        vmStateManager.set(vm, 'attrBindings', attrBindings);
        proxy(ctx, 'attrs', {
            get: function () {
                return attrBindings === null || attrBindings === void 0 ? void 0 : attrBindings.data;
            },
            set: function () {
                ("production" !== 'production') &&
                    warn("Cannot assign to '$attrs' because it is a read-only property", vm);
            },
        });
    }
    var source = vm.$attrs;
    var _loop_1 = function (attr) {
        if (!hasOwn(attrBindings.data, attr)) {
            proxy(attrBindings.data, attr, {
                get: function () {
                    // to ensure it always return the latest value
                    return vm.$attrs[attr];
                },
            });
        }
    };
    try {
        for (var _b = __values(Object.keys(source)), _c = _b.next(); !_c.done; _c = _b.next()) {
            var attr = _c.value;
            _loop_1(attr);
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
function resolveScopedSlots(vm, slotsProxy) {
    var parentVNode = vm.$options._parentVnode;
    if (!parentVNode)
        return;
    var prevSlots = vmStateManager.get(vm, 'slots') || [];
    var curSlots = resolveSlots(parentVNode.data.scopedSlots, vm.$slots);
    // remove staled slots
    for (var index = 0; index < prevSlots.length; index++) {
        var key = prevSlots[index];
        if (!curSlots[key]) {
            delete slotsProxy[key];
        }
    }
    // proxy fresh slots
    var slotNames = Object.keys(curSlots);
    for (var index = 0; index < slotNames.length; index++) {
        var key = slotNames[index];
        if (!slotsProxy[key]) {
            slotsProxy[key] = createSlotProxy(vm, key);
        }
    }
    vmStateManager.set(vm, 'slots', slotNames);
}
function activateCurrentInstance(instance, fn, onError) {
    var preVm = getCurrentInstance();
    setCurrentInstance(instance);
    try {
        return fn(instance);
    }
    catch (
    // FIXME: remove any
    err) {
        if (onError) {
            onError(err);
        }
        else {
            throw err;
        }
    }
    finally {
        setCurrentInstance(preVm);
    }
}

function mixin(Vue) {
    Vue.mixin({
        beforeCreate: functionApiInit,
        mounted: function () {
            afterRender(this);
        },
        beforeUpdate: function () {
            updateVmAttrs(this);
        },
        updated: function () {
            afterRender(this);
        },
    });
    /**
     * Vuex init hook, injected into each instances init hooks list.
     */
    function functionApiInit() {
        var vm = this;
        var $options = vm.$options;
        var setup = $options.setup, render = $options.render;
        if (render) {
            // keep currentInstance accessible for createElement
            $options.render = function () {
                var _this = this;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return activateCurrentInstance(toVue3ComponentInstance(vm), function () {
                    return render.apply(_this, args);
                });
            };
        }
        if (!setup) {
            return;
        }
        if (!isFunction(setup)) {
            if ((false)) {
                warn('The "setup" option should be a function that returns a object in component definitions.', vm);
            }
            return;
        }
        var data = $options.data;
        // wrapper the data option, so we can invoke setup before data get resolved
        $options.data = function wrappedData() {
            initSetup(vm, vm.$props);
            return isFunction(data)
                ? data.call(vm, vm)
                : data || {};
        };
    }
    function initSetup(vm, props) {
        if (props === void 0) { props = {}; }
        var setup = vm.$options.setup;
        var ctx = createSetupContext(vm);
        var instance = toVue3ComponentInstance(vm);
        instance.setupContext = ctx;
        // fake reactive for `toRefs(props)`
        def(props, '__ob__', createObserver());
        // resolve scopedSlots and slots to functions
        resolveScopedSlots(vm, ctx.slots);
        var binding;
        activateCurrentInstance(instance, function () {
            // make props to be fake reactive, this is for `toRefs(props)`
            binding = setup(props, ctx);
        });
        if (!binding)
            return;
        if (isFunction(binding)) {
            // keep typescript happy with the binding type.
            var bindingFunc_1 = binding;
            // keep currentInstance accessible for createElement
            vm.$options.render = function () {
                resolveScopedSlots(vm, ctx.slots);
                return activateCurrentInstance(instance, function () { return bindingFunc_1(); });
            };
            return;
        }
        else if (isObject(binding)) {
            if (isReactive(binding)) {
                binding = toRefs(binding);
            }
            vmStateManager.set(vm, 'rawBindings', binding);
            var bindingObj_1 = binding;
            Object.keys(bindingObj_1).forEach(function (name) {
                var bindingValue = bindingObj_1[name];
                if (!isRef(bindingValue)) {
                    if (!isReactive(bindingValue)) {
                        if (isFunction(bindingValue)) {
                            var copy_1 = bindingValue;
                            bindingValue = bindingValue.bind(vm);
                            Object.keys(copy_1).forEach(function (ele) {
                                bindingValue[ele] = copy_1[ele];
                            });
                        }
                        else if (!isObject(bindingValue)) {
                            bindingValue = ref(bindingValue);
                        }
                        else if (hasReactiveArrayChild(bindingValue)) {
                            // creates a custom reactive properties without make the object explicitly reactive
                            // NOTE we should try to avoid this, better implementation needed
                            customReactive(bindingValue);
                        }
                    }
                    else if (isArray(bindingValue)) {
                        bindingValue = ref(bindingValue);
                    }
                }
                asVmProperty(vm, name, bindingValue);
            });
            return;
        }
        if ((false)) {
            assert(false, "\"setup\" must return a \"Object\" or a \"Function\", got \"".concat(Object.prototype.toString
                .call(binding)
                .slice(8, -1), "\""));
        }
    }
    function customReactive(target, seen) {
        if (seen === void 0) { seen = new Set(); }
        if (seen.has(target))
            return;
        if (!isPlainObject(target) ||
            isRef(target) ||
            isReactive(target) ||
            isRaw(target))
            return;
        var Vue = getVueConstructor();
        // @ts-expect-error https://github.com/vuejs/vue/pull/12132
        var defineReactive = Vue.util.defineReactive;
        Object.keys(target).forEach(function (k) {
            var val = target[k];
            defineReactive(target, k, val);
            if (val) {
                seen.add(val);
                customReactive(val, seen);
            }
            return;
        });
    }
    function hasReactiveArrayChild(target, visited) {
        if (visited === void 0) { visited = new Map(); }
        if (visited.has(target)) {
            return visited.get(target);
        }
        visited.set(target, false);
        if (isArray(target) && isReactive(target)) {
            visited.set(target, true);
            return true;
        }
        if (!isPlainObject(target) || isRaw(target) || isRef(target)) {
            return false;
        }
        return Object.keys(target).some(function (x) {
            return hasReactiveArrayChild(target[x], visited);
        });
    }
    function createSetupContext(vm) {
        var ctx = { slots: {} };
        var propsPlain = [
            'root',
            'parent',
            'refs',
            'listeners',
            'isServer',
            'ssrContext',
        ];
        var methodReturnVoid = ['emit'];
        propsPlain.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () { return vm[srcKey]; },
                set: function () {
                    ("production" !== 'production') &&
                        warn("Cannot assign to '".concat(key, "' because it is a read-only property"), vm);
                },
            });
        });
        updateVmAttrs(vm, ctx);
        methodReturnVoid.forEach(function (key) {
            var srcKey = "$".concat(key);
            proxy(ctx, key, {
                get: function () {
                    return function () {
                        var args = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            args[_i] = arguments[_i];
                        }
                        var fn = vm[srcKey];
                        fn.apply(vm, args);
                    };
                },
            });
        });
        if (false) {
            ctx._vm = vm;
        }
        return ctx;
    }
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData(from, to) {
    if (!from)
        return to;
    if (!to)
        return from;
    var key;
    var toVal;
    var fromVal;
    var keys = hasSymbol ? Reflect.ownKeys(from) : Object.keys(from);
    for (var i = 0; i < keys.length; i++) {
        key = keys[i];
        // in case the object is already observed...
        if (key === '__ob__')
            continue;
        toVal = to[key];
        fromVal = from[key];
        if (!hasOwn(to, key)) {
            to[key] = fromVal;
        }
        else if (toVal !== fromVal &&
            isPlainObject(toVal) &&
            !isRef(toVal) &&
            isPlainObject(fromVal) &&
            !isRef(fromVal)) {
            mergeData(fromVal, toVal);
        }
    }
    return to;
}
function install(Vue) {
    if (isVueRegistered(Vue)) {
        if ((false)) {
            warn('[vue-composition-api] already installed. Vue.use(VueCompositionAPI) should be called only once.');
        }
        return;
    }
    if ((false)) {
        if (Vue.version) {
            if (Vue.version[0] !== '2' || Vue.version[1] !== '.') {
                warn("[vue-composition-api] only works with Vue 2, v".concat(Vue.version, " found."));
            }
        }
        else {
            warn('[vue-composition-api] no Vue version found');
        }
    }
    Vue.config.optionMergeStrategies.setup = function (parent, child) {
        return function mergedSetupFn(props, context) {
            return mergeData(isFunction(parent) ? parent(props, context) || {} : undefined, isFunction(child) ? child(props, context) || {} : undefined);
        };
    };
    setVueConstructor(Vue);
    mixin(Vue);
}
var Plugin = {
    install: function (Vue) { return install(Vue); },
};

// implementation, close to no-op
function defineComponent(options) {
    return options;
}

function defineAsyncComponent(source) {
    if (isFunction(source)) {
        source = { loader: source };
    }
    var loader = source.loader, loadingComponent = source.loadingComponent, errorComponent = source.errorComponent, _a = source.delay, delay = _a === void 0 ? 200 : _a, timeout = source.timeout, // undefined = never times out
    _b = source.suspensible, // undefined = never times out
    suspensible = _b === void 0 ? false : _b, // in Vue 3 default is true
    userOnError = source.onError;
    if (false) {
        warn("The suspensiblbe option for async components is not supported in Vue2. It is ignored.");
    }
    var pendingRequest = null;
    var retries = 0;
    var retry = function () {
        retries++;
        pendingRequest = null;
        return load();
    };
    var load = function () {
        var thisRequest;
        return (pendingRequest ||
            (thisRequest = pendingRequest =
                loader()
                    .catch(function (err) {
                    err = err instanceof Error ? err : new Error(String(err));
                    if (userOnError) {
                        return new Promise(function (resolve, reject) {
                            var userRetry = function () { return resolve(retry()); };
                            var userFail = function () { return reject(err); };
                            userOnError(err, userRetry, userFail, retries + 1);
                        });
                    }
                    else {
                        throw err;
                    }
                })
                    .then(function (comp) {
                    if (thisRequest !== pendingRequest && pendingRequest) {
                        return pendingRequest;
                    }
                    if (false) {
                        warn("Async component loader resolved to undefined. " +
                            "If you are using retry(), make sure to return its return value.");
                    }
                    // interop module default
                    if (comp &&
                        (comp.__esModule || comp[Symbol.toStringTag] === 'Module')) {
                        comp = comp.default;
                    }
                    if (false) {
                        throw new Error("Invalid async component load result: ".concat(comp));
                    }
                    return comp;
                })));
    };
    return function () {
        var component = load();
        return {
            component: component,
            delay: delay,
            timeout: timeout,
            error: errorComponent,
            loading: loadingComponent,
        };
    };
}

var version = "1.7.1";
// auto install when using CDN
if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(Plugin);
}




/***/ }),

/***/ 1499:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export dataUrl */
/* unused harmony export wasmUrl */
/* harmony export (immutable) */ __webpack_exports__["a"] = configureSciChartWasm;
/* harmony export (immutable) */ __webpack_exports__["b"] = diagnoseSciChartWasm;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_scichart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_scichart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp__);




// Ścieżka musi być identyczna z tą, do której kopiuje build/scichart-wasm.js.
var basePath = "/static/scichart/" + __WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp__["libraryVersion"] + "/";

var dataUrl = basePath + "scichart2d.data";
var wasmUrl = basePath + "scichart2d.wasm";

function configureSciChartWasm() {
  __WEBPACK_IMPORTED_MODULE_1_scichart__["SciChartSurface"].configure({ dataUrl: dataUrl, wasmUrl: wasmUrl });
}

// SciChart łapie KAŻDY błąd ładowania wasm jednym catch-em (createMaster.js) i
// zawsze wypisuje ten sam komunikat o niezgodnych wersjach. Dlatego 404,
// przekierowanie na index.html przez fallback SPA, zły MIME i realny rozjazd
// wersji wyglądają w konsoli identycznie. Ta funkcja sprawdza, co serwer
// naprawdę zwraca, i nazywa przyczynę.
function diagnoseSciChartWasm() {
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all([check(wasmUrl, WASM_MAGIC), check(dataUrl, null)]).then(function (problems) {
    var found = problems.filter(Boolean);

    if (found.length) {
      console.error('[SciChart] Pliki wasm są nieosiągalne lub uszkodzone – wykresy nie ' + 'wystartują, a SciChart pokaże mylący komunikat o niezgodnych ' + 'wersjach.\n' + found.join('\n') + '\nOczekiwana wersja: ' + __WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp__["libraryVersion"] + '. Sprawdź, czy katalog ' + 'static/scichart/' + __WEBPACK_IMPORTED_MODULE_2_scichart_Core_BuildStamp__["libraryVersion"] + '/ został wgrany na serwer i ' + 'czy serwer nie przekierowuje tych ścieżek na index.html.');
    }

    return found;
  });
}

var WASM_MAGIC = [0x00, 0x61, 0x73, 0x6d]; // "\0asm"

function check(url, magic) {
  // Range zamiast pełnego GET – interesują nas tylko nagłówki i magic bytes.
  return fetch(url, { headers: { Range: 'bytes=0-7' } }).then(function (response) {
    if (!response.ok && response.status !== 206) {
      return url + ' → HTTP ' + response.status;
    }

    var contentType = response.headers.get('content-type') || '';

    // Fallback SPA odpowiada 200 z HTML-em, co Emscripten zgłasza jako błąd
    // instancjonowania modułu.
    if (contentType.indexOf('text/html') !== -1) {
      return url + ' → serwer zwrócił HTML (' + contentType + '), prawdopodobnie fallback SPA zamiast pliku';
    }

    if (!magic) {
      return null;
    }

    return response.arrayBuffer().then(function (buffer) {
      var bytes = new Uint8Array(buffer);
      var valid = magic.every(function (byte, i) {
        return bytes[i] === byte;
      });

      return valid ? null : url + ' → to nie jest moduł WebAssembly ' + '(nieprawidłowe pierwsze bajty, content-type: ' + contentType + ')';
    });
  }).catch(function (error) {
    return url + ' → żądanie nie doszło: ' + error.message;
  });
}

/***/ }),

/***/ 1500:
/***/ (function(module, exports, __webpack_require__) {

// SciChart 2.2 stawia dymek rollovera na prawo od punktu, a gdy się tam nie
// mieści — przesuwa go o całą szerokość w lewo, nie sprawdzając lewej krawędzi.
// Na wąskich wykresach (karty wagi stada) dymek wychodził wtedy poza płótno.
//
// Przesunięcie w poziomie liczy tylko calcTooltipProps, a RolloverModifier woła
// ją przez obiekt exports swojego modułu (CommonJS), więc wystarczy ją opakować:
// poprawione przesunięcie trafia do dymka od razu, bez dodatkowego renderowania.
// Import w main.js — działa dla wszystkich wykresów z rolloverem.
var rolloverModule = __webpack_require__(445);

var calcTooltipProps = rolloverModule.calcTooltipProps;

rolloverModule.calcTooltipProps = function (index, rs, rolloverProps, seriesViewRect, xValue, yValue, absoluteXCoord, absoluteYCoord, hitTestInfo, pixelRatio, isY1, isVerticalChart) {
    var props = calcTooltipProps.apply(this, arguments);
    if (!props || isVerticalChart) {
        return props;
    }

    // Współrzędne i szerokość obszaru serii są w pikselach płótna (× pixelRatio),
    // przesunięcie i szerokość dymka — w pikselach CSS.
    var width = rolloverProps.tooltip.width;
    var x = absoluteXCoord / pixelRatio;
    var viewWidth = seriesViewRect.width / pixelRatio;
    var left = x + props.xCoordShift;

    if (left >= 0 && left + width <= viewWidth) {
        return props;
    }

    // Strona punktu z większą ilością miejsca, potem dociągnięcie do krawędzi.
    var shift = viewWidth - x >= x ? 5 : -width;
    props.xCoordShift = Math.min(Math.max(shift, -x), viewWidth - width - x);
    return props;
};

/***/ }),

/***/ 1506:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/cows.bc8e675.jpg";

/***/ }),

/***/ 463:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_base__ = __webpack_require__(0);



//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  components: {},
  methods: {
    // Teksty siatek Syncfusion z bieżącego języka. Jeden obiekt pod każdą kulturą z plików
    // językowych (ej2LocaleCulture) — wcześniej Polish.json ustawiał "pl", a teksty były tylko
    // pod "pl-PL", więc np. nagłówki grup zostawały po angielsku.
    setGridCulture: function setGridCulture() {
      var _this = this;

      var t = function t(key) {
        return _this.$root.$i18n.t(key);
      };
      var texts = {
        grid: {
          EmptyRecord: t('emptyRecord'),
          Item: t('item'),
          Items: t('items'),
          Search: t('search'),
          Pdfexport: t('Pdfexport'),
          Excelexport: t('Excelexport'),
          Csvexport: t('Csvexport'),
          FilterButton: t('FilterButton'),
          ClearButton: t('ClearButton'),
          StartsWith: t('StartsWith'),
          EndsWith: t('EndsWith'),
          Contains: t('Contains'),
          Equal: t('Equal'),
          NotEqual: t('NotEqual'),
          LessThan: t('LessThan'),
          LessThanOrEqual: t('LessThanOrEqual'),
          GreaterThan: t('GreaterThan'),
          GreaterThanOrEqual: t('GreaterThanOrEqual'),
          ChooseDate: t('ChooseDate'),
          EnterValue: t('EnterValue'),
          NoResult: t('NoResult'),
          ClearFilter: t('ClearFilter'),
          ChooseColumns: t('ChooseColumns'),
          SelectAll: t('SelectAll'),
          Columnchooser: t('Columnchooser'),
          OKButton: t('OKButton'),
          CancelButton: t('CancelButton')
        },
        pager: {
          pagerDropDown: t('pagerDropDown'),
          currentPageInfo: t('currentPageInfo'),
          totalItemsInfo: t('totalItemsInfo'),
          totalItemInfo: t('totalItemInfo')
        }
      };
      var culture = t('ej2LocaleCulture');
      Object(__WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_base__["_14" /* setCulture */])(culture);
      __WEBPACK_IMPORTED_MODULE_3__syncfusion_ej2_base__["p" /* L10n */].load(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()({ 'en-US': texts }, culture, texts));
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this2.$store.dispatch('set_isMobile', /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));

              _this2.$root.$i18n.locale = _this2.$store.getters.language;
              _this2.setGridCulture();

            case 3:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  }
});

/***/ }),

/***/ 612:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Role; });
var Role = {
    Admin: 'Admin',
    User: 'User',
    Service: 'Service',
    PC: 'PC',
    Server: 'Server'
};

/***/ }),

/***/ 613:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_api__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_role__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_theme__ = __webpack_require__(624);









__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_3_vuex__["a" /* default */].Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user: JSON.parse(localStorage.getItem('user')) || {},
    pageSize: 25,
    filter: '',
    modalTitle: '',
    modalComponent: '',
    isModalVisible: false,
    isConfirmVisible: false,
    isLoading: false,
    id: '',
    isDeleteQuestion: false,
    systemId: null,
    deleteAction: function deleteAction() {},
    callback: function callback() {},
    dashboardStatus: null,
    serviceDetails: null,
    avatar: null,
    acceptedCookies: false,
    language: 'English',
    isMobile: false,
    hasTasks: false,
    hasTickets: false,
    theme: Object(__WEBPACK_IMPORTED_MODULE_7__utils_theme__["c" /* readStoredTheme */])(),
    systemPrefersDark: Object(__WEBPACK_IMPORTED_MODULE_7__utils_theme__["e" /* systemPrefersDark */])()
  },
  mutations: {
    change_theme: function change_theme(state, value) {
      state.theme = value;
      localStorage.setItem(__WEBPACK_IMPORTED_MODULE_7__utils_theme__["a" /* THEME_STORAGE_KEY */], value);
    },
    change_systemPrefersDark: function change_systemPrefersDark(state, value) {
      state.systemPrefersDark = value;
    },
    change_cookies: function change_cookies(state, val) {
      state.acceptedCookies = val;
      // console.log('change cookies: ' + val)
      localStorage.setItem('accCookies', val);
    },
    auth_request: function auth_request(state) {
      state.status = 'loading';
    },
    auth_success: function auth_success(state, user) {
      state.status = 'success';
      state.token = user.token;
      state.user = user;
    },
    auth_error: function auth_error(state) {
      state.status = 'error';
    },
    logout: function logout(state) {
      state.status = '';
      state.token = '';
      state.user = {};
    },
    update_profile: function update_profile(state, fullName) {
      state.user.fullName = fullName;
    },
    change_page_size: function change_page_size(state, pageSize) {
      state.pageSize = pageSize;
    },
    change_filter: function change_filter(state, filter) {
      state.filter = filter;
    },
    change_systemId: function change_systemId(state, id) {
      state.systemId = id;
    },
    change_dashboardStatus: function change_dashboardStatus(state, status) {
      state.dashboardStatus = status;
    },
    show_modal: function show_modal(state, _ref) {
      var modalTitle = _ref.modalTitle,
          modalComponent = _ref.modalComponent,
          callback = _ref.callback,
          id = _ref.id;

      state.modalTitle = modalTitle;
      state.modalComponent = modalComponent;
      state.id = id;
      state.callback = callback;
      state.isModalVisible = true;
    },
    hide_modal: function hide_modal(state) {
      state.modalTitle = '';
      state.modalComponent = '';
      state.id = '';
      state.callback = function () {};
      state.isModalVisible = false;
    },
    show_delete_confirm: function show_delete_confirm(state, deleteAction) {
      state.isDeleteQuestion = true;
      state.deleteAction = deleteAction;
    },
    hide_delete_confirm: function hide_delete_confirm(state) {
      state.isDeleteQuestion = false;
      state.deleteAction = function () {};
    },
    show_confirm: function show_confirm(state) {
      state.isConfirmVisible = true;
    },
    hide_confirm: function hide_confirm(state) {
      state.isConfirmVisible = false;
    },
    set_serviceDetails: function set_serviceDetails(state, service) {
      state.serviceDetails = service;
    },
    update_avatar: function update_avatar(state, avatar) {
      state.avatar = avatar;
    },
    set_loading: function set_loading(state, value) {
      state.isLoading = value;
    },
    change_language: function change_language(state, value) {
      state.language = value;
      localStorage.setItem('lang', value);
      // this.$root.$i18n.locale = value
    },
    change_isMobile: function change_isMobile(state, value) {
      state.isMobile = value;
    },
    system_hasTasks: function system_hasTasks(state, value) {
      state.hasTasks = value;
    },
    system_hasTickets: function system_hasTickets(state, value) {
      state.hasTickets = value;
    },
    change_systemTableShown: function change_systemTableShown(state, value) {
      localStorage.setItem('systemTableShownColumns', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(value));
    }
  },
  actions: {
    change_theme: function change_theme(_ref2, value) {
      var commit = _ref2.commit;

      commit('change_theme', value);
    },
    set_isMobile: function set_isMobile(_ref3, value) {
      var commit = _ref3.commit;

      commit('change_isMobile', value);
    },
    login: function login(_ref4, user) {
      var commit = _ref4.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('auth_request');
        Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_103" /* loginUser */])(user).then(function (resp) {
          if (["Server", "PC"].includes(resp.data.roles[0])) {
            console.log(resp.data.roles[0]);
            commit('auth_error');
            localStorage.removeItem('token');
            localStorage.removeItem('user');
            reject('Unauthorized access');
          }
          var token = resp.data.token;
          localStorage.setItem('token', 'Bearer ' + token);
          localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(resp.data));
          __WEBPACK_IMPORTED_MODULE_4_axios__["default"].defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('auth_success', resp.data);
          resolve(resp);
        }).catch(function (err) {
          commit('auth_error');
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          reject(err);
        });
      });
    },
    register: function register(_ref5, user) {
      var commit = _ref5.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('auth_request');
        Object(__WEBPACK_IMPORTED_MODULE_5__api_api__["_107" /* registerUser */])(user).then(function (resp) {
          var token = resp.data.token;
          localStorage.setItem('token', 'Bearer ' + token);
          localStorage.setItem('user', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(resp.data));
          __WEBPACK_IMPORTED_MODULE_4_axios__["default"].defaults.headers.common['Authorization'] = 'Bearer ' + token;
          commit('auth_success', resp.data);
          resolve(resp);
        }).catch(function (err) {
          commit('auth_error', err);
          localStorage.removeItem('token');
          localStorage.removeItem('user');
          reject(err);
        });
      });
    },
    logout: function logout(_ref6) {
      var commit = _ref6.commit;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('logout');
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        delete __WEBPACK_IMPORTED_MODULE_4_axios__["default"].defaults.headers.common['Authorization'];
        resolve();
      });
    },
    change_language: function change_language(_ref7, languageName) {
      var commit = _ref7.commit;

      commit('change_language', languageName);
    },
    update_cookies: function update_cookies(_ref8, val) {
      var commit = _ref8.commit;

      commit('change_cookies', val);
    },
    update_profile: function update_profile(_ref9, fullName) {
      var commit = _ref9.commit;

      commit('update_profile', fullName);
    },
    change_page_size: function change_page_size(_ref10, pageSize) {
      var commit = _ref10.commit;

      commit('change_page_size', pageSize);
    },
    change_filter: function change_filter(_ref11, filter) {
      var commit = _ref11.commit;

      commit('change_filter', filter);
    },
    change_systemId: function change_systemId(_ref12, id) {
      var commit = _ref12.commit;

      commit('change_systemId', id);
    },
    show_modal: function show_modal(_ref13, _ref14) {
      var commit = _ref13.commit;
      var modalTitle = _ref14.modalTitle,
          modalComponent = _ref14.modalComponent,
          callback = _ref14.callback,
          id = _ref14.id;

      commit('show_modal', { modalTitle: modalTitle, modalComponent: modalComponent, callback: callback, id: id });
    },
    hide_modal: function hide_modal(_ref15) {
      var commit = _ref15.commit;

      commit('hide_modal');
    },
    show_delete_confirm: function show_delete_confirm(_ref16, deleteAction) {
      var commit = _ref16.commit;

      commit('show_delete_confirm', deleteAction);
    },
    hide_delete_confirm: function hide_delete_confirm(_ref17) {
      var commit = _ref17.commit;

      commit('hide_delete_confirm');
    },
    change_dashboardStatus: function change_dashboardStatus(_ref18, status) {
      var commit = _ref18.commit;

      commit('change_dashboardStatus', status);
    },
    show_confirm: function show_confirm(_ref19) {
      var commit = _ref19.commit;

      commit('show_confirm');
    },
    hide_confirm: function hide_confirm(_ref20) {
      var commit = _ref20.commit;

      commit('hide_confirm');
    },
    set_serviceDetails: function set_serviceDetails(_ref21, service) {
      var commit = _ref21.commit;

      commit('set_serviceDetails', service);
    },
    update_avatar: function update_avatar(_ref22, avatar) {
      var commit = _ref22.commit;

      commit('update_avatar', avatar);
    },
    set_loading: function set_loading(_ref23, value) {
      var commit = _ref23.commit;

      commit('set_loading', value);
    },
    system_hasTasks: function system_hasTasks(_ref24, value) {
      var commit = _ref24.commit;

      commit('system_hasTasks', value);
    },
    system_hasTickets: function system_hasTickets(_ref25, value) {
      var commit = _ref25.commit;

      commit('system_hasTickets', value);
    },
    change_systemTableShown: function change_systemTableShown(_ref26, value) {
      var commit = _ref26.commit;

      commit('change_systemTableShown', value);
    }
  },
  getters: {
    theme: function theme(state) {
      return state.theme;
    },
    // 'light' | 'dark' — wybór 'system' rozwiązany według ustawień systemu.
    resolvedTheme: function resolvedTheme(state) {
      return Object(__WEBPACK_IMPORTED_MODULE_7__utils_theme__["d" /* resolveTheme */])(state.theme, state.systemPrefersDark);
    },
    isLoading: function isLoading(state) {
      return state.isLoading;
    },
    isLoggedIn: function isLoggedIn(state) {
      return !!state.token;
    },
    authStatus: function authStatus(state) {
      return state.status;
    },
    user: function user(state) {
      return state.user;
    },
    isAdmin: function isAdmin(state) {
      return state.user.roles != null && state.user.roles.includes(__WEBPACK_IMPORTED_MODULE_6__auth_role__["a" /* Role */].Admin);
    },
    isService: function isService(state) {
      return state.user.roles != null && state.user.roles.includes(__WEBPACK_IMPORTED_MODULE_6__auth_role__["a" /* Role */].Service);
    },
    isUser: function isUser(state) {
      return state.user.roles != null && state.user.roles.includes(__WEBPACK_IMPORTED_MODULE_6__auth_role__["a" /* Role */].User);
    },
    pageSize: function pageSize(state) {
      return state.pageSize;
    },
    filter: function filter(state) {
      return state.filter;
    },
    isModalVisible: function isModalVisible(state) {
      return state.isModalVisible;
    },
    isConfirmVisible: function isConfirmVisible(state) {
      return state.isConfirmVisible;
    },
    modalTitle: function modalTitle(state) {
      return state.modalTitle;
    },
    modalComponent: function modalComponent(state) {
      return state.modalComponent;
    },
    id: function id(state) {
      return state.id;
    },
    isDeleteQuestion: function isDeleteQuestion(state) {
      return state.isDeleteQuestion;
    },
    deleteAction: function deleteAction(state) {
      return state.deleteAction;
    },
    callback: function callback(state) {
      return state.callback;
    },
    systemId: function systemId(state) {
      return state.systemId;
    },
    dashboardStatus: function dashboardStatus(state) {
      return state.dashboardStatus;
    },
    serviceDetails: function serviceDetails(state) {
      return state.serviceDetails;
    },
    avatar: function avatar(state) {
      return state.avatar;
    },
    cookies: function cookies(state) {
      var c = localStorage.getItem('accCookies');
      state.acceptedCookies = c == undefined || c == 'false' ? false : true;
      return state.acceptedCookies;
    },
    language: function language(state) {
      var lang = localStorage.getItem('lang');
      state.language = lang == undefined ? 'English' : lang;
      return state.language;
    },
    isMobile: function isMobile(state) {
      return state.isMobile;
    },
    hasTasks: function hasTasks(state) {
      return state.hasTasks;
    },
    hasTickets: function hasTickets(state) {
      return state.hasTickets;
    },
    systemTableShownColumns: function systemTableShownColumns(state) {
      var columns = localStorage.getItem('systemTableShownColumns');
      if (columns == undefined) {
        return undefined;
      }
      try {
        var arr = JSON.parse(columns);
        return arr;
      } catch (ex) {
        localStorage.removeItem('systemTableShownColumns');
        return undefined;
      }
    }
  }
}));

/***/ }),

/***/ 624:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export THEMES */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return THEME_STORAGE_KEY; });
/* harmony export (immutable) */ __webpack_exports__["c"] = readStoredTheme;
/* harmony export (immutable) */ __webpack_exports__["e"] = systemPrefersDark;
/* harmony export (immutable) */ __webpack_exports__["d"] = resolveTheme;
/* unused harmony export applyTheme */
/* harmony export (immutable) */ __webpack_exports__["b"] = initTheme;
// Motyw aplikacji: 'light' | 'dark' | 'system'. Wybór użytkownika trzymamy
// w localStorage, a rozwiązany motyw (light/dark) ląduje w atrybucie
// data-theme na <html> — z niego korzystają tokeny w assets/css/theme.css.
//
// Atrybut zamiast klasy, bo w style.css klasa .light jest już zajęta
// (pomocnik od grubości fontu) i dopisana do <html> odchudziłaby cały tekst.
//
// Ten sam odczyt robi skrypt w index.html jeszcze przed załadowaniem bundla,
// żeby strona w trybie ciemnym nie mignęła jasnym tłem.

var THEMES = ['light', 'dark', 'system'];
var THEME_STORAGE_KEY = 'theme';

// Domyślnie jasny: tryb ciemny włącza się dopiero z wyboru użytkownika,
// więc dotychczasowi użytkownicy nie zobaczą nagłej zmiany wyglądu.
var DEFAULT_THEME = 'light';
var COLOR_SCHEME_QUERY = '(prefers-color-scheme: dark)';

function readStoredTheme() {
    try {
        var value = localStorage.getItem(THEME_STORAGE_KEY);
        return THEMES.includes(value) ? value : DEFAULT_THEME;
    } catch (e) {
        return DEFAULT_THEME;
    }
}

function systemPrefersDark() {
    return window.matchMedia(COLOR_SCHEME_QUERY).matches;
}

function resolveTheme(theme, prefersDark) {
    if (theme === 'system') return prefersDark ? 'dark' : 'light';
    return theme;
}

// Na czas przełączenia wyłączamy transitions — inaczej elementy z transition
// na kolorach (menu, przyciski) przechodzą płynnie, a reszta skokowo, i przez
// chwilę strona wygląda na rozjechaną.
function disableTransitionsTemporarily() {
    var style = document.createElement('style');
    style.appendChild(document.createTextNode('*,*::before,*::after{-webkit-transition:none!important;transition:none!important}'));
    document.head.appendChild(style);

    return function () {
        window.getComputedStyle(document.body);
        requestAnimationFrame(function () {
            return requestAnimationFrame(function () {
                return style.remove();
            });
        });
    };
}

function applyTheme(resolvedTheme) {
    var root = document.documentElement;
    if (root.getAttribute('data-theme') === resolvedTheme) return;

    var restoreTransitions = disableTransitionsTemporarily();
    root.setAttribute('data-theme', resolvedTheme);
    restoreTransitions();
}

// Spina motyw ze store: ustawia atrybut od razu, pilnuje zmian wyboru
// użytkownika, a w trybie systemowym także zmian ustawień systemu.
function initTheme(store) {
    applyTheme(store.getters.resolvedTheme);
    store.watch(function (state, getters) {
        return getters.resolvedTheme;
    }, applyTheme);

    var media = window.matchMedia(COLOR_SCHEME_QUERY);
    var onSystemChange = function onSystemChange(event) {
        return store.commit('change_systemPrefersDark', event.matches);
    };
    if (media.addEventListener) {
        media.addEventListener('change', onSystemChange);
    } else {
        media.addListener(onSystemChange);
    }

    // Motyw zmieniony w innej karcie — dociągamy go tutaj.
    window.addEventListener('storage', function (event) {
        if (event.key === THEME_STORAGE_KEY) {
            store.commit('change_theme', readStoredTheme());
        }
    });
}

/***/ }),

/***/ 952:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_96", function() { return getUserSystems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_134", function() { return updateUserSystems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_95", function() { return getUserSystemById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_107", function() { return registerUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_103", function() { return loginUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_93", function() { return getUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_92", function() { return getUserById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_132", function() { return updateUserPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_94", function() { return getUserPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return changePassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_69", function() { return getSystemDevices; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return deleteUser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return deleteOwnAccount; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_122", function() { return updateCurrentUserData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_131", function() { return updateUserAccountData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_109", function() { return restorePassword; });
/* unused harmony export deleteDevice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_5", function() { return getAllUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_6", function() { return getAllUsersNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_82", function() { return getSystemUsersNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_133", function() { return updateUserRole; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_108", function() { return removeUserRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_46", function() { return getRoles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return getAlarmsByIdAndDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return getAlarmsForDetailsModal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return getAlarmsOverview; });
/* unused harmony export getAlarmsOverviewForSystem */
/* unused harmony export dismissAllAlarms */
/* unused harmony export getAlarmsCount */
/* unused harmony export getAlarmFilters */
/* unused harmony export getLastWeekAlarmsForSystem */
/* unused harmony export changeAlarmState */
/* unused harmony export deleteAlarm */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_68", function() { return getSystemAlarmsByPriorityFromWeek; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_31", function() { return getLastWeekAlarmsForSystemPerDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_0", function() { return getAllAlarmTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_1", function() { return getAllAlarmTypesFaq; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_2", function() { return getAllAlarmTypesForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_126", function() { return updateSendToMobileStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_125", function() { return updateSendPushStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_35", function() { return getNotDisabledAlarmTypesForSystem; });
/* unused harmony export getDeviceAlarms */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_23", function() { return getDeviceAlarmFromDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_26", function() { return getDevicesForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_53", function() { return getSoftwareHistoryForDevice; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_4", function() { return getAllFarmsNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_28", function() { return getFarms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_20", function() { return getContactInfo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_121", function() { return updateContactInfo; });
/* unused harmony export getContacts */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_21", function() { return getContactsBySystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_124", function() { return updatePcUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_84", function() { return getSystemsCoordinates; });
/* unused harmony export getSystemsStatus */
/* unused harmony export getSystems */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_87", function() { return getSystemsOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_86", function() { return getSystemsFromMode; });
/* unused harmony export getSystemFarms */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_89", function() { return getSystemsWithCountries; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_67", function() { return getSystemAlarmFromDay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_66", function() { return getSystemAlarmChartsForDay; });
/* unused harmony export getSystemAlarmChartsForWeek */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_70", function() { return getSystemFarmById; });
/* unused harmony export deleteSystem */
/* unused harmony export getSystem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_127", function() { return updateSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return addSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_73", function() { return getSystemImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return addSystemWithDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return editSystemWithDetails; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_78", function() { return getSystemStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_88", function() { return getSystemsStatusList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_77", function() { return getSystemStatusById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_72", function() { return getSystemGeneralData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_41", function() { return getRemoteAccessForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_42", function() { return getRemoteAccessPasswordForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return addRemoteAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return editRemoteAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return editRemoteAccessPassword; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return deleteRemoteAccess; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_81", function() { return getSystemTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_76", function() { return getSystemStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_25", function() { return getDeviceStatusFromDatesToChart; });
/* unused harmony export getRoughageSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_47", function() { return getRoughageSettingsHistory; });
/* unused harmony export getSortingSettings */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_63", function() { return getSortingSettingsHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_32", function() { return getLoadCellDataHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_36", function() { return getPdfAlarmReportBySystemId; });
/* unused harmony export getSystemAlarms */
/* unused harmony export getSystemAlarmDetails */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_3", function() { return getAllContacts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_22", function() { return getContactsBySystemId; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_19", function() { return getContactById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return addContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_120", function() { return updateContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return deleteContact; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_27", function() { return getExistingGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return assignUserToGroups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_64", function() { return getStatisticsForSystem; });
/* unused harmony export getVisitsForSystem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_101", function() { return getVisitsForSystemById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_100", function() { return getVisits; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_99", function() { return getVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return editVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_112", function() { return saveVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return getActiveOrFutureVisitsNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return getActiveProblemsForVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_85", function() { return getSystemsForFarm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_43", function() { return getReportForFinishedVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_39", function() { return getProblems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_37", function() { return getProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_40", function() { return getProblemsForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_110", function() { return saveProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return editProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_38", function() { return getProblemPhotos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return deleteResourceFromProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_62", function() { return getSolutionsForVisit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_61", function() { return getSolutionsForProblem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetSystemNames; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_58", function() { return getSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_111", function() { return saveSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return editSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_60", function() { return getSolutions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_59", function() { return getSolutionResourceById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return deleteResourceFromSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return deleteSolution; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_80", function() { return getSystemTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_104", function() { return postNewTicket; });
/* unused harmony export closeTicket */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_65", function() { return getStatusForSystemsTickets; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_106", function() { return readTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return confirmRequestToClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return denyRequestToClose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_34", function() { return getMessagesForTicket; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_33", function() { return getMessageResource; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_113", function() { return sendMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_30", function() { return getInvitations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return deleteInvitations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return disableInvitations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return enableInvitations; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return createInvitation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_123", function() { return updateInvitation; });
/* unused harmony export resendInvitation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_24", function() { return getDeviceStatisticsForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_71", function() { return getSystemGeneralAlarms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_79", function() { return getSystemTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return dismissAlarms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return dismissManyAlarms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_102", function() { return hasTasks; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_52", function() { return getShortDevicesList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return getAlarmSystemRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return addAlarmSystemRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_117", function() { return turnOnAllAlarmsForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_116", function() { return turnOnAlarmTypeForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_75", function() { return getSystemSettingsOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_128", function() { return updateSystemAlarmOff; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_129", function() { return updateSystemCheckupDone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_90", function() { return getTodayCheckupForSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_91", function() { return getUnknownAnimalWeightAlarmParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_130", function() { return updateUnknownAnimalWeightAlarmParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_17", function() { return getCalibrationDateErrorAfterDaysParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_118", function() { return updateCalibrationDateErrorAfterDaysParam; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_29", function() { return getHerdWeight; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_10", function() { return getAnimals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_9", function() { return getAnimalWeightChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_7", function() { return getAnimalConsumptionChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_8", function() { return getAnimalVisitsChart; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_49", function() { return getSensorsChartData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_18", function() { return getCloudServers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_51", function() { return getServerUsers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return addServerConfiguration; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return assignServerSystem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return assignServerManager; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return deleteServer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_50", function() { return getServerSystems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_83", function() { return getSystemsAvailableForCloud; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_119", function() { return updateCloudSystemAssigment; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_98", function() { return getVersionsOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_97", function() { return getVersionById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addNewSoftwareVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_55", function() { return getSoftwareProducts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_57", function() { return getSoftwareVersionInfoById; });
/* unused harmony export uploadBigSoftwareFileChunk */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_135", function() { return uploadBigSoftwareFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_136", function() { return uploadRequirementFile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_54", function() { return getSoftwarePlatforms; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_14", function() { return getArchitectures; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return deleteVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return editSoftwareVersion; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_56", function() { return getSoftwareShortcutCards; });
/* unused harmony export getSoftwareShortcutById */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return addSoftwareShortcut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return editSoftwareShortcut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return deleteSoftwareShortcut; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return addRequirement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return editRequirement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return deleteRequirement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_45", function() { return getRequirementsList; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_44", function() { return getRequirementById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_16", function() { return getBackupsOverview; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_15", function() { return getBackupById; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return deleteBackup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_48", function() { return getScheduledReports; });
/* unused harmony export getScheduledReport */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return addScheduledReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return editScheduledReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return deleteScheduledReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_105", function() { return previewScheduledReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_115", function() { return sendScheduledReportNow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_12", function() { return getApiUsageReport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_13", function() { return getApiUsageTimeline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_11", function() { return getApiUsageEndpoints; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_74", function() { return getSystemNotifications; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_114", function() { return sendNotificationsNow; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);



var axios = __webpack_require__(297).default;

/* USERSYSTEM CONTROLLER */
var getUserSystems = function () {
    var _ref = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return axios.get('UserSystem');

                    case 2:
                        result = _context.sent;
                        return _context.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function getUserSystems() {
        return _ref.apply(this, arguments);
    };
}();

var updateUserSystems = function () {
    var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2(userSystems) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        _context2.next = 2;
                        return axios.put('UserSystem', userSystems);

                    case 2:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, this);
    }));

    return function updateUserSystems(_x) {
        return _ref2.apply(this, arguments);
    };
}();

var getUserSystemById = function () {
    var _ref3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        _context3.next = 2;
                        return axios.get('UserSystem/' + id);

                    case 2:
                        result = _context3.sent;
                        return _context3.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, this);
    }));

    return function getUserSystemById(_x2) {
        return _ref3.apply(this, arguments);
    };
}();

/* ACCOUNT CONTROLLER */

var registerUser = function () {
    var _ref4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee4(user) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        return _context4.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            axios.post('Account/register', user).then(function (response) {
                                resolve(response);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, this);
    }));

    return function registerUser(_x3) {
        return _ref4.apply(this, arguments);
    };
}();

var loginUser = function () {
    var _ref5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee5(user) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        return _context5.abrupt('return', axios.post('Account/login', user));

                    case 1:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, this);
    }));

    return function loginUser(_x4) {
        return _ref5.apply(this, arguments);
    };
}();

var getUserData = function () {
    var _ref6 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee6() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        _context6.next = 2;
                        return axios.get('Account');

                    case 2:
                        result = _context6.sent;
                        return _context6.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, this);
    }));

    return function getUserData() {
        return _ref6.apply(this, arguments);
    };
}();

var getUserById = function () {
    var _ref7 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee7(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        _context7.next = 2;
                        return axios.get('Account/' + id);

                    case 2:
                        result = _context7.sent;
                        return _context7.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, this);
    }));

    return function getUserById(_x5) {
        return _ref7.apply(this, arguments);
    };
}();

var updateUserPhoto = function () {
    var _ref8 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee8(id, photoObject) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        return _context8.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            axios.put('Account/' + id + '/image', photoObject, {
                                headers: {
                                    'content-type': 'multipart/form-data'
                                }
                            }).then(function (response) {
                                resolve(response);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, this);
    }));

    return function updateUserPhoto(_x6, _x7) {
        return _ref8.apply(this, arguments);
    };
}();

var getUserPhoto = function () {
    var _ref9 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee9(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.next = 2;
                        return axios.get('Account/' + id + '/image', { responseType: 'blob' });

                    case 2:
                        result = _context9.sent;
                        return _context9.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, this);
    }));

    return function getUserPhoto(_x8) {
        return _ref9.apply(this, arguments);
    };
}();

var changePassword = function () {
    var _ref10 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee10(dto) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        return _context10.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            axios.post('Account/reset/password', dto).then(function (response) {
                                resolve(response);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, this);
    }));

    return function changePassword(_x9) {
        return _ref10.apply(this, arguments);
    };
}();

var getSystemDevices = function () {
    var _ref11 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee11(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        _context11.next = 2;
                        return axios.get('System/' + id + '/devices');

                    case 2:
                        result = _context11.sent;
                        return _context11.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, this);
    }));

    return function getSystemDevices(_x10) {
        return _ref11.apply(this, arguments);
    };
}();

var deleteUser = function () {
    var _ref12 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee12(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        _context12.next = 2;
                        return axios.delete('Account/' + id);

                    case 2:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, this);
    }));

    return function deleteUser(_x11) {
        return _ref12.apply(this, arguments);
    };
}();

var deleteOwnAccount = function () {
    var _ref13 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee13() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        _context13.next = 2;
                        return axios.delete('Account/own');

                    case 2:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, this);
    }));

    return function deleteOwnAccount() {
        return _ref13.apply(this, arguments);
    };
}();

var updateCurrentUserData = function () {
    var _ref14 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee14(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        _context14.next = 2;
                        return axios.put('Account', data);

                    case 2:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, this);
    }));

    return function updateCurrentUserData(_x12) {
        return _ref14.apply(this, arguments);
    };
}();

var updateUserAccountData = function () {
    var _ref15 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee15(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.next = 2;
                        return axios.put('Account/update', data);

                    case 2:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, this);
    }));

    return function updateUserAccountData(_x13) {
        return _ref15.apply(this, arguments);
    };
}();

var restorePassword = function () {
    var _ref16 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee16(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        _context16.next = 2;
                        return axios.put('Account/restore/password', data);

                    case 2:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, this);
    }));

    return function restorePassword(_x14) {
        return _ref16.apply(this, arguments);
    };
}();

var deleteDevice = function () {
    var _ref17 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee17(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        _context17.next = 2;
                        return axios.delete('Device/' + id);

                    case 2:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, this);
    }));

    return function deleteDevice(_x15) {
        return _ref17.apply(this, arguments);
    };
}();

var getAllUsers = function () {
    var _ref18 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee18() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        _context18.next = 2;
                        return axios.get('Account/all');

                    case 2:
                        result = _context18.sent;
                        return _context18.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, this);
    }));

    return function getAllUsers() {
        return _ref18.apply(this, arguments);
    };
}();

var getAllUsersNames = function () {
    var _ref19 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee19() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        _context19.next = 2;
                        return axios.get('Account/names');

                    case 2:
                        result = _context19.sent;
                        return _context19.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, this);
    }));

    return function getAllUsersNames() {
        return _ref19.apply(this, arguments);
    };
}();

var getSystemUsersNames = function () {
    var _ref20 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee20(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        _context20.next = 2;
                        return axios.get('Account/systemnames/' + systemId);

                    case 2:
                        result = _context20.sent;
                        return _context20.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, this);
    }));

    return function getSystemUsersNames(_x16) {
        return _ref20.apply(this, arguments);
    };
}();

var updateUserRole = function () {
    var _ref21 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee21(id, role) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        _context21.next = 2;
                        return axios.put('Account/' + id + '/' + role);

                    case 2:
                    case 'end':
                        return _context21.stop();
                }
            }
        }, _callee21, this);
    }));

    return function updateUserRole(_x17, _x18) {
        return _ref21.apply(this, arguments);
    };
}();

var removeUserRoles = function () {
    var _ref22 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee22(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee22$(_context22) {
            while (1) {
                switch (_context22.prev = _context22.next) {
                    case 0:
                        _context22.next = 2;
                        return axios.put('Account/' + id + '/role/remove');

                    case 2:
                    case 'end':
                        return _context22.stop();
                }
            }
        }, _callee22, this);
    }));

    return function removeUserRoles(_x19) {
        return _ref22.apply(this, arguments);
    };
}();

/* ROLE CONTROLLER */

var getRoles = function () {
    var _ref23 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee23() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee23$(_context23) {
            while (1) {
                switch (_context23.prev = _context23.next) {
                    case 0:
                        _context23.next = 2;
                        return axios.get('Role');

                    case 2:
                        result = _context23.sent;
                        return _context23.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context23.stop();
                }
            }
        }, _callee23, this);
    }));

    return function getRoles() {
        return _ref23.apply(this, arguments);
    };
}();

/* ALARM CONTROLLER */

var getAlarmsByIdAndDay = function () {
    var _ref24 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee24(id, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee24$(_context24) {
            while (1) {
                switch (_context24.prev = _context24.next) {
                    case 0:
                        _context24.next = 2;
                        return axios.get('Alarm/' + id + '/' + day);

                    case 2:
                        result = _context24.sent;
                        return _context24.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context24.stop();
                }
            }
        }, _callee24, this);
    }));

    return function getAlarmsByIdAndDay(_x20, _x21) {
        return _ref24.apply(this, arguments);
    };
}();

var getAlarmsForDetailsModal = function () {
    var _ref25 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee25(alarmTypeId, systemId, deviceId, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee25$(_context25) {
            while (1) {
                switch (_context25.prev = _context25.next) {
                    case 0:
                        _context25.next = 2;
                        return axios.get('Alarm/' + alarmTypeId + '/' + systemId + '/' + deviceId + '/' + day);

                    case 2:
                        result = _context25.sent;
                        return _context25.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context25.stop();
                }
            }
        }, _callee25, this);
    }));

    return function getAlarmsForDetailsModal(_x22, _x23, _x24, _x25) {
        return _ref25.apply(this, arguments);
    };
}();

var getAlarmsOverview = function () {
    var _ref26 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee26() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee26$(_context26) {
            while (1) {
                switch (_context26.prev = _context26.next) {
                    case 0:
                        _context26.next = 2;
                        return axios.get('Alarm/overview');

                    case 2:
                        result = _context26.sent;
                        return _context26.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context26.stop();
                }
            }
        }, _callee26, this);
    }));

    return function getAlarmsOverview() {
        return _ref26.apply(this, arguments);
    };
}();

var getAlarmsOverviewForSystem = function () {
    var _ref27 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee27(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee27$(_context27) {
            while (1) {
                switch (_context27.prev = _context27.next) {
                    case 0:
                        _context27.next = 2;
                        return axios.get('Alarm/overview/' + systemId);

                    case 2:
                        result = _context27.sent;
                        return _context27.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context27.stop();
                }
            }
        }, _callee27, this);
    }));

    return function getAlarmsOverviewForSystem(_x26) {
        return _ref27.apply(this, arguments);
    };
}();

var dismissAllAlarms = function () {
    var _ref28 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee28(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee28$(_context28) {
            while (1) {
                switch (_context28.prev = _context28.next) {
                    case 0:
                        _context28.next = 2;
                        return axios.put('Alarm/' + id + '/alarms/dismiss/all');

                    case 2:
                    case 'end':
                        return _context28.stop();
                }
            }
        }, _callee28, this);
    }));

    return function dismissAllAlarms(_x27) {
        return _ref28.apply(this, arguments);
    };
}();

var getAlarmsCount = function () {
    var _ref29 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee29() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee29$(_context29) {
            while (1) {
                switch (_context29.prev = _context29.next) {
                    case 0:
                        _context29.next = 2;
                        return axios.get('Alarm/count');

                    case 2:
                        result = _context29.sent;
                        return _context29.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context29.stop();
                }
            }
        }, _callee29, this);
    }));

    return function getAlarmsCount() {
        return _ref29.apply(this, arguments);
    };
}();

var getAlarmFilters = function () {
    var _ref30 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee30() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee30$(_context30) {
            while (1) {
                switch (_context30.prev = _context30.next) {
                    case 0:
                        _context30.next = 2;
                        return axios.get('Alarm/filters');

                    case 2:
                        result = _context30.sent;
                        return _context30.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context30.stop();
                }
            }
        }, _callee30, this);
    }));

    return function getAlarmFilters() {
        return _ref30.apply(this, arguments);
    };
}();

var getLastWeekAlarmsForSystem = function () {
    var _ref31 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee31(systemId, deviceId, alarmTypeId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee31$(_context31) {
            while (1) {
                switch (_context31.prev = _context31.next) {
                    case 0:
                        _context31.next = 2;
                        return axios.get('Alarm/lastWeek/' + systemId + '/' + deviceId + '/' + alarmTypeId);

                    case 2:
                        result = _context31.sent;
                        return _context31.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context31.stop();
                }
            }
        }, _callee31, this);
    }));

    return function getLastWeekAlarmsForSystem(_x28, _x29, _x30) {
        return _ref31.apply(this, arguments);
    };
}();

var changeAlarmState = function () {
    var _ref32 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee32(id, state) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee32$(_context32) {
            while (1) {
                switch (_context32.prev = _context32.next) {
                    case 0:
                        _context32.next = 2;
                        return axios.put('Alarm/' + id + '/' + state);

                    case 2:
                    case 'end':
                        return _context32.stop();
                }
            }
        }, _callee32, this);
    }));

    return function changeAlarmState(_x31, _x32) {
        return _ref32.apply(this, arguments);
    };
}();

var deleteAlarm = function () {
    var _ref33 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee33(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee33$(_context33) {
            while (1) {
                switch (_context33.prev = _context33.next) {
                    case 0:
                        _context33.next = 2;
                        return axios.delete('Alarm/' + id);

                    case 2:
                    case 'end':
                        return _context33.stop();
                }
            }
        }, _callee33, this);
    }));

    return function deleteAlarm(_x33) {
        return _ref33.apply(this, arguments);
    };
}();

var getSystemAlarmsByPriorityFromWeek = function () {
    var _ref34 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee34(systemId, priority) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee34$(_context34) {
            while (1) {
                switch (_context34.prev = _context34.next) {
                    case 0:
                        _context34.next = 2;
                        return axios.get('Alarm/lastWeek/systems/' + systemId + '/' + priority);

                    case 2:
                        result = _context34.sent;
                        return _context34.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context34.stop();
                }
            }
        }, _callee34, this);
    }));

    return function getSystemAlarmsByPriorityFromWeek(_x34, _x35) {
        return _ref34.apply(this, arguments);
    };
}();

var getLastWeekAlarmsForSystemPerDevice = function () {
    var _ref35 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee35(deviceId, from, to) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee35$(_context35) {
            while (1) {
                switch (_context35.prev = _context35.next) {
                    case 0:
                        _context35.next = 2;
                        return axios.get('Alarm/lastWeek/perDevice/' + deviceId + '/' + from + '/' + to);

                    case 2:
                        result = _context35.sent;
                        return _context35.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context35.stop();
                }
            }
        }, _callee35, this);
    }));

    return function getLastWeekAlarmsForSystemPerDevice(_x36, _x37, _x38) {
        return _ref35.apply(this, arguments);
    };
}();

/* ALARM GROUP CONTROLLER */

/* ALARM TYPE CONTROLLER */

var getAllAlarmTypes = function () {
    var _ref36 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee36() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee36$(_context36) {
            while (1) {
                switch (_context36.prev = _context36.next) {
                    case 0:
                        _context36.next = 2;
                        return axios.get('AlarmType/all/toShow');

                    case 2:
                        result = _context36.sent;
                        return _context36.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context36.stop();
                }
            }
        }, _callee36, this);
    }));

    return function getAllAlarmTypes() {
        return _ref36.apply(this, arguments);
    };
}();

var getAllAlarmTypesFaq = function () {
    var _ref37 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee37() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee37$(_context37) {
            while (1) {
                switch (_context37.prev = _context37.next) {
                    case 0:
                        _context37.next = 2;
                        return axios.get('AlarmType/all');

                    case 2:
                        result = _context37.sent;
                        return _context37.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context37.stop();
                }
            }
        }, _callee37, this);
    }));

    return function getAllAlarmTypesFaq() {
        return _ref37.apply(this, arguments);
    };
}();

var getAllAlarmTypesForSystem = function () {
    var _ref38 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee38(systemId, from, to) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee38$(_context38) {
            while (1) {
                switch (_context38.prev = _context38.next) {
                    case 0:
                        _context38.next = 2;
                        return axios.get('AlarmType/count/' + systemId + '/' + from + '/' + to);

                    case 2:
                        result = _context38.sent;
                        return _context38.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context38.stop();
                }
            }
        }, _callee38, this);
    }));

    return function getAllAlarmTypesForSystem(_x39, _x40, _x41) {
        return _ref38.apply(this, arguments);
    };
}();

var updateSendToMobileStatus = function () {
    var _ref39 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee39(id, sendToMobile) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee39$(_context39) {
            while (1) {
                switch (_context39.prev = _context39.next) {
                    case 0:
                        _context39.next = 2;
                        return axios.put('alarmType/isSendToMobile/' + id + '/' + sendToMobile);

                    case 2:
                    case 'end':
                        return _context39.stop();
                }
            }
        }, _callee39, this);
    }));

    return function updateSendToMobileStatus(_x42, _x43) {
        return _ref39.apply(this, arguments);
    };
}();

var updateSendPushStatus = function () {
    var _ref40 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee40(id, sendPush) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee40$(_context40) {
            while (1) {
                switch (_context40.prev = _context40.next) {
                    case 0:
                        _context40.next = 2;
                        return axios.put('alarmType/isSendPush/' + id + '/' + sendPush);

                    case 2:
                    case 'end':
                        return _context40.stop();
                }
            }
        }, _callee40, this);
    }));

    return function updateSendPushStatus(_x44, _x45) {
        return _ref40.apply(this, arguments);
    };
}();

var getNotDisabledAlarmTypesForSystem = function () {
    var _ref41 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee41(systemId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee41$(_context41) {
            while (1) {
                switch (_context41.prev = _context41.next) {
                    case 0:
                        _context41.next = 2;
                        return axios.get('AlarmType/notDisabled/' + systemId);

                    case 2:
                        response = _context41.sent;
                        return _context41.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context41.stop();
                }
            }
        }, _callee41, this);
    }));

    return function getNotDisabledAlarmTypesForSystem(_x46) {
        return _ref41.apply(this, arguments);
    };
}();

/* DEVICE CONTROLLER */

var getDeviceAlarms = function () {
    var _ref42 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee42(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee42$(_context42) {
            while (1) {
                switch (_context42.prev = _context42.next) {
                    case 0:
                        _context42.next = 2;
                        return axios.get('Device/alarms/' + id);

                    case 2:
                        result = _context42.sent;
                        return _context42.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context42.stop();
                }
            }
        }, _callee42, this);
    }));

    return function getDeviceAlarms(_x47) {
        return _ref42.apply(this, arguments);
    };
}();

var getDeviceAlarmFromDay = function () {
    var _ref43 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee43(deviceId, type, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee43$(_context43) {
            while (1) {
                switch (_context43.prev = _context43.next) {
                    case 0:
                        _context43.next = 2;
                        return axios.get('Device/alarms/' + deviceId + '/' + day + '/' + type);

                    case 2:
                        result = _context43.sent;
                        return _context43.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context43.stop();
                }
            }
        }, _callee43, this);
    }));

    return function getDeviceAlarmFromDay(_x48, _x49, _x50) {
        return _ref43.apply(this, arguments);
    };
}();

var getDevicesForSystem = function () {
    var _ref44 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee44(systemId, from, to) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee44$(_context44) {
            while (1) {
                switch (_context44.prev = _context44.next) {
                    case 0:
                        _context44.next = 2;
                        return axios.get('Device/system/' + systemId + '/' + from.toISOString() + '/' + to.toISOString());

                    case 2:
                        result = _context44.sent;
                        return _context44.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context44.stop();
                }
            }
        }, _callee44, this);
    }));

    return function getDevicesForSystem(_x51, _x52, _x53) {
        return _ref44.apply(this, arguments);
    };
}();

/* DEVICE HISTORY CONTROLLER */

var getSoftwareHistoryForDevice = function () {
    var _ref45 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee45(deviceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee45$(_context45) {
            while (1) {
                switch (_context45.prev = _context45.next) {
                    case 0:
                        _context45.next = 2;
                        return axios.get('Device/software/history/' + deviceId);

                    case 2:
                        result = _context45.sent;
                        return _context45.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context45.stop();
                }
            }
        }, _callee45, this);
    }));

    return function getSoftwareHistoryForDevice(_x54) {
        return _ref45.apply(this, arguments);
    };
}();

/* DEVICE TYPE CONTROLLER */

/* FARM CONTROLLER */

var getAllFarmsNames = function () {
    var _ref46 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee46() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee46$(_context46) {
            while (1) {
                switch (_context46.prev = _context46.next) {
                    case 0:
                        _context46.next = 2;
                        return axios.get('System/farmNames');

                    case 2:
                        result = _context46.sent;
                        return _context46.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context46.stop();
                }
            }
        }, _callee46, this);
    }));

    return function getAllFarmsNames() {
        return _ref46.apply(this, arguments);
    };
}();

var getFarms = function () {
    var _ref47 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee47() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee47$(_context47) {
            while (1) {
                switch (_context47.prev = _context47.next) {
                    case 0:
                        _context47.next = 2;
                        return axios.get('System/farms');

                    case 2:
                        result = _context47.sent;
                        return _context47.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context47.stop();
                }
            }
        }, _callee47, this);
    }));

    return function getFarms() {
        return _ref47.apply(this, arguments);
    };
}();

/* CONTACT FORM CONTROLLER */

var getContactInfo = function () {
    var _ref48 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee48(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee48$(_context48) {
            while (1) {
                switch (_context48.prev = _context48.next) {
                    case 0:
                        _context48.next = 2;
                        return axios.get('contact/system/' + id);

                    case 2:
                        result = _context48.sent;
                        return _context48.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context48.stop();
                }
            }
        }, _callee48, this);
    }));

    return function getContactInfo(_x55) {
        return _ref48.apply(this, arguments);
    };
}();

var updateContactInfo = function () {
    var _ref49 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee49(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee49$(_context49) {
            while (1) {
                switch (_context49.prev = _context49.next) {
                    case 0:
                        _context49.next = 2;
                        return axios.post('contact', data);

                    case 2:
                    case 'end':
                        return _context49.stop();
                }
            }
        }, _callee49, this);
    }));

    return function updateContactInfo(_x56) {
        return _ref49.apply(this, arguments);
    };
}();

var getContacts = function () {
    var _ref50 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee50() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee50$(_context50) {
            while (1) {
                switch (_context50.prev = _context50.next) {
                    case 0:
                        _context50.next = 2;
                        return axios.get('contact');

                    case 2:
                        result = _context50.sent;
                        return _context50.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context50.stop();
                }
            }
        }, _callee50, this);
    }));

    return function getContacts() {
        return _ref50.apply(this, arguments);
    };
}();

var getContactsBySystem = function () {
    var _ref51 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee51(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee51$(_context51) {
            while (1) {
                switch (_context51.prev = _context51.next) {
                    case 0:
                        _context51.next = 2;
                        return axios.get('contact/system/' + systemId);

                    case 2:
                        result = _context51.sent;
                        return _context51.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context51.stop();
                }
            }
        }, _callee51, this);
    }));

    return function getContactsBySystem(_x57) {
        return _ref51.apply(this, arguments);
    };
}();

var updatePcUpdate = function () {
    var _ref52 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee52(systemId, status) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee52$(_context52) {
            while (1) {
                switch (_context52.prev = _context52.next) {
                    case 0:
                        _context52.next = 2;
                        return axios.put('contact/' + systemId + '/' + status);

                    case 2:
                    case 'end':
                        return _context52.stop();
                }
            }
        }, _callee52, this);
    }));

    return function updatePcUpdate(_x58, _x59) {
        return _ref52.apply(this, arguments);
    };
}();

var getSystemsCoordinates = function () {
    var _ref53 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee53(mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee53$(_context53) {
            while (1) {
                switch (_context53.prev = _context53.next) {
                    case 0:
                        _context53.next = 2;
                        return axios.get('contact/map/overview/' + mode);

                    case 2:
                        result = _context53.sent;
                        return _context53.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context53.stop();
                }
            }
        }, _callee53, this);
    }));

    return function getSystemsCoordinates(_x60) {
        return _ref53.apply(this, arguments);
    };
}();

/* SYSTEM CONTROLLER */
var getSystemsStatus = function () {
    var _ref54 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee54() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee54$(_context54) {
            while (1) {
                switch (_context54.prev = _context54.next) {
                    case 0:
                        _context54.next = 2;
                        return axios.get('System/dashboard/status');

                    case 2:
                        result = _context54.sent;
                        return _context54.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context54.stop();
                }
            }
        }, _callee54, this);
    }));

    return function getSystemsStatus() {
        return _ref54.apply(this, arguments);
    };
}();

var getSystems = function () {
    var _ref55 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee55() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee55$(_context55) {
            while (1) {
                switch (_context55.prev = _context55.next) {
                    case 0:
                        _context55.next = 2;
                        return axios.get('System/all');

                    case 2:
                        result = _context55.sent;
                        return _context55.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context55.stop();
                }
            }
        }, _callee55, this);
    }));

    return function getSystems() {
        return _ref55.apply(this, arguments);
    };
}();

var getSystemsOverview = function () {
    var _ref56 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee56() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee56$(_context56) {
            while (1) {
                switch (_context56.prev = _context56.next) {
                    case 0:
                        _context56.next = 2;
                        return axios.get('System/overview');

                    case 2:
                        result = _context56.sent;
                        return _context56.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context56.stop();
                }
            }
        }, _callee56, this);
    }));

    return function getSystemsOverview() {
        return _ref56.apply(this, arguments);
    };
}();

/*
    Possible modes to send (ignoreCase == true):
    > All
    > Active
    > NoMonitoring
    > Working
    > Issues
*/
var getSystemsFromMode = function () {
    var _ref57 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee57(mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee57$(_context57) {
            while (1) {
                switch (_context57.prev = _context57.next) {
                    case 0:
                        _context57.next = 2;
                        return axios.get('System/overview/mode/' + (mode == undefined ? 'All' : mode));

                    case 2:
                        result = _context57.sent;
                        return _context57.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context57.stop();
                }
            }
        }, _callee57, this);
    }));

    return function getSystemsFromMode(_x61) {
        return _ref57.apply(this, arguments);
    };
}();

var getSystemFarms = function () {
    var _ref58 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee58(onlyMonitoring) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee58$(_context58) {
            while (1) {
                switch (_context58.prev = _context58.next) {
                    case 0:
                        _context58.next = 2;
                        return axios.get('System/overview/' + (onlyMonitoring == undefined ? false : onlyMonitoring)).then(function (response) {
                            return response;
                        }).catch(function (error) {
                            var result = {
                                general: 2,
                                blackbox: false,
                                device: false,
                                rapid24h: false,
                                photocells: false,
                                pressure: false
                            };

                            return result;
                        });

                    case 2:
                        result = _context58.sent;
                        return _context58.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context58.stop();
                }
            }
        }, _callee58, this);
    }));

    return function getSystemFarms(_x62) {
        return _ref58.apply(this, arguments);
    };
}();

var getSystemsWithCountries = function () {
    var _ref59 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee59() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee59$(_context59) {
            while (1) {
                switch (_context59.prev = _context59.next) {
                    case 0:
                        _context59.next = 2;
                        return axios.get('System/countries');

                    case 2:
                        result = _context59.sent;
                        return _context59.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context59.stop();
                }
            }
        }, _callee59, this);
    }));

    return function getSystemsWithCountries() {
        return _ref59.apply(this, arguments);
    };
}();

var getSystemAlarmFromDay = function () {
    var _ref60 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee60(systemId, priority, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee60$(_context60) {
            while (1) {
                switch (_context60.prev = _context60.next) {
                    case 0:
                        _context60.next = 2;
                        return axios.get('System/' + systemId + '/' + day + '/' + priority);

                    case 2:
                        result = _context60.sent;
                        return _context60.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context60.stop();
                }
            }
        }, _callee60, this);
    }));

    return function getSystemAlarmFromDay(_x63, _x64, _x65) {
        return _ref60.apply(this, arguments);
    };
}();

var getSystemAlarmChartsForDay = function () {
    var _ref61 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee61(systemId, priority, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee61$(_context61) {
            while (1) {
                switch (_context61.prev = _context61.next) {
                    case 0:
                        _context61.next = 2;
                        return axios.get('System/chart/' + systemId + '/' + day + '/' + priority);

                    case 2:
                        result = _context61.sent;
                        return _context61.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context61.stop();
                }
            }
        }, _callee61, this);
    }));

    return function getSystemAlarmChartsForDay(_x66, _x67, _x68) {
        return _ref61.apply(this, arguments);
    };
}();

var getSystemAlarmChartsForWeek = function () {
    var _ref62 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee62(systemId, alarmTypeId, deviceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee62$(_context62) {
            while (1) {
                switch (_context62.prev = _context62.next) {
                    case 0:
                        _context62.next = 2;
                        return axios.get('System/chart/week/' + systemId + '/' + alarmTypeId + '/' + deviceId);

                    case 2:
                        result = _context62.sent;
                        return _context62.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context62.stop();
                }
            }
        }, _callee62, this);
    }));

    return function getSystemAlarmChartsForWeek(_x69, _x70, _x71) {
        return _ref62.apply(this, arguments);
    };
}();

var getSystemFarmById = function () {
    var _ref63 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee63(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee63$(_context63) {
            while (1) {
                switch (_context63.prev = _context63.next) {
                    case 0:
                        _context63.next = 2;
                        return axios.get('System/' + id + '/overview');

                    case 2:
                        result = _context63.sent;
                        return _context63.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context63.stop();
                }
            }
        }, _callee63, this);
    }));

    return function getSystemFarmById(_x72) {
        return _ref63.apply(this, arguments);
    };
}();

var deleteSystem = function () {
    var _ref64 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee64(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee64$(_context64) {
            while (1) {
                switch (_context64.prev = _context64.next) {
                    case 0:
                        _context64.next = 2;
                        return axios.delete('System/' + id);

                    case 2:
                    case 'end':
                        return _context64.stop();
                }
            }
        }, _callee64, this);
    }));

    return function deleteSystem(_x73) {
        return _ref64.apply(this, arguments);
    };
}();

var getSystem = function () {
    var _ref65 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee65(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee65$(_context65) {
            while (1) {
                switch (_context65.prev = _context65.next) {
                    case 0:
                        _context65.next = 2;
                        return axios.get('System/' + id);

                    case 2:
                        result = _context65.sent;
                        return _context65.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context65.stop();
                }
            }
        }, _callee65, this);
    }));

    return function getSystem(_x74) {
        return _ref65.apply(this, arguments);
    };
}();

var updateSystem = function () {
    var _ref66 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee66(data) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee66$(_context66) {
            while (1) {
                switch (_context66.prev = _context66.next) {
                    case 0:
                        _context66.next = 2;
                        return axios.put('System', data);

                    case 2:
                    case 'end':
                        return _context66.stop();
                }
            }
        }, _callee66, this);
    }));

    return function updateSystem(_x75) {
        return _ref66.apply(this, arguments);
    };
}();

var addSystem = function () {
    var _ref67 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee67(system) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee67$(_context67) {
            while (1) {
                switch (_context67.prev = _context67.next) {
                    case 0:
                        _context67.next = 2;
                        return axios.post('System/create', system);

                    case 2:
                    case 'end':
                        return _context67.stop();
                }
            }
        }, _callee67, this);
    }));

    return function addSystem(_x76) {
        return _ref67.apply(this, arguments);
    };
}();

var getSystemImage = function () {
    var _ref68 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee68(imageId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee68$(_context68) {
            while (1) {
                switch (_context68.prev = _context68.next) {
                    case 0:
                        _context68.next = 2;
                        return axios.get('System/file/' + imageId, {
                            responseType: 'blob'
                        });

                    case 2:
                        result = _context68.sent;
                        return _context68.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context68.stop();
                }
            }
        }, _callee68, this);
    }));

    return function getSystemImage(_x77) {
        return _ref68.apply(this, arguments);
    };
}();

var addSystemWithDetails = function () {
    var _ref69 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee69(system) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee69$(_context69) {
            while (1) {
                switch (_context69.prev = _context69.next) {
                    case 0:
                        _context69.next = 2;
                        return axios.post('System/add', system);

                    case 2:
                    case 'end':
                        return _context69.stop();
                }
            }
        }, _callee69, this);
    }));

    return function addSystemWithDetails(_x78) {
        return _ref69.apply(this, arguments);
    };
}();

var editSystemWithDetails = function () {
    var _ref70 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee70(system) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee70$(_context70) {
            while (1) {
                switch (_context70.prev = _context70.next) {
                    case 0:
                        _context70.next = 2;
                        return axios.put('System/edit', system);

                    case 2:
                    case 'end':
                        return _context70.stop();
                }
            }
        }, _callee70, this);
    }));

    return function editSystemWithDetails(_x79) {
        return _ref70.apply(this, arguments);
    };
}();

var getSystemStatusList = function () {
    var _ref71 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee71() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee71$(_context71) {
            while (1) {
                switch (_context71.prev = _context71.next) {
                    case 0:
                        _context71.next = 2;
                        return axios.get('System/statusDetailsList');

                    case 2:
                        result = _context71.sent;
                        return _context71.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context71.stop();
                }
            }
        }, _callee71, this);
    }));

    return function getSystemStatusList() {
        return _ref71.apply(this, arguments);
    };
}();

var getSystemsStatusList = function () {
    var _ref72 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee72() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee72$(_context72) {
            while (1) {
                switch (_context72.prev = _context72.next) {
                    case 0:
                        _context72.next = 2;
                        return axios.get('System/statusListV2');

                    case 2:
                        result = _context72.sent;
                        return _context72.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context72.stop();
                }
            }
        }, _callee72, this);
    }));

    return function getSystemsStatusList() {
        return _ref72.apply(this, arguments);
    };
}();

var getSystemStatusById = function () {
    var _ref73 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee73(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee73$(_context73) {
            while (1) {
                switch (_context73.prev = _context73.next) {
                    case 0:
                        _context73.next = 2;
                        return axios.get('System/status/' + systemId);

                    case 2:
                        result = _context73.sent;
                        return _context73.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context73.stop();
                }
            }
        }, _callee73, this);
    }));

    return function getSystemStatusById(_x80) {
        return _ref73.apply(this, arguments);
    };
}();

var getSystemGeneralData = function () {
    var _ref74 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee74(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee74$(_context74) {
            while (1) {
                switch (_context74.prev = _context74.next) {
                    case 0:
                        _context74.next = 2;
                        return axios.get('System/general/' + systemId);

                    case 2:
                        result = _context74.sent;
                        return _context74.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context74.stop();
                }
            }
        }, _callee74, this);
    }));

    return function getSystemGeneralData(_x81) {
        return _ref74.apply(this, arguments);
    };
}();

var getRemoteAccessForSystem = function () {
    var _ref75 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee75(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee75$(_context75) {
            while (1) {
                switch (_context75.prev = _context75.next) {
                    case 0:
                        _context75.next = 2;
                        return axios.get('System/remoteAccess/' + systemId);

                    case 2:
                        result = _context75.sent;
                        return _context75.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context75.stop();
                }
            }
        }, _callee75, this);
    }));

    return function getRemoteAccessForSystem(_x82) {
        return _ref75.apply(this, arguments);
    };
}();

var getRemoteAccessPasswordForSystem = function () {
    var _ref76 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee76(remoteAccessId, pin) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee76$(_context76) {
            while (1) {
                switch (_context76.prev = _context76.next) {
                    case 0:
                        _context76.next = 2;
                        return axios.post('System/remoteAccess/password/' + remoteAccessId, { pin: pin });

                    case 2:
                        result = _context76.sent;
                        return _context76.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context76.stop();
                }
            }
        }, _callee76, this);
    }));

    return function getRemoteAccessPasswordForSystem(_x83, _x84) {
        return _ref76.apply(this, arguments);
    };
}();

var addRemoteAccess = function () {
    var _ref77 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee77(remoteAccess) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee77$(_context77) {
            while (1) {
                switch (_context77.prev = _context77.next) {
                    case 0:
                        _context77.next = 2;
                        return axios.post('System/remoteAccess', remoteAccess);

                    case 2:
                    case 'end':
                        return _context77.stop();
                }
            }
        }, _callee77, this);
    }));

    return function addRemoteAccess(_x85) {
        return _ref77.apply(this, arguments);
    };
}();

var editRemoteAccess = function () {
    var _ref78 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee78(remoteAccess) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee78$(_context78) {
            while (1) {
                switch (_context78.prev = _context78.next) {
                    case 0:
                        _context78.next = 2;
                        return axios.put('System/remoteAccess/access', remoteAccess);

                    case 2:
                    case 'end':
                        return _context78.stop();
                }
            }
        }, _callee78, this);
    }));

    return function editRemoteAccess(_x86) {
        return _ref78.apply(this, arguments);
    };
}();

var editRemoteAccessPassword = function () {
    var _ref79 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee79(remoteAccess) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee79$(_context79) {
            while (1) {
                switch (_context79.prev = _context79.next) {
                    case 0:
                        _context79.next = 2;
                        return axios.put('System/remoteAccess/password', remoteAccess);

                    case 2:
                    case 'end':
                        return _context79.stop();
                }
            }
        }, _callee79, this);
    }));

    return function editRemoteAccessPassword(_x87) {
        return _ref79.apply(this, arguments);
    };
}();

var deleteRemoteAccess = function () {
    var _ref80 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee80(remoteAccessId, pin) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee80$(_context80) {
            while (1) {
                switch (_context80.prev = _context80.next) {
                    case 0:
                        _context80.next = 2;
                        return axios.post('System/remoteAccess/' + remoteAccessId + '/delete', { pin: pin });

                    case 2:
                    case 'end':
                        return _context80.stop();
                }
            }
        }, _callee80, this);
    }));

    return function deleteRemoteAccess(_x88, _x89) {
        return _ref80.apply(this, arguments);
    };
}();

var getSystemTypes = function () {
    var _ref81 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee81() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee81$(_context81) {
            while (1) {
                switch (_context81.prev = _context81.next) {
                    case 0:
                        _context81.next = 2;
                        return axios.get('System/systemTypes');

                    case 2:
                        result = _context81.sent;
                        return _context81.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context81.stop();
                }
            }
        }, _callee81, this);
    }));

    return function getSystemTypes() {
        return _ref81.apply(this, arguments);
    };
}();

/* System Status */
var getSystemStatus = function () {
    var _ref82 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee82(systemId) {
        var response, status;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee82$(_context82) {
            while (1) {
                switch (_context82.prev = _context82.next) {
                    case 0:
                        _context82.prev = 0;
                        _context82.next = 3;
                        return axios.get('SystemStatus/' + systemId);

                    case 3:
                        response = _context82.sent;

                        response.data.isError = false;
                        return _context82.abrupt('return', response.data);

                    case 8:
                        _context82.prev = 8;
                        _context82.t0 = _context82['catch'](0);
                        status = {
                            isError: true
                        };
                        return _context82.abrupt('return', status);

                    case 12:
                    case 'end':
                        return _context82.stop();
                }
            }
        }, _callee82, this, [[0, 8]]);
    }));

    return function getSystemStatus(_x90) {
        return _ref82.apply(this, arguments);
    };
}();

var getDeviceStatusFromDatesToChart = function () {
    var _ref83 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee83(system, from, to) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee83$(_context83) {
            while (1) {
                switch (_context83.prev = _context83.next) {
                    case 0:
                        _context83.next = 2;
                        return axios.get('SystemStatus/' + system + '/' + from.toISOString() + '/' + to.toISOString());

                    case 2:
                        response = _context83.sent;
                        return _context83.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context83.stop();
                }
            }
        }, _callee83, this);
    }));

    return function getDeviceStatusFromDatesToChart(_x91, _x92, _x93) {
        return _ref83.apply(this, arguments);
    };
}();

/* SETTINGS CONTROLLER */

var getRoughageSettings = function () {
    var _ref84 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee84(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee84$(_context84) {
            while (1) {
                switch (_context84.prev = _context84.next) {
                    case 0:
                        _context84.next = 2;
                        return axios.get('Settings/blackbox/' + systemId);

                    case 2:
                        result = _context84.sent;
                        return _context84.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context84.stop();
                }
            }
        }, _callee84, this);
    }));

    return function getRoughageSettings(_x94) {
        return _ref84.apply(this, arguments);
    };
}();

var getRoughageSettingsHistory = function () {
    var _ref85 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee85(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee85$(_context85) {
            while (1) {
                switch (_context85.prev = _context85.next) {
                    case 0:
                        _context85.next = 2;
                        return axios.get('Settings/blackbox/history/' + systemId);

                    case 2:
                        result = _context85.sent;
                        return _context85.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context85.stop();
                }
            }
        }, _callee85, this);
    }));

    return function getRoughageSettingsHistory(_x95) {
        return _ref85.apply(this, arguments);
    };
}();

var getSortingSettings = function () {
    var _ref86 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee86(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee86$(_context86) {
            while (1) {
                switch (_context86.prev = _context86.next) {
                    case 0:
                        _context86.next = 2;
                        return axios.get('Settings/sorting/' + systemId);

                    case 2:
                        result = _context86.sent;
                        return _context86.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context86.stop();
                }
            }
        }, _callee86, this);
    }));

    return function getSortingSettings(_x96) {
        return _ref86.apply(this, arguments);
    };
}();

var getSortingSettingsHistory = function () {
    var _ref87 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee87(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee87$(_context87) {
            while (1) {
                switch (_context87.prev = _context87.next) {
                    case 0:
                        _context87.next = 2;
                        return axios.get('Settings/sorting/history/' + systemId);

                    case 2:
                        result = _context87.sent;
                        return _context87.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context87.stop();
                }
            }
        }, _callee87, this);
    }));

    return function getSortingSettingsHistory(_x97) {
        return _ref87.apply(this, arguments);
    };
}();

/* LOADCELLDATA CONTROLLER */

var getLoadCellDataHistory = function () {
    var _ref88 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee88(systemId, deviceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee88$(_context88) {
            while (1) {
                switch (_context88.prev = _context88.next) {
                    case 0:
                        _context88.next = 2;
                        return axios.get('LoadCellData/history/' + systemId + '/' + deviceId);

                    case 2:
                        result = _context88.sent;
                        return _context88.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context88.stop();
                }
            }
        }, _callee88, this);
    }));

    return function getLoadCellDataHistory(_x98, _x99) {
        return _ref88.apply(this, arguments);
    };
}();

/* PDF REPORT */

var getPdfAlarmReportBySystemId = function () {
    var _ref89 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee89(reportData) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee89$(_context89) {
            while (1) {
                switch (_context89.prev = _context89.next) {
                    case 0:
                        _context89.next = 2;
                        return axios.post('PdfReport/alarms', reportData, {
                            responseType: 'blob'
                        });

                    case 2:
                        result = _context89.sent;
                        return _context89.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context89.stop();
                }
            }
        }, _callee89, this);
    }));

    return function getPdfAlarmReportBySystemId(_x100) {
        return _ref89.apply(this, arguments);
    };
}();

/* SYSTEM ALARMS CONTROLLER */

var getSystemAlarms = function () {
    var _ref90 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee90(id, sorts, filter, page, pageSize) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee90$(_context90) {
            while (1) {
                switch (_context90.prev = _context90.next) {
                    case 0:
                        _context90.next = 2;
                        return axios.get('SystemAlarm/alarms/' + id + ('?sorts=' + sorts) + ('' + (filter == '' ? '' : '&filters=name@=*' + filter)) + ('&page=' + page) + ('&pageSize=' + pageSize));

                    case 2:
                        result = _context90.sent;
                        return _context90.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context90.stop();
                }
            }
        }, _callee90, this);
    }));

    return function getSystemAlarms(_x101, _x102, _x103, _x104, _x105) {
        return _ref90.apply(this, arguments);
    };
}();

var getSystemAlarmDetails = function () {
    var _ref91 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee91(systemId, alarmTypeId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee91$(_context91) {
            while (1) {
                switch (_context91.prev = _context91.next) {
                    case 0:
                        _context91.next = 2;
                        return axios.get('SystemAlarm/' + systemId + '/' + alarmTypeId);

                    case 2:
                        result = _context91.sent;
                        return _context91.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context91.stop();
                }
            }
        }, _callee91, this);
    }));

    return function getSystemAlarmDetails(_x106, _x107) {
        return _ref91.apply(this, arguments);
    };
}();

/* CONTACT CONTROLLER */
var getAllContacts = function () {
    var _ref92 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee92() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee92$(_context92) {
            while (1) {
                switch (_context92.prev = _context92.next) {
                    case 0:
                        _context92.next = 2;
                        return axios.get('contactsData/all');

                    case 2:
                        result = _context92.sent;
                        return _context92.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context92.stop();
                }
            }
        }, _callee92, this);
    }));

    return function getAllContacts() {
        return _ref92.apply(this, arguments);
    };
}();

var getContactsBySystemId = function () {
    var _ref93 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee93(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee93$(_context93) {
            while (1) {
                switch (_context93.prev = _context93.next) {
                    case 0:
                        _context93.next = 2;
                        return axios.get('contactsData/system/' + systemId);

                    case 2:
                        result = _context93.sent;
                        return _context93.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context93.stop();
                }
            }
        }, _callee93, this);
    }));

    return function getContactsBySystemId(_x108) {
        return _ref93.apply(this, arguments);
    };
}();

var getContactById = function () {
    var _ref94 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee94(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee94$(_context94) {
            while (1) {
                switch (_context94.prev = _context94.next) {
                    case 0:
                        _context94.next = 2;
                        return axios.get('contactsData/' + id);

                    case 2:
                        result = _context94.sent;
                        return _context94.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context94.stop();
                }
            }
        }, _callee94, this);
    }));

    return function getContactById(_x109) {
        return _ref94.apply(this, arguments);
    };
}();

var addContact = function () {
    var _ref95 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee95(contact) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee95$(_context95) {
            while (1) {
                switch (_context95.prev = _context95.next) {
                    case 0:
                        return _context95.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            axios.post('contactsData', contact).then(function (response) {
                                resolve(response);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context95.stop();
                }
            }
        }, _callee95, this);
    }));

    return function addContact(_x110) {
        return _ref95.apply(this, arguments);
    };
}();

var updateContact = function () {
    var _ref96 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee96(contact) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee96$(_context96) {
            while (1) {
                switch (_context96.prev = _context96.next) {
                    case 0:
                        return _context96.abrupt('return', new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                            axios.put('contactsData', contact).then(function (response) {
                                resolve(response);
                            }).catch(function (error) {
                                reject(error);
                            });
                        }));

                    case 1:
                    case 'end':
                        return _context96.stop();
                }
            }
        }, _callee96, this);
    }));

    return function updateContact(_x111) {
        return _ref96.apply(this, arguments);
    };
}();

var deleteContact = function () {
    var _ref97 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee97(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee97$(_context97) {
            while (1) {
                switch (_context97.prev = _context97.next) {
                    case 0:
                        _context97.next = 2;
                        return axios.delete('contactsData/' + id);

                    case 2:
                    case 'end':
                        return _context97.stop();
                }
            }
        }, _callee97, this);
    }));

    return function deleteContact(_x112) {
        return _ref97.apply(this, arguments);
    };
}();

/* GROUPS */

var getExistingGroups = function () {
    var _ref98 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee98() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee98$(_context98) {
            while (1) {
                switch (_context98.prev = _context98.next) {
                    case 0:
                        _context98.next = 2;
                        return axios.get('groups/list');

                    case 2:
                        result = _context98.sent;
                        return _context98.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context98.stop();
                }
            }
        }, _callee98, this);
    }));

    return function getExistingGroups() {
        return _ref98.apply(this, arguments);
    };
}();

var assignUserToGroups = function () {
    var _ref99 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee99(userId, groupName) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee99$(_context99) {
            while (1) {
                switch (_context99.prev = _context99.next) {
                    case 0:
                        _context99.next = 2;
                        return axios.post('groups/assign/user/' + userId, groupName);

                    case 2:
                    case 'end':
                        return _context99.stop();
                }
            }
        }, _callee99, this);
    }));

    return function assignUserToGroups(_x113, _x114) {
        return _ref99.apply(this, arguments);
    };
}();

/* STATISTICS */

var getStatisticsForSystem = function () {
    var _ref100 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee100(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee100$(_context100) {
            while (1) {
                switch (_context100.prev = _context100.next) {
                    case 0:
                        _context100.next = 2;
                        return axios.get('Statistics/' + systemId);

                    case 2:
                        result = _context100.sent;
                        return _context100.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context100.stop();
                }
            }
        }, _callee100, this);
    }));

    return function getStatisticsForSystem(_x115) {
        return _ref100.apply(this, arguments);
    };
}();

/* VISITS */

var getVisitsForSystem = function () {
    var _ref101 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee101(farmId, mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee101$(_context101) {
            while (1) {
                switch (_context101.prev = _context101.next) {
                    case 0:
                        _context101.next = 2;
                        return axios.get('Visits/farm/' + farmId + '/' + mode);

                    case 2:
                        result = _context101.sent;
                        return _context101.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context101.stop();
                }
            }
        }, _callee101, this);
    }));

    return function getVisitsForSystem(_x116, _x117) {
        return _ref101.apply(this, arguments);
    };
}();

var getVisitsForSystemById = function () {
    var _ref102 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee102(systemId, mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee102$(_context102) {
            while (1) {
                switch (_context102.prev = _context102.next) {
                    case 0:
                        _context102.next = 2;
                        return axios.get('Visits/system/' + systemId + '/' + mode);

                    case 2:
                        result = _context102.sent;
                        return _context102.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context102.stop();
                }
            }
        }, _callee102, this);
    }));

    return function getVisitsForSystemById(_x118, _x119) {
        return _ref102.apply(this, arguments);
    };
}();

var getVisits = function () {
    var _ref103 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee103(mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee103$(_context103) {
            while (1) {
                switch (_context103.prev = _context103.next) {
                    case 0:
                        _context103.next = 2;
                        return axios.get('Visits/mode/' + mode);

                    case 2:
                        result = _context103.sent;
                        return _context103.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context103.stop();
                }
            }
        }, _callee103, this);
    }));

    return function getVisits(_x120) {
        return _ref103.apply(this, arguments);
    };
}();

var getVisit = function () {
    var _ref104 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee104(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee104$(_context104) {
            while (1) {
                switch (_context104.prev = _context104.next) {
                    case 0:
                        _context104.next = 2;
                        return axios.get('Visits/' + id);

                    case 2:
                        result = _context104.sent;
                        return _context104.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context104.stop();
                }
            }
        }, _callee104, this);
    }));

    return function getVisit(_x121) {
        return _ref104.apply(this, arguments);
    };
}();

var editVisit = function () {
    var _ref105 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee105(objectToSave) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee105$(_context105) {
            while (1) {
                switch (_context105.prev = _context105.next) {
                    case 0:
                        _context105.next = 2;
                        return axios.put('Visits/edit', objectToSave);

                    case 2:
                    case 'end':
                        return _context105.stop();
                }
            }
        }, _callee105, this);
    }));

    return function editVisit(_x122) {
        return _ref105.apply(this, arguments);
    };
}();

var saveVisit = function () {
    var _ref106 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee106(objectToSave) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee106$(_context106) {
            while (1) {
                switch (_context106.prev = _context106.next) {
                    case 0:
                        _context106.next = 2;
                        return axios.post('Visits/new', objectToSave);

                    case 2:
                    case 'end':
                        return _context106.stop();
                }
            }
        }, _callee106, this);
    }));

    return function saveVisit(_x123) {
        return _ref106.apply(this, arguments);
    };
}();

var getActiveOrFutureVisitsNames = function () {
    var _ref107 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee107() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee107$(_context107) {
            while (1) {
                switch (_context107.prev = _context107.next) {
                    case 0:
                        _context107.next = 2;
                        return axios.get('Visits/active');

                    case 2:
                        result = _context107.sent;
                        return _context107.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context107.stop();
                }
            }
        }, _callee107, this);
    }));

    return function getActiveOrFutureVisitsNames() {
        return _ref107.apply(this, arguments);
    };
}();

var getActiveProblemsForVisit = function () {
    var _ref108 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee108(visitId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee108$(_context108) {
            while (1) {
                switch (_context108.prev = _context108.next) {
                    case 0:
                        _context108.next = 2;
                        return axios.get('Problem/visit/' + visitId);

                    case 2:
                        result = _context108.sent;
                        return _context108.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context108.stop();
                }
            }
        }, _callee108, this);
    }));

    return function getActiveProblemsForVisit(_x124) {
        return _ref108.apply(this, arguments);
    };
}();

var getSystemsForFarm = function () {
    var _ref109 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee109(farmId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee109$(_context109) {
            while (1) {
                switch (_context109.prev = _context109.next) {
                    case 0:
                        _context109.next = 2;
                        return axios.get('System/farms/systems/' + farmId);

                    case 2:
                        result = _context109.sent;
                        return _context109.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context109.stop();
                }
            }
        }, _callee109, this);
    }));

    return function getSystemsForFarm(_x125) {
        return _ref109.apply(this, arguments);
    };
}();

var getReportForFinishedVisit = function () {
    var _ref110 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee110(visitId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee110$(_context110) {
            while (1) {
                switch (_context110.prev = _context110.next) {
                    case 0:
                        _context110.next = 2;
                        return axios.get('Report/download/' + visitId, { responseType: 'blob' });

                    case 2:
                        result = _context110.sent;
                        return _context110.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context110.stop();
                }
            }
        }, _callee110, this);
    }));

    return function getReportForFinishedVisit(_x126) {
        return _ref110.apply(this, arguments);
    };
}();

/* PROBLEMS */

var getProblems = function () {
    var _ref111 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee111(mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee111$(_context111) {
            while (1) {
                switch (_context111.prev = _context111.next) {
                    case 0:
                        _context111.next = 2;
                        return axios.get('Problem/list/' + mode);

                    case 2:
                        result = _context111.sent;
                        return _context111.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context111.stop();
                }
            }
        }, _callee111, this);
    }));

    return function getProblems(_x127) {
        return _ref111.apply(this, arguments);
    };
}();

var getProblem = function () {
    var _ref112 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee112(problemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee112$(_context112) {
            while (1) {
                switch (_context112.prev = _context112.next) {
                    case 0:
                        _context112.next = 2;
                        return axios.get('Problem/id/' + problemId);

                    case 2:
                        result = _context112.sent;
                        return _context112.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context112.stop();
                }
            }
        }, _callee112, this);
    }));

    return function getProblem(_x128) {
        return _ref112.apply(this, arguments);
    };
}();

var getProblemsForSystem = function () {
    var _ref113 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee113(systemId, mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee113$(_context113) {
            while (1) {
                switch (_context113.prev = _context113.next) {
                    case 0:
                        _context113.next = 2;
                        return axios.get('Problem/system/' + systemId + '/' + mode);

                    case 2:
                        result = _context113.sent;
                        return _context113.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context113.stop();
                }
            }
        }, _callee113, this);
    }));

    return function getProblemsForSystem(_x129, _x130) {
        return _ref113.apply(this, arguments);
    };
}();

var saveProblem = function () {
    var _ref114 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee114(objectToSave) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee114$(_context114) {
            while (1) {
                switch (_context114.prev = _context114.next) {
                    case 0:
                        _context114.next = 2;
                        return axios.post('Problem/new', objectToSave, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context114.stop();
                }
            }
        }, _callee114, this);
    }));

    return function saveProblem(_x131) {
        return _ref114.apply(this, arguments);
    };
}();

var editProblem = function () {
    var _ref115 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee115(objectToSave) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee115$(_context115) {
            while (1) {
                switch (_context115.prev = _context115.next) {
                    case 0:
                        _context115.next = 2;
                        return axios.post('Problem/edit', objectToSave, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context115.stop();
                }
            }
        }, _callee115, this);
    }));

    return function editProblem(_x132) {
        return _ref115.apply(this, arguments);
    };
}();

var getProblemPhotos = function () {
    var _ref116 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee116(resourceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee116$(_context116) {
            while (1) {
                switch (_context116.prev = _context116.next) {
                    case 0:
                        _context116.next = 2;
                        return axios.get('Problem/resource/file/' + resourceId, {
                            responseType: 'blob'
                        });

                    case 2:
                        result = _context116.sent;
                        return _context116.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context116.stop();
                }
            }
        }, _callee116, this);
    }));

    return function getProblemPhotos(_x133) {
        return _ref116.apply(this, arguments);
    };
}();

var deleteResourceFromProblem = function () {
    var _ref117 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee117(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee117$(_context117) {
            while (1) {
                switch (_context117.prev = _context117.next) {
                    case 0:
                        _context117.next = 2;
                        return axios.delete('Problem/' + id);

                    case 2:
                    case 'end':
                        return _context117.stop();
                }
            }
        }, _callee117, this);
    }));

    return function deleteResourceFromProblem(_x134) {
        return _ref117.apply(this, arguments);
    };
}();

/* SOLUTIONS */

var getSolutionsForVisit = function () {
    var _ref118 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee118(visitId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee118$(_context118) {
            while (1) {
                switch (_context118.prev = _context118.next) {
                    case 0:
                        _context118.next = 2;
                        return axios.get('Solution/visit/' + visitId);

                    case 2:
                        result = _context118.sent;
                        return _context118.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context118.stop();
                }
            }
        }, _callee118, this);
    }));

    return function getSolutionsForVisit(_x135) {
        return _ref118.apply(this, arguments);
    };
}();

var getSolutionsForProblem = function () {
    var _ref119 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee119(problemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee119$(_context119) {
            while (1) {
                switch (_context119.prev = _context119.next) {
                    case 0:
                        _context119.next = 2;
                        return axios.get('Solution/problem/' + problemId);

                    case 2:
                        result = _context119.sent;
                        return _context119.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context119.stop();
                }
            }
        }, _callee119, this);
    }));

    return function getSolutionsForProblem(_x136) {
        return _ref119.apply(this, arguments);
    };
}();

var GetSystemNames = function () {
    var _ref120 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee120() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee120$(_context120) {
            while (1) {
                switch (_context120.prev = _context120.next) {
                    case 0:
                        _context120.next = 2;
                        return axios.get('System/systemNames');

                    case 2:
                        result = _context120.sent;
                        return _context120.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context120.stop();
                }
            }
        }, _callee120, this);
    }));

    return function GetSystemNames() {
        return _ref120.apply(this, arguments);
    };
}();

var getSolution = function () {
    var _ref121 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee121(solutionId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee121$(_context121) {
            while (1) {
                switch (_context121.prev = _context121.next) {
                    case 0:
                        _context121.next = 2;
                        return axios.get('Solution/id/' + solutionId);

                    case 2:
                        result = _context121.sent;
                        return _context121.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context121.stop();
                }
            }
        }, _callee121, this);
    }));

    return function getSolution(_x137) {
        return _ref121.apply(this, arguments);
    };
}();

var saveSolution = function () {
    var _ref122 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee122(form) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee122$(_context122) {
            while (1) {
                switch (_context122.prev = _context122.next) {
                    case 0:
                        _context122.next = 2;
                        return axios.post('Solution/new', form, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context122.stop();
                }
            }
        }, _callee122, this);
    }));

    return function saveSolution(_x138) {
        return _ref122.apply(this, arguments);
    };
}();

var editSolution = function () {
    var _ref123 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee123(form) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee123$(_context123) {
            while (1) {
                switch (_context123.prev = _context123.next) {
                    case 0:
                        _context123.next = 2;
                        return axios.post('Solution/edit', form, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context123.stop();
                }
            }
        }, _callee123, this);
    }));

    return function editSolution(_x139) {
        return _ref123.apply(this, arguments);
    };
}();

var getSolutions = function () {
    var _ref124 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee124() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee124$(_context124) {
            while (1) {
                switch (_context124.prev = _context124.next) {
                    case 0:
                        _context124.next = 2;
                        return axios.get('Solution/all');

                    case 2:
                        result = _context124.sent;
                        return _context124.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context124.stop();
                }
            }
        }, _callee124, this);
    }));

    return function getSolutions() {
        return _ref124.apply(this, arguments);
    };
}();

var getSolutionResourceById = function () {
    var _ref125 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee125(resourceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee125$(_context125) {
            while (1) {
                switch (_context125.prev = _context125.next) {
                    case 0:
                        _context125.next = 2;
                        return axios.get('Solution/resources/file/' + resourceId, {
                            responseType: 'blob'
                        });

                    case 2:
                        result = _context125.sent;
                        return _context125.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context125.stop();
                }
            }
        }, _callee125, this);
    }));

    return function getSolutionResourceById(_x140) {
        return _ref125.apply(this, arguments);
    };
}();

var deleteResourceFromSolution = function () {
    var _ref126 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee126(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee126$(_context126) {
            while (1) {
                switch (_context126.prev = _context126.next) {
                    case 0:
                        _context126.next = 2;
                        return axios.delete('Solution/resources/' + id);

                    case 2:
                    case 'end':
                        return _context126.stop();
                }
            }
        }, _callee126, this);
    }));

    return function deleteResourceFromSolution(_x141) {
        return _ref126.apply(this, arguments);
    };
}();

var deleteSolution = function () {
    var _ref127 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee127(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee127$(_context127) {
            while (1) {
                switch (_context127.prev = _context127.next) {
                    case 0:
                        _context127.next = 2;
                        return axios.delete('Solution/' + id);

                    case 2:
                    case 'end':
                        return _context127.stop();
                }
            }
        }, _callee127, this);
    }));

    return function deleteSolution(_x142) {
        return _ref127.apply(this, arguments);
    };
}();

// tickets
var getSystemTickets = function () {
    var _ref128 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee128(id, mode) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee128$(_context128) {
            while (1) {
                switch (_context128.prev = _context128.next) {
                    case 0:
                        if (mode == undefined) {
                            mode == 'All';
                        }
                        _context128.next = 3;
                        return axios.get('Tickets/system/' + id + '/' + mode);

                    case 3:
                        result = _context128.sent;
                        return _context128.abrupt('return', result.data);

                    case 5:
                    case 'end':
                        return _context128.stop();
                }
            }
        }, _callee128, this);
    }));

    return function getSystemTickets(_x143, _x144) {
        return _ref128.apply(this, arguments);
    };
}();

var postNewTicket = function () {
    var _ref129 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee129(ticket) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee129$(_context129) {
            while (1) {
                switch (_context129.prev = _context129.next) {
                    case 0:
                        _context129.next = 2;
                        return axios.post('Tickets/new', ticket, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context129.stop();
                }
            }
        }, _callee129, this);
    }));

    return function postNewTicket(_x145) {
        return _ref129.apply(this, arguments);
    };
}();

var closeTicket = function () {
    var _ref130 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee130(ticketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee130$(_context130) {
            while (1) {
                switch (_context130.prev = _context130.next) {
                    case 0:
                        _context130.next = 2;
                        return axios.put('Tickets/close/' + ticketId);

                    case 2:
                    case 'end':
                        return _context130.stop();
                }
            }
        }, _callee130, this);
    }));

    return function closeTicket(_x146) {
        return _ref130.apply(this, arguments);
    };
}();

var getStatusForSystemsTickets = function () {
    var _ref131 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee131(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee131$(_context131) {
            while (1) {
                switch (_context131.prev = _context131.next) {
                    case 0:
                        _context131.next = 2;
                        return axios.get('Tickets/systemStatus/' + systemId);

                    case 2:
                        result = _context131.sent;
                        return _context131.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context131.stop();
                }
            }
        }, _callee131, this);
    }));

    return function getStatusForSystemsTickets(_x147) {
        return _ref131.apply(this, arguments);
    };
}();

var readTicket = function () {
    var _ref132 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee132(ticketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee132$(_context132) {
            while (1) {
                switch (_context132.prev = _context132.next) {
                    case 0:
                        _context132.prev = 0;
                        _context132.next = 3;
                        return axios.put('Tickets/read/' + ticketId);

                    case 3:
                        _context132.next = 8;
                        break;

                    case 5:
                        _context132.prev = 5;
                        _context132.t0 = _context132['catch'](0);

                        console.dir(_context132.t0);

                    case 8:
                    case 'end':
                        return _context132.stop();
                }
            }
        }, _callee132, this, [[0, 5]]);
    }));

    return function readTicket(_x148) {
        return _ref132.apply(this, arguments);
    };
}();

var confirmRequestToClose = function () {
    var _ref133 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee133(ticketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee133$(_context133) {
            while (1) {
                switch (_context133.prev = _context133.next) {
                    case 0:
                        _context133.next = 2;
                        return axios.put('Tickets/close/' + ticketId);

                    case 2:
                    case 'end':
                        return _context133.stop();
                }
            }
        }, _callee133, this);
    }));

    return function confirmRequestToClose(_x149) {
        return _ref133.apply(this, arguments);
    };
}();

var denyRequestToClose = function () {
    var _ref134 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee134(ticketId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee134$(_context134) {
            while (1) {
                switch (_context134.prev = _context134.next) {
                    case 0:
                        _context134.next = 2;
                        return axios.put('Tickets/deny/' + ticketId);

                    case 2:
                    case 'end':
                        return _context134.stop();
                }
            }
        }, _callee134, this);
    }));

    return function denyRequestToClose(_x150) {
        return _ref134.apply(this, arguments);
    };
}();

// Messages
var getMessagesForTicket = function () {
    var _ref135 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee135(ticketId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee135$(_context135) {
            while (1) {
                switch (_context135.prev = _context135.next) {
                    case 0:
                        _context135.next = 2;
                        return axios.get('Tickets/messages/' + ticketId);

                    case 2:
                        result = _context135.sent;
                        return _context135.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context135.stop();
                }
            }
        }, _callee135, this);
    }));

    return function getMessagesForTicket(_x151) {
        return _ref135.apply(this, arguments);
    };
}();

var getMessageResource = function () {
    var _ref136 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee136(resourceId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee136$(_context136) {
            while (1) {
                switch (_context136.prev = _context136.next) {
                    case 0:
                        _context136.next = 2;
                        return axios.get('Tickets/resource/' + resourceId, {
                            responseType: 'blob'
                        });

                    case 2:
                        result = _context136.sent;
                        return _context136.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context136.stop();
                }
            }
        }, _callee136, this);
    }));

    return function getMessageResource(_x152) {
        return _ref136.apply(this, arguments);
    };
}();

var sendMessage = function () {
    var _ref137 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee137(form) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee137$(_context137) {
            while (1) {
                switch (_context137.prev = _context137.next) {
                    case 0:
                        _context137.next = 2;
                        return axios.post('Tickets/response', form, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context137.stop();
                }
            }
        }, _callee137, this);
    }));

    return function sendMessage(_x153) {
        return _ref137.apply(this, arguments);
    };
}();

/* Invitations */
var getInvitations = function () {
    var _ref138 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee138() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee138$(_context138) {
            while (1) {
                switch (_context138.prev = _context138.next) {
                    case 0:
                        _context138.next = 2;
                        return axios.get('Invitations/list');

                    case 2:
                        result = _context138.sent;
                        return _context138.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context138.stop();
                }
            }
        }, _callee138, this);
    }));

    return function getInvitations() {
        return _ref138.apply(this, arguments);
    };
}();

var deleteInvitations = function () {
    var _ref139 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee139(invitation, pin) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee139$(_context139) {
            while (1) {
                switch (_context139.prev = _context139.next) {
                    case 0:
                        _context139.next = 2;
                        return axios.delete('Invitations/remove/' + invitation + '/' + pin);

                    case 2:
                        result = _context139.sent;
                        return _context139.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context139.stop();
                }
            }
        }, _callee139, this);
    }));

    return function deleteInvitations(_x154, _x155) {
        return _ref139.apply(this, arguments);
    };
}();

var disableInvitations = function () {
    var _ref140 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee140(invitations) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee140$(_context140) {
            while (1) {
                switch (_context140.prev = _context140.next) {
                    case 0:
                        _context140.next = 2;
                        return axios.put('Invitations/disable', invitations);

                    case 2:
                        result = _context140.sent;
                        return _context140.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context140.stop();
                }
            }
        }, _callee140, this);
    }));

    return function disableInvitations(_x156) {
        return _ref140.apply(this, arguments);
    };
}();

var enableInvitations = function () {
    var _ref141 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee141(invitations) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee141$(_context141) {
            while (1) {
                switch (_context141.prev = _context141.next) {
                    case 0:
                        _context141.next = 2;
                        return axios.put('Invitations/enable', invitations);

                    case 2:
                        result = _context141.sent;
                        return _context141.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context141.stop();
                }
            }
        }, _callee141, this);
    }));

    return function enableInvitations(_x157) {
        return _ref141.apply(this, arguments);
    };
}();

var createInvitation = function () {
    var _ref142 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee142(invitation) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee142$(_context142) {
            while (1) {
                switch (_context142.prev = _context142.next) {
                    case 0:
                        _context142.next = 2;
                        return axios.post('Invitations/create', invitation).catch(function (err) {
                            throw err.response.data.error;
                        });

                    case 2:
                        result = _context142.sent;
                        return _context142.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context142.stop();
                }
            }
        }, _callee142, this);
    }));

    return function createInvitation(_x158) {
        return _ref142.apply(this, arguments);
    };
}();

var updateInvitation = function () {
    var _ref143 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee143(invitation) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee143$(_context143) {
            while (1) {
                switch (_context143.prev = _context143.next) {
                    case 0:
                        _context143.next = 2;
                        return axios.put('Invitations/update', invitation).catch(function (err) {
                            throw err.response.data.error;
                        });

                    case 2:
                        result = _context143.sent;
                        return _context143.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context143.stop();
                }
            }
        }, _callee143, this);
    }));

    return function updateInvitation(_x159) {
        return _ref143.apply(this, arguments);
    };
}();

var resendInvitation = function () {
    var _ref144 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee144(invitationId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee144$(_context144) {
            while (1) {
                switch (_context144.prev = _context144.next) {
                    case 0:
                        _context144.next = 2;
                        return axios.post('Invitations/resend/' + invitationId);

                    case 2:
                        result = _context144.sent;
                        return _context144.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context144.stop();
                }
            }
        }, _callee144, this);
    }));

    return function resendInvitation(_x160) {
        return _ref144.apply(this, arguments);
    };
}();

// device statistics
var getDeviceStatisticsForSystem = function () {
    var _ref145 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee145(systemId, day) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee145$(_context145) {
            while (1) {
                switch (_context145.prev = _context145.next) {
                    case 0:
                        _context145.next = 2;
                        return axios.get('Statistics/devices/' + systemId + '/' + day);

                    case 2:
                        result = _context145.sent;
                        return _context145.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context145.stop();
                }
            }
        }, _callee145, this);
    }));

    return function getDeviceStatisticsForSystem(_x161, _x162) {
        return _ref145.apply(this, arguments);
    };
}();

var getSystemGeneralAlarms = function () {
    var _ref146 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee146(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee146$(_context146) {
            while (1) {
                switch (_context146.prev = _context146.next) {
                    case 0:
                        _context146.next = 2;
                        return axios.get('Alarm/general/' + systemId);

                    case 2:
                        result = _context146.sent;
                        return _context146.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context146.stop();
                }
            }
        }, _callee146, this);
    }));

    return function getSystemGeneralAlarms(_x163) {
        return _ref146.apply(this, arguments);
    };
}();

var getSystemTasks = function () {
    var _ref147 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee147(systemId) {
        var showResolved = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee147$(_context147) {
            while (1) {
                switch (_context147.prev = _context147.next) {
                    case 0:
                        _context147.next = 2;
                        return axios.get('Alarm/tasks/' + systemId + '/' + showResolved);

                    case 2:
                        result = _context147.sent;
                        return _context147.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context147.stop();
                }
            }
        }, _callee147, this);
    }));

    return function getSystemTasks(_x164) {
        return _ref147.apply(this, arguments);
    };
}();

var dismissAlarms = function () {
    var _ref148 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee148(systemId, obj) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee148$(_context148) {
            while (1) {
                switch (_context148.prev = _context148.next) {
                    case 0:
                        _context148.next = 2;
                        return axios.post('Alarm/dismiss/' + systemId, obj);

                    case 2:
                        result = _context148.sent;
                        return _context148.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context148.stop();
                }
            }
        }, _callee148, this);
    }));

    return function dismissAlarms(_x166, _x167) {
        return _ref148.apply(this, arguments);
    };
}();

var dismissManyAlarms = function () {
    var _ref149 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee149(systemId, obj) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee149$(_context149) {
            while (1) {
                switch (_context149.prev = _context149.next) {
                    case 0:
                        _context149.next = 2;
                        return axios.post('Alarm/dismissMany/' + systemId, obj);

                    case 2:
                        result = _context149.sent;
                        return _context149.abrupt('return', result);

                    case 4:
                    case 'end':
                        return _context149.stop();
                }
            }
        }, _callee149, this);
    }));

    return function dismissManyAlarms(_x168, _x169) {
        return _ref149.apply(this, arguments);
    };
}();

var hasTasks = function () {
    var _ref150 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee150(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee150$(_context150) {
            while (1) {
                switch (_context150.prev = _context150.next) {
                    case 0:
                        _context150.next = 2;
                        return axios.get('Alarm/tasks/has/' + systemId);

                    case 2:
                        result = _context150.sent;
                        return _context150.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context150.stop();
                }
            }
        }, _callee150, this);
    }));

    return function hasTasks(_x170) {
        return _ref150.apply(this, arguments);
    };
}();

var getShortDevicesList = function () {
    var _ref151 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee151(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee151$(_context151) {
            while (1) {
                switch (_context151.prev = _context151.next) {
                    case 0:
                        _context151.next = 2;
                        return axios.get('Device/short/' + systemId);

                    case 2:
                        result = _context151.sent;
                        return _context151.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context151.stop();
                }
            }
        }, _callee151, this);
    }));

    return function getShortDevicesList(_x171) {
        return _ref151.apply(this, arguments);
    };
}();

var getAlarmSystemRules = function () {
    var _ref152 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee152(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee152$(_context152) {
            while (1) {
                switch (_context152.prev = _context152.next) {
                    case 0:
                        _context152.next = 2;
                        return axios.get('Alarm/rules/' + systemId);

                    case 2:
                        result = _context152.sent;
                        return _context152.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context152.stop();
                }
            }
        }, _callee152, this);
    }));

    return function getAlarmSystemRules(_x172) {
        return _ref152.apply(this, arguments);
    };
}();

var addAlarmSystemRules = function () {
    var _ref153 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee153(obj) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee153$(_context153) {
            while (1) {
                switch (_context153.prev = _context153.next) {
                    case 0:
                        _context153.next = 2;
                        return axios.post('Alarm/rules/add', obj);

                    case 2:
                        result = _context153.sent;
                        return _context153.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context153.stop();
                }
            }
        }, _callee153, this);
    }));

    return function addAlarmSystemRules(_x173) {
        return _ref153.apply(this, arguments);
    };
}();

var turnOnAllAlarmsForSystem = function () {
    var _ref154 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee154(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee154$(_context154) {
            while (1) {
                switch (_context154.prev = _context154.next) {
                    case 0:
                        _context154.next = 2;
                        return axios.post('Alarm/rules/delete/all/' + systemId);

                    case 2:
                        result = _context154.sent;
                        return _context154.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context154.stop();
                }
            }
        }, _callee154, this);
    }));

    return function turnOnAllAlarmsForSystem(_x174) {
        return _ref154.apply(this, arguments);
    };
}();

var turnOnAlarmTypeForSystem = function () {
    var _ref155 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee155(obj) {
        var toSend, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee155$(_context155) {
            while (1) {
                switch (_context155.prev = _context155.next) {
                    case 0:
                        toSend = { Rules: obj };
                        _context155.next = 3;
                        return axios.post('Alarm/rules/delete', toSend);

                    case 3:
                        result = _context155.sent;
                        return _context155.abrupt('return', result.data);

                    case 5:
                    case 'end':
                        return _context155.stop();
                }
            }
        }, _callee155, this);
    }));

    return function turnOnAlarmTypeForSystem(_x175) {
        return _ref155.apply(this, arguments);
    };
}();

var getSystemSettingsOverview = function () {
    var _ref156 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee156(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee156$(_context156) {
            while (1) {
                switch (_context156.prev = _context156.next) {
                    case 0:
                        _context156.next = 2;
                        return axios.get('System/settings/overview/' + systemId);

                    case 2:
                        result = _context156.sent;
                        return _context156.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context156.stop();
                }
            }
        }, _callee156, this);
    }));

    return function getSystemSettingsOverview(_x176) {
        return _ref156.apply(this, arguments);
    };
}();

var updateSystemAlarmOff = function () {
    var _ref157 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee157(systemId, offObject) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee157$(_context157) {
            while (1) {
                switch (_context157.prev = _context157.next) {
                    case 0:
                        _context157.next = 2;
                        return axios.post('System/alarms/monitoring/system/' + systemId, offObject);

                    case 2:
                    case 'end':
                        return _context157.stop();
                }
            }
        }, _callee157, this);
    }));

    return function updateSystemAlarmOff(_x177, _x178) {
        return _ref157.apply(this, arguments);
    };
}();

var updateSystemCheckupDone = function () {
    var _ref158 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee158(checkupObject) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee158$(_context158) {
            while (1) {
                switch (_context158.prev = _context158.next) {
                    case 0:
                        _context158.next = 2;
                        return axios.post('System/checkup', checkupObject);

                    case 2:
                    case 'end':
                        return _context158.stop();
                }
            }
        }, _callee158, this);
    }));

    return function updateSystemCheckupDone(_x179) {
        return _ref158.apply(this, arguments);
    };
}();

var getTodayCheckupForSystem = function () {
    var _ref159 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee159(systemId) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee159$(_context159) {
            while (1) {
                switch (_context159.prev = _context159.next) {
                    case 0:
                        _context159.next = 2;
                        return axios.get('System/checkup/' + systemId);

                    case 2:
                        response = _context159.sent;
                        return _context159.abrupt('return', response);

                    case 4:
                    case 'end':
                        return _context159.stop();
                }
            }
        }, _callee159, this);
    }));

    return function getTodayCheckupForSystem(_x180) {
        return _ref159.apply(this, arguments);
    };
}();

var getUnknownAnimalWeightAlarmParam = function () {
    var _ref160 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee160(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee160$(_context160) {
            while (1) {
                switch (_context160.prev = _context160.next) {
                    case 0:
                        _context160.next = 2;
                        return axios.get('Alarm/unknownAnimalWeightAlarmParam/' + systemId);

                    case 2:
                        result = _context160.sent;
                        return _context160.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context160.stop();
                }
            }
        }, _callee160, this);
    }));

    return function getUnknownAnimalWeightAlarmParam(_x181) {
        return _ref160.apply(this, arguments);
    };
}();

var updateUnknownAnimalWeightAlarmParam = function () {
    var _ref161 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee161(systemId, value) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee161$(_context161) {
            while (1) {
                switch (_context161.prev = _context161.next) {
                    case 0:
                        _context161.next = 2;
                        return axios.put('Alarm/unknownAnimalWeightAlarmParam/' + systemId + '/' + value);

                    case 2:
                    case 'end':
                        return _context161.stop();
                }
            }
        }, _callee161, this);
    }));

    return function updateUnknownAnimalWeightAlarmParam(_x182, _x183) {
        return _ref161.apply(this, arguments);
    };
}();

var getCalibrationDateErrorAfterDaysParam = function () {
    var _ref162 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee162(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee162$(_context162) {
            while (1) {
                switch (_context162.prev = _context162.next) {
                    case 0:
                        _context162.next = 2;
                        return axios.get('System/calibrationDate/error/' + systemId);

                    case 2:
                        result = _context162.sent;
                        return _context162.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context162.stop();
                }
            }
        }, _callee162, this);
    }));

    return function getCalibrationDateErrorAfterDaysParam(_x184) {
        return _ref162.apply(this, arguments);
    };
}();

var updateCalibrationDateErrorAfterDaysParam = function () {
    var _ref163 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee163(systemId, value) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee163$(_context163) {
            while (1) {
                switch (_context163.prev = _context163.next) {
                    case 0:
                        _context163.next = 2;
                        return axios.put('System/calibrationDate/error/' + systemId + '/' + value);

                    case 2:
                    case 'end':
                        return _context163.stop();
                }
            }
        }, _callee163, this);
    }));

    return function updateCalibrationDateErrorAfterDaysParam(_x185, _x186) {
        return _ref163.apply(this, arguments);
    };
}();

var getHerdWeight = function () {
    var _ref164 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee164(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee164$(_context164) {
            while (1) {
                switch (_context164.prev = _context164.next) {
                    case 0:
                        _context164.next = 2;
                        return axios.get('Animals/chart/herd/weight/' + systemId);

                    case 2:
                        result = _context164.sent;
                        return _context164.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context164.stop();
                }
            }
        }, _callee164, this);
    }));

    return function getHerdWeight(_x187) {
        return _ref164.apply(this, arguments);
    };
}();

var getAnimals = function () {
    var _ref165 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee165(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee165$(_context165) {
            while (1) {
                switch (_context165.prev = _context165.next) {
                    case 0:
                        _context165.next = 2;
                        return axios.get('Animals/overview/animals/' + systemId + '?systemDate=' + new Date().toISOString());

                    case 2:
                        result = _context165.sent;
                        return _context165.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context165.stop();
                }
            }
        }, _callee165, this);
    }));

    return function getAnimals(_x188) {
        return _ref165.apply(this, arguments);
    };
}();

var getAnimalWeightChart = function () {
    var _ref166 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee166(systemId, animalId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee166$(_context166) {
            while (1) {
                switch (_context166.prev = _context166.next) {
                    case 0:
                        _context166.next = 2;
                        return axios.get('Animals/chart/animal/weight/' + systemId + '/' + animalId + '/All');

                    case 2:
                        result = _context166.sent;
                        return _context166.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context166.stop();
                }
            }
        }, _callee166, this);
    }));

    return function getAnimalWeightChart(_x189, _x190) {
        return _ref166.apply(this, arguments);
    };
}();

var getAnimalConsumptionChart = function () {
    var _ref167 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee167(systemId, animalId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee167$(_context167) {
            while (1) {
                switch (_context167.prev = _context167.next) {
                    case 0:
                        _context167.next = 2;
                        return axios.get('Animals/chart/animal/consumption/' + systemId + '/' + animalId + '/All');

                    case 2:
                        result = _context167.sent;
                        return _context167.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context167.stop();
                }
            }
        }, _callee167, this);
    }));

    return function getAnimalConsumptionChart(_x191, _x192) {
        return _ref167.apply(this, arguments);
    };
}();

var getAnimalVisitsChart = function () {
    var _ref168 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee168(systemId, animalId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee168$(_context168) {
            while (1) {
                switch (_context168.prev = _context168.next) {
                    case 0:
                        _context168.next = 2;
                        return axios.get('Animals/chart/animal/visits/' + systemId + '/' + animalId + '/All');

                    case 2:
                        result = _context168.sent;
                        return _context168.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context168.stop();
                }
            }
        }, _callee168, this);
    }));

    return function getAnimalVisitsChart(_x193, _x194) {
        return _ref168.apply(this, arguments);
    };
}();

var getSensorsChartData = function () {
    var _ref169 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee169(systemId) {
        var from, to, result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee169$(_context169) {
            while (1) {
                switch (_context169.prev = _context169.next) {
                    case 0:
                        from = new Date();

                        from.setDate(from.getDate() - 61);
                        from = from.toISOString();
                        to = new Date().toISOString();
                        _context169.next = 6;
                        return axios.get('SystemStatus/chart/sensors/' + systemId + '/' + from + '/' + to);

                    case 6:
                        result = _context169.sent;
                        return _context169.abrupt('return', result.data);

                    case 8:
                    case 'end':
                        return _context169.stop();
                }
            }
        }, _callee169, this);
    }));

    return function getSensorsChartData(_x195) {
        return _ref169.apply(this, arguments);
    };
}();

// CLOUD API

var getCloudServers = function () {
    var _ref170 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee170() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee170$(_context170) {
            while (1) {
                switch (_context170.prev = _context170.next) {
                    case 0:
                        _context170.next = 2;
                        return axios.get('Cloud/servers');

                    case 2:
                        result = _context170.sent;
                        return _context170.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context170.stop();
                }
            }
        }, _callee170, this);
    }));

    return function getCloudServers() {
        return _ref170.apply(this, arguments);
    };
}();

var getServerUsers = function () {
    var _ref171 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee171() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee171$(_context171) {
            while (1) {
                switch (_context171.prev = _context171.next) {
                    case 0:
                        _context171.next = 2;
                        return axios.get('Cloud/users/server');

                    case 2:
                        result = _context171.sent;
                        return _context171.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context171.stop();
                }
            }
        }, _callee171, this);
    }));

    return function getServerUsers() {
        return _ref171.apply(this, arguments);
    };
}();

var addServerConfiguration = function () {
    var _ref172 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee172(config) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee172$(_context172) {
            while (1) {
                switch (_context172.prev = _context172.next) {
                    case 0:
                        _context172.next = 2;
                        return axios.post('Cloud/new', config);

                    case 2:
                        result = _context172.sent;
                        return _context172.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context172.stop();
                }
            }
        }, _callee172, this);
    }));

    return function addServerConfiguration(_x196) {
        return _ref172.apply(this, arguments);
    };
}();

var assignServerSystem = function () {
    var _ref173 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee173(systems) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee173$(_context173) {
            while (1) {
                switch (_context173.prev = _context173.next) {
                    case 0:
                        _context173.next = 2;
                        return axios.post('Cloud/assign/systems', systems);

                    case 2:
                    case 'end':
                        return _context173.stop();
                }
            }
        }, _callee173, this);
    }));

    return function assignServerSystem(_x197) {
        return _ref173.apply(this, arguments);
    };
}();

var assignServerManager = function () {
    var _ref174 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee174(serverId, userId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee174$(_context174) {
            while (1) {
                switch (_context174.prev = _context174.next) {
                    case 0:
                        _context174.next = 2;
                        return axios.post('Cloud/assign/manager/' + serverId + '/' + userId);

                    case 2:
                    case 'end':
                        return _context174.stop();
                }
            }
        }, _callee174, this);
    }));

    return function assignServerManager(_x198, _x199) {
        return _ref174.apply(this, arguments);
    };
}();

var deleteServer = function () {
    var _ref175 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee175(serverId) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee175$(_context175) {
            while (1) {
                switch (_context175.prev = _context175.next) {
                    case 0:
                        _context175.next = 2;
                        return axios.delete('Cloud/' + serverId);

                    case 2:
                    case 'end':
                        return _context175.stop();
                }
            }
        }, _callee175, this);
    }));

    return function deleteServer(_x200) {
        return _ref175.apply(this, arguments);
    };
}();

var getServerSystems = function () {
    var _ref176 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee176(serverId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee176$(_context176) {
            while (1) {
                switch (_context176.prev = _context176.next) {
                    case 0:
                        _context176.next = 2;
                        return axios.get('Cloud/server/' + serverId + '/systems');

                    case 2:
                        result = _context176.sent;
                        return _context176.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context176.stop();
                }
            }
        }, _callee176, this);
    }));

    return function getServerSystems(_x201) {
        return _ref176.apply(this, arguments);
    };
}();

var getSystemsAvailableForCloud = function () {
    var _ref177 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee177() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee177$(_context177) {
            while (1) {
                switch (_context177.prev = _context177.next) {
                    case 0:
                        _context177.next = 2;
                        return axios.get('Cloud/systems/identifiers');

                    case 2:
                        result = _context177.sent;
                        return _context177.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context177.stop();
                }
            }
        }, _callee177, this);
    }));

    return function getSystemsAvailableForCloud() {
        return _ref177.apply(this, arguments);
    };
}();

var updateCloudSystemAssigment = function () {
    var _ref178 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee178(serverId, cloudSystem) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee178$(_context178) {
            while (1) {
                switch (_context178.prev = _context178.next) {
                    case 0:
                        _context178.next = 2;
                        return axios.post('Cloud/assign/system/edit/' + serverId, cloudSystem);

                    case 2:
                    case 'end':
                        return _context178.stop();
                }
            }
        }, _callee178, this);
    }));

    return function updateCloudSystemAssigment(_x202, _x203) {
        return _ref178.apply(this, arguments);
    };
}();

// SOFTWARE UPDATER

var getVersionsOverview = function () {
    var _ref179 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee179() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee179$(_context179) {
            while (1) {
                switch (_context179.prev = _context179.next) {
                    case 0:
                        _context179.next = 2;
                        return axios.get('Updater/overview');

                    case 2:
                        result = _context179.sent;
                        return _context179.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context179.stop();
                }
            }
        }, _callee179, this);
    }));

    return function getVersionsOverview() {
        return _ref179.apply(this, arguments);
    };
}();

var getVersionById = function () {
    var _ref180 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee180(id, config) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee180$(_context180) {
            while (1) {
                switch (_context180.prev = _context180.next) {
                    case 0:
                        config.responseType = 'blob';
                        _context180.next = 3;
                        return axios.get('Updater/version/' + id, config);

                    case 3:
                        result = _context180.sent;
                        return _context180.abrupt('return', result);

                    case 5:
                    case 'end':
                        return _context180.stop();
                }
            }
        }, _callee180, this);
    }));

    return function getVersionById(_x204, _x205) {
        return _ref180.apply(this, arguments);
    };
}();

var addNewSoftwareVersion = function () {
    var _ref181 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee181(newVersion) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee181$(_context181) {
            while (1) {
                switch (_context181.prev = _context181.next) {
                    case 0:
                        _context181.next = 2;
                        return axios.post('Updater/new', newVersion);

                    case 2:
                        result = _context181.sent;
                        return _context181.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context181.stop();
                }
            }
        }, _callee181, this);
    }));

    return function addNewSoftwareVersion(_x206) {
        return _ref181.apply(this, arguments);
    };
}();

var getSoftwareProducts = function () {
    var _ref182 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee182() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee182$(_context182) {
            while (1) {
                switch (_context182.prev = _context182.next) {
                    case 0:
                        _context182.next = 2;
                        return axios.get('Updater/products');

                    case 2:
                        result = _context182.sent;
                        return _context182.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context182.stop();
                }
            }
        }, _callee182, this);
    }));

    return function getSoftwareProducts() {
        return _ref182.apply(this, arguments);
    };
}();

var getSoftwareVersionInfoById = function () {
    var _ref183 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee183(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee183$(_context183) {
            while (1) {
                switch (_context183.prev = _context183.next) {
                    case 0:
                        _context183.next = 2;
                        return axios.get('Updater/info/version/' + id);

                    case 2:
                        result = _context183.sent;
                        return _context183.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context183.stop();
                }
            }
        }, _callee183, this);
    }));

    return function getSoftwareVersionInfoById(_x207) {
        return _ref183.apply(this, arguments);
    };
}();

var uploadBigSoftwareFileChunk = function () {
    var _ref184 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee184(form) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee184$(_context184) {
            while (1) {
                switch (_context184.prev = _context184.next) {
                    case 0:
                        _context184.next = 2;
                        return axios.post('Updater/upload', form, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        });

                    case 2:
                    case 'end':
                        return _context184.stop();
                }
            }
        }, _callee184, this);
    }));

    return function uploadBigSoftwareFileChunk(_x208) {
        return _ref184.apply(this, arguments);
    };
}();

var uploadBigSoftwareFile = function () {
    var _ref185 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee185(form, id, config) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee185$(_context185) {
            while (1) {
                switch (_context185.prev = _context185.next) {
                    case 0:
                        config.headers = { 'Content-Type': 'multipart/form-data' };
                        _context185.next = 3;
                        return axios.post('Updater/upload/stream/' + id, form, config);

                    case 3:
                    case 'end':
                        return _context185.stop();
                }
            }
        }, _callee185, this);
    }));

    return function uploadBigSoftwareFile(_x209, _x210, _x211) {
        return _ref185.apply(this, arguments);
    };
}();

var uploadRequirementFile = function () {
    var _ref186 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee186(form, id, config) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee186$(_context186) {
            while (1) {
                switch (_context186.prev = _context186.next) {
                    case 0:
                        config.headers = { 'Content-Type': 'multipart/form-data' };
                        _context186.next = 3;
                        return axios.post('Updater/requirements/upload/stream/' + id, form, config);

                    case 3:
                    case 'end':
                        return _context186.stop();
                }
            }
        }, _callee186, this);
    }));

    return function uploadRequirementFile(_x212, _x213, _x214) {
        return _ref186.apply(this, arguments);
    };
}();

var getSoftwarePlatforms = function () {
    var _ref187 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee187() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee187$(_context187) {
            while (1) {
                switch (_context187.prev = _context187.next) {
                    case 0:
                        _context187.next = 2;
                        return axios.get('Updater/platforms');

                    case 2:
                        res = _context187.sent;
                        return _context187.abrupt('return', res.data);

                    case 4:
                    case 'end':
                        return _context187.stop();
                }
            }
        }, _callee187, this);
    }));

    return function getSoftwarePlatforms() {
        return _ref187.apply(this, arguments);
    };
}();

var getArchitectures = function () {
    var _ref188 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee188() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee188$(_context188) {
            while (1) {
                switch (_context188.prev = _context188.next) {
                    case 0:
                        _context188.next = 2;
                        return axios.get('Updater/architectures');

                    case 2:
                        res = _context188.sent;
                        return _context188.abrupt('return', res.data);

                    case 4:
                    case 'end':
                        return _context188.stop();
                }
            }
        }, _callee188, this);
    }));

    return function getArchitectures() {
        return _ref188.apply(this, arguments);
    };
}();

var deleteVersion = function () {
    var _ref189 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee189(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee189$(_context189) {
            while (1) {
                switch (_context189.prev = _context189.next) {
                    case 0:
                        _context189.next = 2;
                        return axios.delete('Updater/delete/' + id);

                    case 2:
                    case 'end':
                        return _context189.stop();
                }
            }
        }, _callee189, this);
    }));

    return function deleteVersion(_x215) {
        return _ref189.apply(this, arguments);
    };
}();

var editSoftwareVersion = function () {
    var _ref190 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee190(obj) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee190$(_context190) {
            while (1) {
                switch (_context190.prev = _context190.next) {
                    case 0:
                        _context190.next = 2;
                        return axios.post('Updater/edit', obj);

                    case 2:
                        result = _context190.sent;
                        return _context190.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context190.stop();
                }
            }
        }, _callee190, this);
    }));

    return function editSoftwareVersion(_x216) {
        return _ref190.apply(this, arguments);
    };
}();

// Software Shortcuts

var getSoftwareShortcutCards = function () {
    var _ref191 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee191() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee191$(_context191) {
            while (1) {
                switch (_context191.prev = _context191.next) {
                    case 0:
                        _context191.next = 2;
                        return axios.get('SoftwareShortcut/cards');

                    case 2:
                        result = _context191.sent;
                        return _context191.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context191.stop();
                }
            }
        }, _callee191, this);
    }));

    return function getSoftwareShortcutCards() {
        return _ref191.apply(this, arguments);
    };
}();

var getSoftwareShortcutById = function () {
    var _ref192 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee192(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee192$(_context192) {
            while (1) {
                switch (_context192.prev = _context192.next) {
                    case 0:
                        _context192.next = 2;
                        return axios.get('SoftwareShortcut/' + id);

                    case 2:
                        result = _context192.sent;
                        return _context192.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context192.stop();
                }
            }
        }, _callee192, this);
    }));

    return function getSoftwareShortcutById(_x217) {
        return _ref192.apply(this, arguments);
    };
}();

var addSoftwareShortcut = function () {
    var _ref193 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee193(shortcut) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee193$(_context193) {
            while (1) {
                switch (_context193.prev = _context193.next) {
                    case 0:
                        _context193.next = 2;
                        return axios.post('SoftwareShortcut', shortcut);

                    case 2:
                        result = _context193.sent;
                        return _context193.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context193.stop();
                }
            }
        }, _callee193, this);
    }));

    return function addSoftwareShortcut(_x218) {
        return _ref193.apply(this, arguments);
    };
}();

var editSoftwareShortcut = function () {
    var _ref194 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee194(shortcut) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee194$(_context194) {
            while (1) {
                switch (_context194.prev = _context194.next) {
                    case 0:
                        _context194.next = 2;
                        return axios.put('SoftwareShortcut', shortcut);

                    case 2:
                    case 'end':
                        return _context194.stop();
                }
            }
        }, _callee194, this);
    }));

    return function editSoftwareShortcut(_x219) {
        return _ref194.apply(this, arguments);
    };
}();

var deleteSoftwareShortcut = function () {
    var _ref195 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee195(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee195$(_context195) {
            while (1) {
                switch (_context195.prev = _context195.next) {
                    case 0:
                        _context195.next = 2;
                        return axios.delete('SoftwareShortcut/' + id);

                    case 2:
                    case 'end':
                        return _context195.stop();
                }
            }
        }, _callee195, this);
    }));

    return function deleteSoftwareShortcut(_x220) {
        return _ref195.apply(this, arguments);
    };
}();

// Requirements

var addRequirement = function () {
    var _ref196 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee196(obj) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee196$(_context196) {
            while (1) {
                switch (_context196.prev = _context196.next) {
                    case 0:
                        _context196.next = 2;
                        return axios.post('Updater/requirements/new', obj);

                    case 2:
                        result = _context196.sent;
                        return _context196.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context196.stop();
                }
            }
        }, _callee196, this);
    }));

    return function addRequirement(_x221) {
        return _ref196.apply(this, arguments);
    };
}();

var editRequirement = function () {
    var _ref197 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee197(obj) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee197$(_context197) {
            while (1) {
                switch (_context197.prev = _context197.next) {
                    case 0:
                        _context197.next = 2;
                        return axios.post('Updater/requirements/edit', obj);

                    case 2:
                    case 'end':
                        return _context197.stop();
                }
            }
        }, _callee197, this);
    }));

    return function editRequirement(_x222) {
        return _ref197.apply(this, arguments);
    };
}();

var deleteRequirement = function () {
    var _ref198 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee198(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee198$(_context198) {
            while (1) {
                switch (_context198.prev = _context198.next) {
                    case 0:
                        _context198.next = 2;
                        return axios.delete('Updater/requirements/delete/' + id);

                    case 2:
                    case 'end':
                        return _context198.stop();
                }
            }
        }, _callee198, this);
    }));

    return function deleteRequirement(_x223) {
        return _ref198.apply(this, arguments);
    };
}();

var getRequirementsList = function () {
    var _ref199 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee199() {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee199$(_context199) {
            while (1) {
                switch (_context199.prev = _context199.next) {
                    case 0:
                        _context199.next = 2;
                        return axios.get('Updater/requirements/list');

                    case 2:
                        response = _context199.sent;
                        return _context199.abrupt('return', response.data);

                    case 4:
                    case 'end':
                        return _context199.stop();
                }
            }
        }, _callee199, this);
    }));

    return function getRequirementsList() {
        return _ref199.apply(this, arguments);
    };
}();

var getRequirementById = function () {
    var _ref200 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee200(id, config) {
        var response;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee200$(_context200) {
            while (1) {
                switch (_context200.prev = _context200.next) {
                    case 0:
                        config.responseType = 'blob';
                        _context200.next = 3;
                        return axios.get('Updater/requirement/' + id, config);

                    case 3:
                        response = _context200.sent;
                        return _context200.abrupt('return', response);

                    case 5:
                    case 'end':
                        return _context200.stop();
                }
            }
        }, _callee200, this);
    }));

    return function getRequirementById(_x224, _x225) {
        return _ref200.apply(this, arguments);
    };
}();

// BACKUPS

var getBackupsOverview = function () {
    var _ref201 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee201() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee201$(_context201) {
            while (1) {
                switch (_context201.prev = _context201.next) {
                    case 0:
                        _context201.next = 2;
                        return axios.get('Backup/overview');

                    case 2:
                        result = _context201.sent;
                        return _context201.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context201.stop();
                }
            }
        }, _callee201, this);
    }));

    return function getBackupsOverview() {
        return _ref201.apply(this, arguments);
    };
}();

var getBackupById = function () {
    var _ref202 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee202(id, config) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee202$(_context202) {
            while (1) {
                switch (_context202.prev = _context202.next) {
                    case 0:
                        config.responseType = 'blob';
                        _context202.next = 3;
                        return axios.get('Backup/' + id, config);

                    case 3:
                        result = _context202.sent;
                        return _context202.abrupt('return', result);

                    case 5:
                    case 'end':
                        return _context202.stop();
                }
            }
        }, _callee202, this);
    }));

    return function getBackupById(_x226, _x227) {
        return _ref202.apply(this, arguments);
    };
}();

var deleteBackup = function () {
    var _ref203 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee203(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee203$(_context203) {
            while (1) {
                switch (_context203.prev = _context203.next) {
                    case 0:
                        _context203.next = 2;
                        return axios.delete('Backup/delete/' + id);

                    case 2:
                    case 'end':
                        return _context203.stop();
                }
            }
        }, _callee203, this);
    }));

    return function deleteBackup(_x228) {
        return _ref203.apply(this, arguments);
    };
}();

/* SCHEDULED REPORTS */
// Cykliczne raporty e-mail o alarmach. Nie mylic z PdfReport (raporty serwisowe z wizyt).

var getScheduledReports = function () {
    var _ref204 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee204() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee204$(_context204) {
            while (1) {
                switch (_context204.prev = _context204.next) {
                    case 0:
                        _context204.next = 2;
                        return axios.get('ScheduledReport');

                    case 2:
                        result = _context204.sent;
                        return _context204.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context204.stop();
                }
            }
        }, _callee204, this);
    }));

    return function getScheduledReports() {
        return _ref204.apply(this, arguments);
    };
}();

var getScheduledReport = function () {
    var _ref205 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee205(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee205$(_context205) {
            while (1) {
                switch (_context205.prev = _context205.next) {
                    case 0:
                        _context205.next = 2;
                        return axios.get('ScheduledReport/' + id);

                    case 2:
                        result = _context205.sent;
                        return _context205.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context205.stop();
                }
            }
        }, _callee205, this);
    }));

    return function getScheduledReport(_x229) {
        return _ref205.apply(this, arguments);
    };
}();

var addScheduledReport = function () {
    var _ref206 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee206(report) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee206$(_context206) {
            while (1) {
                switch (_context206.prev = _context206.next) {
                    case 0:
                        _context206.next = 2;
                        return axios.post('ScheduledReport', report);

                    case 2:
                        result = _context206.sent;
                        return _context206.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context206.stop();
                }
            }
        }, _callee206, this);
    }));

    return function addScheduledReport(_x230) {
        return _ref206.apply(this, arguments);
    };
}();

var editScheduledReport = function () {
    var _ref207 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee207(report) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee207$(_context207) {
            while (1) {
                switch (_context207.prev = _context207.next) {
                    case 0:
                        _context207.next = 2;
                        return axios.put('ScheduledReport', report);

                    case 2:
                        result = _context207.sent;
                        return _context207.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context207.stop();
                }
            }
        }, _callee207, this);
    }));

    return function editScheduledReport(_x231) {
        return _ref207.apply(this, arguments);
    };
}();

var deleteScheduledReport = function () {
    var _ref208 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee208(id) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee208$(_context208) {
            while (1) {
                switch (_context208.prev = _context208.next) {
                    case 0:
                        _context208.next = 2;
                        return axios.delete('ScheduledReport/' + id);

                    case 2:
                    case 'end':
                        return _context208.stop();
                }
            }
        }, _callee208, this);
    }));

    return function deleteScheduledReport(_x232) {
        return _ref208.apply(this, arguments);
    };
}();

var previewScheduledReport = function () {
    var _ref209 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee209(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee209$(_context209) {
            while (1) {
                switch (_context209.prev = _context209.next) {
                    case 0:
                        _context209.next = 2;
                        return axios.get('ScheduledReport/' + id + '/preview', { responseType: 'text' });

                    case 2:
                        result = _context209.sent;
                        return _context209.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context209.stop();
                }
            }
        }, _callee209, this);
    }));

    return function previewScheduledReport(_x233) {
        return _ref209.apply(this, arguments);
    };
}();

var sendScheduledReportNow = function () {
    var _ref210 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee210(id) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee210$(_context210) {
            while (1) {
                switch (_context210.prev = _context210.next) {
                    case 0:
                        _context210.next = 2;
                        return axios.post('ScheduledReport/' + id + '/send-now');

                    case 2:
                        result = _context210.sent;
                        return _context210.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context210.stop();
                }
            }
        }, _callee210, this);
    }));

    return function sendScheduledReportNow(_x234) {
        return _ref210.apply(this, arguments);
    };
}();

/* API USAGE CONTROLLER */
// Diagnostyka uzycia API (tylko Admin). Listy (userIds, roles) jako napisy rozdzielane przecinkami.

var getApiUsageReport = function () {
    var _ref211 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee211(params) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee211$(_context211) {
            while (1) {
                switch (_context211.prev = _context211.next) {
                    case 0:
                        _context211.next = 2;
                        return axios.get('ApiUsage/report', { params: params });

                    case 2:
                        result = _context211.sent;
                        return _context211.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context211.stop();
                }
            }
        }, _callee211, this);
    }));

    return function getApiUsageReport(_x235) {
        return _ref211.apply(this, arguments);
    };
}();

var getApiUsageTimeline = function () {
    var _ref212 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee212(params) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee212$(_context212) {
            while (1) {
                switch (_context212.prev = _context212.next) {
                    case 0:
                        _context212.next = 2;
                        return axios.get('ApiUsage/timeline', { params: params });

                    case 2:
                        result = _context212.sent;
                        return _context212.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context212.stop();
                }
            }
        }, _callee212, this);
    }));

    return function getApiUsageTimeline(_x236) {
        return _ref212.apply(this, arguments);
    };
}();

var getApiUsageEndpoints = function () {
    var _ref213 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee213() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee213$(_context213) {
            while (1) {
                switch (_context213.prev = _context213.next) {
                    case 0:
                        _context213.next = 2;
                        return axios.get('ApiUsage/endpoints');

                    case 2:
                        result = _context213.sent;
                        return _context213.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context213.stop();
                }
            }
        }, _callee213, this);
    }));

    return function getApiUsageEndpoints() {
        return _ref213.apply(this, arguments);
    };
}();

/* NOTIFICATION CONTROLLER */

var getSystemNotifications = function () {
    var _ref214 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee214(systemId) {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee214$(_context214) {
            while (1) {
                switch (_context214.prev = _context214.next) {
                    case 0:
                        _context214.next = 2;
                        return axios.get('Notification/system/' + systemId);

                    case 2:
                        result = _context214.sent;
                        return _context214.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context214.stop();
                }
            }
        }, _callee214, this);
    }));

    return function getSystemNotifications(_x237) {
        return _ref214.apply(this, arguments);
    };
}();

var sendNotificationsNow = function () {
    var _ref215 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee215() {
        var result;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee215$(_context215) {
            while (1) {
                switch (_context215.prev = _context215.next) {
                    case 0:
                        _context215.next = 2;
                        return axios.post('Notification/send-now');

                    case 2:
                        result = _context215.sent;
                        return _context215.abrupt('return', result.data);

                    case 4:
                    case 'end':
                        return _context215.stop();
                }
            }
        }, _callee215, this);
    }));

    return function sendNotificationsNow() {
        return _ref215.apply(this, arguments);
    };
}();

/***/ }),

/***/ 987:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App_vue__ = __webpack_require__(1004);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__ = __webpack_require__(1029);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__ = __webpack_require__(1067);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_bootstrap_vue_dist_bootstrap_vue_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portal_vue__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_portal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_portal_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_router__ = __webpack_require__(611);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__router__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(613);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__i18n__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_axios__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__syncfusion_ej2_vue_grids__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__syncfusion_ej2_base__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select_dist_vue_select_css__ = __webpack_require__(1494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_sidebar_menu_dist_vue_sidebar_menu_css__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_sidebar_menu_dist_vue_sidebar_menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_sidebar_menu_dist_vue_sidebar_menu_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_v_click_outside__ = __webpack_require__(1496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_v_click_outside___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_v_click_outside__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_tippy__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vue_composition_api__ = __webpack_require__(1498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_scichart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_scichart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_scichartWasm__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_sciChartRollover__ = __webpack_require__(1500);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_sciChartRollover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__utils_sciChartRollover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_theme__ = __webpack_require__(624);























// Dymki rollovera nie wychodzą poza lewą krawędź wykresu (poprawka SciChart 2.2).



__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_12_moment___default.a;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_11_axios__["default"];
// TEST LOKALNY: API uruchomione na 127.0.0.1:5080 (port 5000 zajmuje na macOS ControlCenter/AirPlay).
// Przed powrotem na produkcje przywroc adres cloudapi.
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http.defaults.baseURL = 'https://cloudapi.biocontrol.pl/api/';
// Vue.prototype.$http.defaults.baseURL = 'http://127.0.0.1:5080/api/'

// Pliki wasm/data SciChart muszą pochodzić z tej samej wersji co ten bundle.
// Ścieżka ze stemplem wersji jest generowana z libraryVersion tej samej paczki
// npm, z której build kopiuje wasm (build/scichart-wasm.js), więc po wystawieniu
// nowej wersji cache przeglądarki nie może podstawić starych plików.
Object(__WEBPACK_IMPORTED_MODULE_22__utils_scichartWasm__["a" /* configureSciChartWasm */])();
Object(__WEBPACK_IMPORTED_MODULE_22__utils_scichartWasm__["b" /* diagnoseSciChartWasm */])();

// Motyw jasny/ciemny: atrybut data-theme na <html> spięty ze store.
Object(__WEBPACK_IMPORTED_MODULE_24__utils_theme__["b" /* initTheme */])(__WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_21_scichart__["SciChartSurface"].setRuntimeLicenseKey("9fnKobcZvtBNBF9jQZk3G5P+MrqSU5Qy0LVdrM1wYFsj8qYS3Tl0FC8jRn3oqMFYX4XOpxuvho28MP7RovThJlsDqxPAv8Cokf4ntMh/ntIM/eNY8pn1w/k/m/DQauzO4fn9y/VUPiDWc/2AzNuKZByCWz7ine9T/4Sk+rMMUgUvWSyE5But64BfiYdX+1YKebjAijSspdwI5B9Ny2KCtNaBA4x36/Nm2WU4gMtRieT2oEeRqkWB34rLGbFXJqswFmXLV/wLC+a0iDVohNonX8hBB8eh/RTo5slTz0U/nRenuNl5FD3atRpKxr+QtC7OYVlXpBPF7k1zt7W9WmW75obS44T8q4huJxBgcWzxzIdfZmgL9O+/ehL7FX9k5IFs7e7J6x4nfV7sSQo2zPi+YsG8rA+dQTAASxxMJbc3p8p/rkYnEHj5eCVmfnw47YV8FHtRM/YOH8H9W3ERbEFLnkc2NMwCuzqbfME4JzGcWDjizwI12Y/eO3yKa/qg1+iSctO6UyyANJ/dK7G/Uc+6dgzCef4TdlfKuqfVtENyIACHxBD4gcyA1mcEb+rDp6rcyC0Xyrk00EGarIKYcOLt9gE5+DwuOb6P3ZmrXYNeU8jplYlP7sz1wTuEBQwY1wmGs7wtmeOHd4gCEErz44hpWT4oE95O9k79xR2Z4S8C49WMAbjQWC0MZxJFxLMo1MEeplRYfkFUbP1WDnHwWGP8svH/3RBvwETvKO1Qmvw=");
Object(__WEBPACK_IMPORTED_MODULE_14__syncfusion_ej2_base__["_7" /* registerLicense */])('ORg4AjUWIQA/Gnt2V1hhQlJMfV5AQmBIYVp/TGpJfl96cVxMZVVBJAtUQF1hSn5Ud0xjUXtXc31TRGhd');

var token = localStorage.getItem('token');
if (token) {
  __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http.defaults.headers.common['Authorization'] = token;
}

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_portal_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_bootstrap_vue__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('v-select', __WEBPACK_IMPORTED_MODULE_15_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13__syncfusion_ej2_vue_grids__["h" /* GridPlugin */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_v_click_outside___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_tippy__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20__vue_composition_api__["a" /* default */]);

new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */],
  i18n: __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */],
  template: '<App/>',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_2__App_vue__["a" /* default */]);
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$http.interceptors.response.use(undefined, function (err) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (err.response && err.response.status === 401 && err.response.config && !err.response.config.__isRetryRequest) {
          __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('logout');
        }
        throw err;
      });
    });
  }
}).$mount('#app');

__WEBPACK_IMPORTED_MODULE_11_axios__["default"].interceptors.response.use(function (response) {
  return response;
}, function (error) {
  // Cancelled requests (AbortController) and network errors have no response - pass them through untouched.
  if (__WEBPACK_IMPORTED_MODULE_11_axios__["default"].isCancel(error) || !error.response) {
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
  }
  var errMsg = error.response.data.error;
  if (error.response.status == 401 && error.response.config && !error.response.config.__isRetryRequest) {
    __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].dispatch('logout');
    __WEBPACK_IMPORTED_MODULE_8__router__["a" /* default */].push('/');
  } else if (error.response.status == 400) {
    console.error(errMsg);
  }
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

Array.prototype.repeat = function (what, L) {
  while (L) {
    this[--L] = what;
  }return this;
};

String.prototype.toDateTime = function () {
  var result = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this).format('YYYY-MM-DD HH:mm:ss');

  if (result == "Invalid date") {
    result = __WEBPACK_IMPORTED_MODULE_12_moment___default()(this, 'YYYY-MM-DD HH:mm:ss Z').format('YYYY-MM-DD HH:mm:ss');
  }

  return result;
};

Date.prototype.toAgoString = function () {
  var now = new Date();
  var t1 = this;
  var seconds = parseInt((now.getTime() - t1.getTime()) / 1000);
  var result = "";
  if (seconds < 60) {
    //seconds ago
    result = seconds + "s " + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else if (seconds < 3600) {
    //minutes ago
    var minutes = parseInt(seconds / 60, 10);
    var seconds = parseInt(seconds % 60, 10);
    result = minutes + 'min ' + seconds + 's ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else if (seconds < 3600 * 24) {
    // hours
    var hours = parseInt(seconds / 3600, 10);
    var minutes = parseInt(seconds / 60 % 60, 10);
    result = hours + 'h ' + minutes + 'min ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else {
    //days
    var days = parseInt(seconds / (3600 * 24));
    result = days + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('days') + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  }

  return result;
};

Date.prototype.toAgoStringVer2 = function () {
  var now = new Date();
  var t1 = this;
  var seconds = parseInt((now.getTime() - t1.getTime()) / 1000);
  var result = "";

  if (seconds >= 3600 * 24 * 365 * 100) {
    // more than 100 years
    result = __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('Never');
  } else if (seconds >= 3600 * 24 * 365) {
    // more than a year
    var years = parseInt(seconds / (3600 * 24 * 365), 10);
    result = years + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('years') + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else if (seconds < 3600) {
    // less than an hour
    var minutes = parseInt(seconds / 60, 10);
    var remainingSeconds = parseInt(seconds % 60, 10);
    result = minutes + 'min ' + remainingSeconds + 's ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else if (seconds < 3600 * 24) {
    // less than a day
    var hours = parseInt(seconds / 3600, 10);
    var minutes = parseInt(seconds / 60 % 60, 10);
    result = hours + 'h ' + minutes + 'min ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else if (seconds < 3600 * 48) {
    // less than 2 days
    var days = parseInt(seconds / (3600 * 24), 10);
    var hours = parseInt(seconds % (3600 * 24) / 3600, 10);
    result = days + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('day') + ' ' + hours + 'h ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  } else {
    // 2 days or more
    var days = parseInt(seconds / (3600 * 24), 10);
    result = days + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('days') + ' ' + __WEBPACK_IMPORTED_MODULE_10__i18n__["a" /* default */].t('ago');
  }

  return result;
};

String.prototype.toDate = function () {
  return __WEBPACK_IMPORTED_MODULE_12_moment___default()(this).format('DD-MM-YYYY');
};

Number.prototype.toAgoString = function () {
  if (this == 0) {
    return '-';
  } else if (this < 60) {
    return this + 's';
  }

  var noSeconds = this / 60;
  return parseInt(noSeconds / 60, 10) + "h " + parseInt(noSeconds % 60, 10) + "min";
};

Number.prototype.formatBytes = function () {
  var decimals = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

  if (!+this) return '0 Bytes';

  var k = 1024;
  var dm = decimals < 0 ? 0 : decimals;
  var sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];

  var i = Math.floor(Math.log(this) / Math.log(k));

  return parseFloat((this / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

/***/ })

},[987]);


// WEBPACK FOOTER //
// static/js/app.ee5f559fd6bd51fedb14.js